import { Component, Input, ɵɵdefineInjectable, ɵɵinject, Injectable, EventEmitter, ViewChild, Output, Inject, NgModule, ChangeDetectorRef, ElementRef } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, debounceTime } from 'rxjs/operators';
import { Router, RouterModule } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { DatePipe, CommonModule } from '@angular/common';
import { Subject, throwError, Subscription } from 'rxjs';
import * as moment_ from 'moment';
import { isNullOrUndefined } from 'util';
import { AgmOverlays } from 'agm-overlays';
import { NgbActiveModal, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { __awaiter } from 'tslib';
import { SphericalUtil } from 'node-geometry-library';
import { EventStreamLibModule } from 'ng-alto-event-stream-lib';
import { TableModule } from 'primeng/table';
import { CalendarModule } from 'primeng/calendar';
import { SliderModule } from 'primeng/slider';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContextMenuModule } from 'primeng/contextmenu';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { DropdownModule } from 'primeng/dropdown';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@agm/core';
import * as ɵngcc2 from '@angular/common/http';
import * as ɵngcc3 from '@angular/router';
import * as ɵngcc4 from '@ngx-translate/core';
import * as ɵngcc5 from '@angular/common';
import * as ɵngcc6 from 'primeng/table';
import * as ɵngcc7 from 'primeng/api';
import * as ɵngcc8 from 'primeng/dropdown';
import * as ɵngcc9 from '@angular/forms';
import * as ɵngcc10 from 'primeng/inputtext';
import * as ɵngcc11 from 'ngx-daterangepicker-material';
import * as ɵngcc12 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc13 from '@ng-select/ng-select';

const _c0 = ["file_input_upload"];
const _c1 = function (a0, a1, a2) { return { "alert-msg--danger": a0, "alert-msg--success": a1, "isVisible": a2 }; };
const _c2 = ["dt"];
function TableConfigurableComponent_ng_template_2_th_1_p_sortIcon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "p-sortIcon", 9);
} if (rf & 2) {
    const col_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("field", col_r6.field);
} }
const _c3 = function (a0) { return { "width": a0 }; };
function TableConfigurableComponent_ng_template_2_th_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵtemplate(3, TableConfigurableComponent_ng_template_2_th_1_p_sortIcon_3_Template, 1, 1, "p-sortIcon", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r6 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("pSortableColumn", col_r6)("pSortableColumnDisabled", col_r6.sort == false)("ngStyle", ɵngcc0.ɵɵpureFunction1(7, _c3, col_r6.width));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", col_r6.header != "" ? ɵngcc0.ɵɵpipeBind1(2, 5, "trip." + col_r6.header) : "", " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", col_r6.sort != false);
} }
function TableConfigurableComponent_ng_template_2_th_3_p_dropdown_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r16 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "trip." + item_r16.label));
} }
function TableConfigurableComponent_ng_template_2_th_3_p_dropdown_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r17 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "trip." + option_r17.label));
} }
function TableConfigurableComponent_ng_template_2_th_3_p_dropdown_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-dropdown", 14);
    ɵngcc0.ɵɵlistener("ngModelChange", function TableConfigurableComponent_ng_template_2_th_3_p_dropdown_1_Template_p_dropdown_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const col_r9 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return (ctx_r18.filters_value[col_r9.field] = $event); })("onChange", function TableConfigurableComponent_ng_template_2_th_3_p_dropdown_1_Template_p_dropdown_onChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const col_r9 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.inputsFilter($event.value, col_r9.field, "dropDown", null); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵtemplate(2, TableConfigurableComponent_ng_template_2_th_3_p_dropdown_1_ng_template_2_Template, 3, 3, "ng-template", 15);
    ɵngcc0.ɵɵtemplate(3, TableConfigurableComponent_ng_template_2_th_3_p_dropdown_1_ng_template_3_Template, 3, 3, "ng-template", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r9 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ɵngcc0.ɵɵpipeBind1(1, 4, "trip.placeholder_dropdown"));
    ɵngcc0.ɵɵproperty("options", col_r9.options)("ngModel", ctx_r10.filters_value[col_r9.field])("showClear", true);
} }
function TableConfigurableComponent_ng_template_2_th_3_input_2_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function TableConfigurableComponent_ng_template_2_th_3_input_2_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const col_r9 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return (ctx_r24.filters_value[col_r9.field] = $event); })("input", function TableConfigurableComponent_ng_template_2_th_3_input_2_Template_input_input_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const col_r9 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ctx_r27.inputsFilter($event.target.value, col_r9.field, "inputText", col_r9.array_field_return); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r9 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate2("placeholder", "", ɵngcc0.ɵɵpipeBind1(1, 3, "trip.placeholder_input_text"), " ", ɵngcc0.ɵɵpipeBind1(2, 5, "trip." + col_r9.header), "");
    ɵngcc0.ɵɵproperty("ngModel", ctx_r11.filters_value[col_r9.field]);
} }
function TableConfigurableComponent_ng_template_2_th_3_input_3_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function TableConfigurableComponent_ng_template_2_th_3_input_3_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r31); const col_r9 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r30 = ɵngcc0.ɵɵnextContext(2); return (ctx_r30.filters_value[col_r9.field] = $event); })("input", function TableConfigurableComponent_ng_template_2_th_3_input_3_Template_input_input_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r31); const col_r9 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r33 = ɵngcc0.ɵɵnextContext(2); return ctx_r33.inputsFilter($event.target.value, col_r9.field, "inputTextNumber", null); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r9 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate2("placeholder", "", ɵngcc0.ɵɵpipeBind1(1, 3, "trip.placeholder_input_text"), " ", ɵngcc0.ɵɵpipeBind1(2, 5, "trip." + col_r9.header), "");
    ɵngcc0.ɵɵproperty("ngModel", ctx_r12.filters_value[col_r9.field]);
} }
function TableConfigurableComponent_ng_template_2_th_3_div_4_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r38 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 21);
    ɵngcc0.ɵɵlistener("click", function TableConfigurableComponent_ng_template_2_th_3_div_4_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r38); const col_r9 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r37 = ɵngcc0.ɵɵnextContext(2); return (ctx_r37.filters_value[col_r9.field] = ""); });
    ɵngcc0.ɵɵelement(1, "i", 22);
    ɵngcc0.ɵɵelementEnd();
} }
function TableConfigurableComponent_ng_template_2_th_3_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r42 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "input", 19);
    ɵngcc0.ɵɵlistener("datesUpdated", function TableConfigurableComponent_ng_template_2_th_3_div_4_Template_input_datesUpdated_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r42); const col_r9 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r40 = ɵngcc0.ɵɵnextContext(2); return ctx_r40.inputsFilter($event, col_r9.field, "calendar", null); })("ngModelChange", function TableConfigurableComponent_ng_template_2_th_3_div_4_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r42); const col_r9 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r43 = ɵngcc0.ɵɵnextContext(2); return (ctx_r43.filters_value[col_r9.field] = $event); })("ngModelChange", function TableConfigurableComponent_ng_template_2_th_3_div_4_Template_input_ngModelChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r42); const col_r9 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r45 = ɵngcc0.ɵɵnextContext(2); return ctx_r45.setDefaultValueCalendar("calendar", col_r9.default_value, col_r9.field); });
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, TableConfigurableComponent_ng_template_2_th_3_div_4_button_3_Template, 2, 0, "button", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r9 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ɵngcc0.ɵɵpipeBind1(2, 8, "trip.placeholder_calendar"));
    ɵngcc0.ɵɵproperty("ngModel", ctx_r13.filters_value[col_r9.field])("autoApply", true)("closeOnAutoApply", true)("showClearButton", true)("readonly", true)("locale", ctx_r13.locale_date);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r13.filters_value[col_r9.field] && ctx_r13.filters_value[col_r9.field].startDate && ctx_r13.filters_value[col_r9.field].endDate);
} }
function TableConfigurableComponent_ng_template_2_th_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 10);
    ɵngcc0.ɵɵtemplate(1, TableConfigurableComponent_ng_template_2_th_3_p_dropdown_1_Template, 4, 6, "p-dropdown", 11);
    ɵngcc0.ɵɵtemplate(2, TableConfigurableComponent_ng_template_2_th_3_input_2_Template, 3, 7, "input", 12);
    ɵngcc0.ɵɵtemplate(3, TableConfigurableComponent_ng_template_2_th_3_input_3_Template, 3, 7, "input", 12);
    ɵngcc0.ɵɵtemplate(4, TableConfigurableComponent_ng_template_2_th_3_div_4_Template, 4, 10, "div", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r9 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngSwitch", col_r9.filter);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "dropDown");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "inputText");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "inputTextNumber");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "calendar");
} }
function TableConfigurableComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵtemplate(1, TableConfigurableComponent_ng_template_2_th_1_Template, 4, 9, "th", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "tr");
    ɵngcc0.ɵɵtemplate(3, TableConfigurableComponent_ng_template_2_th_3_Template, 5, 5, "th", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.config_cols);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.config_cols);
} }
function TableConfigurableComponent_ng_template_3_tr_0_td_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r51 = ɵngcc0.ɵɵnextContext().$implicit;
    const item_r48 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r52 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r52.NestedData(item_r48, col_r51.field) != "undefined" && ctx_r52.NestedData(item_r48, col_r51.field) != "null" ? ctx_r52.NestedData(item_r48, col_r51.field) : "", " ");
} }
function TableConfigurableComponent_ng_template_3_tr_0_td_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r51 = ɵngcc0.ɵɵnextContext().$implicit;
    const item_r48 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r53 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r53.NestedData(item_r48, col_r51.field) != "undefined" && ctx_r53.NestedData(item_r48, col_r51.field) != "null" && ctx_r53.NestedData(item_r48, col_r51.field) != "" ? ɵngcc0.ɵɵpipeBind1(2, 1, "trip." + ctx_r53.NestedData(item_r48, col_r51.field)) : "", " ");
} }
function TableConfigurableComponent_ng_template_3_tr_0_td_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r51 = ɵngcc0.ɵɵnextContext().$implicit;
    const item_r48 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r54 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r54.dateTimeFormat(ctx_r54.NestedData(item_r48, col_r51.field), col_r51.format), " ");
} }
function TableConfigurableComponent_ng_template_3_tr_0_td_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r51 = ɵngcc0.ɵɵnextContext().$implicit;
    const item_r48 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r55 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r55.getArrayData(ctx_r55.NestedData(item_r48, col_r51.array), col_r51.array_field), " ");
} }
function TableConfigurableComponent_ng_template_3_tr_0_td_1_div_5_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "small", 30);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const cda_r70 = ctx.$implicit;
    const col_r51 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r69 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", cda_r70.place_name, ": ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r69.dateTimeFormat(cda_r70.departure, col_r51.format), " - ", ctx_r69.dateTimeFormat(cda_r70.arrival, col_r51.format), "");
} }
function TableConfigurableComponent_ng_template_3_tr_0_td_1_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "ul");
    ɵngcc0.ɵɵtemplate(2, TableConfigurableComponent_ng_template_3_tr_0_td_1_div_5_li_2_Template, 4, 3, "li", 29);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r48 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", item_r48 == null ? null : item_r48.$client_departure_arrival_date);
} }
function TableConfigurableComponent_ng_template_3_tr_0_td_1_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r51 = ɵngcc0.ɵɵnextContext().$implicit;
    const item_r48 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r57 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r57.getArrayData2(ctx_r57.NestedData(item_r48, col_r51.array), col_r51.array_field_2), " ");
} }
function TableConfigurableComponent_ng_template_3_tr_0_td_1_a_7_Template(rf, ctx) { if (rf & 1) {
    const _r77 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 31);
    ɵngcc0.ɵɵlistener("click", function TableConfigurableComponent_ng_template_3_tr_0_td_1_a_7_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r77); const col_r51 = ɵngcc0.ɵɵnextContext().$implicit; const item_r48 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r75 = ɵngcc0.ɵɵnextContext(); return ctx_r75.goToDetail(ctx_r75.NestedData(item_r48, col_r51.field), col_r51.url); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r51 = ɵngcc0.ɵɵnextContext().$implicit;
    const item_r48 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r58 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r58.NestedData(item_r48, col_r51.field), " ");
} }
function TableConfigurableComponent_ng_template_3_tr_0_td_1_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span");
} if (rf & 2) {
    const col_r51 = ɵngcc0.ɵɵnextContext().$implicit;
    const item_r48 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r59 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("badge ", ctx_r59.NestedData(item_r48, col_r51.field) == true ? "badge-indicator-success" : "badge-indicator-danger", " ");
} }
function TableConfigurableComponent_ng_template_3_tr_0_td_1_div_9_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r88 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 35);
    ɵngcc0.ɵɵlistener("click", function TableConfigurableComponent_ng_template_3_tr_0_td_1_div_9_div_1_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r88); const btn_r84 = ɵngcc0.ɵɵnextContext().$implicit; const col_r51 = ɵngcc0.ɵɵnextContext(2).$implicit; const item_r48 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r86 = ɵngcc0.ɵɵnextContext(); return ctx_r86.btnFunctions(ctx_r86.NestedData(item_r48, col_r51.field), btn_r84.action); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵelementStart(2, "p", 36);
    ɵngcc0.ɵɵelement(3, "i");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r84 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵpropertyInterpolate("ngbTooltip", ɵngcc0.ɵɵpipeBind1(1, 4, "trip." + btn_r84.tooltip));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵclassMapInterpolate1("fa ", btn_r84.icon, "");
} }
function TableConfigurableComponent_ng_template_3_tr_0_td_1_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 33);
    ɵngcc0.ɵɵtemplate(1, TableConfigurableComponent_ng_template_3_tr_0_td_1_div_9_div_1_div_1_Template, 4, 6, "div", 34);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const btn_r84 = ctx.$implicit;
    const item_r48 = ɵngcc0.ɵɵnextContext(4).$implicit;
    const ctx_r83 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", btn_r84.condition ? ctx_r83.btnConditions(item_r48, btn_r84.field_cond, btn_r84.value_cond) : true);
} }
function TableConfigurableComponent_ng_template_3_tr_0_td_1_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, TableConfigurableComponent_ng_template_3_tr_0_td_1_div_9_div_1_Template, 2, 1, "div", 32);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r51 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", col_r51.buttons);
} }
function TableConfigurableComponent_ng_template_3_tr_0_td_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 25);
    ɵngcc0.ɵɵtemplate(1, TableConfigurableComponent_ng_template_3_tr_0_td_1_div_1_Template, 2, 1, "div", 26);
    ɵngcc0.ɵɵtemplate(2, TableConfigurableComponent_ng_template_3_tr_0_td_1_div_2_Template, 3, 3, "div", 26);
    ɵngcc0.ɵɵtemplate(3, TableConfigurableComponent_ng_template_3_tr_0_td_1_div_3_Template, 2, 1, "div", 26);
    ɵngcc0.ɵɵtemplate(4, TableConfigurableComponent_ng_template_3_tr_0_td_1_div_4_Template, 2, 1, "div", 26);
    ɵngcc0.ɵɵtemplate(5, TableConfigurableComponent_ng_template_3_tr_0_td_1_div_5_Template, 3, 1, "div", 26);
    ɵngcc0.ɵɵtemplate(6, TableConfigurableComponent_ng_template_3_tr_0_td_1_div_6_Template, 2, 1, "div", 26);
    ɵngcc0.ɵɵtemplate(7, TableConfigurableComponent_ng_template_3_tr_0_td_1_a_7_Template, 2, 1, "a", 27);
    ɵngcc0.ɵɵtemplate(8, TableConfigurableComponent_ng_template_3_tr_0_td_1_span_8_Template, 1, 3, "span", 28);
    ɵngcc0.ɵɵtemplate(9, TableConfigurableComponent_ng_template_3_tr_0_td_1_div_9_Template, 2, 1, "div", 26);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r51 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngSwitch", col_r51.body);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "text");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "text-translate");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "text-calendar");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "text-array");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "client-departure-arrival-array");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "text-array-2");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "link");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "indicator");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "buttons");
} }
function TableConfigurableComponent_ng_template_3_tr_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵtemplate(1, TableConfigurableComponent_ng_template_3_tr_0_td_1_Template, 10, 10, "td", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r49 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r49.config_cols);
} }
function TableConfigurableComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, TableConfigurableComponent_ng_template_3_tr_0_Template, 2, 1, "tr", 23);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.loading);
} }
function TableConfigurableComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td", 37);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.loading ? "" : ɵngcc0.ɵɵpipeBind1(3, 1, "trip.empty_message"));
} }
function MapRealtimeComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵelement(1, "div", 17);
    ɵngcc0.ɵɵelementStart(2, "span", 18);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.item;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", item_r2.style);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r2.id);
} }
function MapRealtimeComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵelement(1, "div", 17);
    ɵngcc0.ɵɵelementStart(2, "span", 18);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.item;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", item_r3.style);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r3.id);
} }
const _c4 = function (a0, a1) { return { "map-toolbox-button-active": a0, "map-toolbox-button-hidden": a1 }; };
const _c5 = function (a0) { return { "map-toolbox-button-active": a0 }; };
const _c6 = function (a0, a1, a2) { return { "map-toolbox-button-active": a0, "map-toolbox-button-route": a1, "map-toolbox-button-route-dots": a2 }; };
const _c7 = function (a0) { return { "loading-screen-hide": a0 }; };
function MessageErrorComponent_h2_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h2", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0._title);
} }
function MessageErrorComponent_h2_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h2", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r1._title));
} }
function MessageErrorComponent_p_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2._sub_title);
} }
function MessageErrorComponent_p_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3._message);
} }
function MessageErrorComponent_p_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r4._sub_title));
} }
function MessageErrorComponent_p_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r5._message));
} }
function MessageErrorComponent_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 11);
    ɵngcc0.ɵɵlistener("click", function MessageErrorComponent_button_13_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.cancel(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.textCancelButton);
} }
function MessageErrorComponent_button_14_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 11);
    ɵngcc0.ɵɵlistener("click", function MessageErrorComponent_button_14_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.cancel(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r7.textCancelButton));
} }
function MessageErrorComponent_button_15_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 12);
    ɵngcc0.ɵɵlistener("click", function MessageErrorComponent_button_15_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.save(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8.textOkButton);
} }
function MessageErrorComponent_button_16_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 12);
    ɵngcc0.ɵɵlistener("click", function MessageErrorComponent_button_16_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.save(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r9.textOkButton));
} }
const _c8 = ["map_tools"];
const _c9 = ["select_signals"];
const _c10 = ["time_signals"];
function TrackGoogleMapComponent_option_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const signal_r7 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", signal_r7.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(signal_r7.id);
} }
const _c11 = function (a0) { return { "background-color": a0 }; };
function TrackGoogleMapComponent_option_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 25);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const gps_r8 = ctx.$implicit;
    const i_r9 = ctx.index;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngValue", gps_r8.gps_id)("ngStyle", ɵngcc0.ɵɵpureFunction1(3, _c11, ctx_r3.coloresHexadecimales.colores[i_r9]));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", gps_r8.gps_id, " ");
} }
function TrackGoogleMapComponent_span_25_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0");
    ɵngcc0.ɵɵelementEnd();
} }
function TrackGoogleMapComponent_span_26_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 26);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.MostrarZonasElegidas(), " ");
} }
function TrackGoogleMapComponent_div_28_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "input", 30);
    ɵngcc0.ɵɵlistener("ngModelChange", function TrackGoogleMapComponent_div_28_div_1_div_1_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const a_r11 = ɵngcc0.ɵɵnextContext().$implicit; return a_r11.checked = $event; })("change", function TrackGoogleMapComponent_div_28_div_1_div_1_Template_input_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r16); const a_r11 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.getSelectedValue(a_r11); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const a_r11 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", a_r11.checked);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\u00A0", a_r11.name, "");
} }
function TrackGoogleMapComponent_div_28_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵtemplate(1, TrackGoogleMapComponent_div_28_div_1_div_1_Template, 3, 2, "div", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const a_r11 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", a_r11.name != "Cliente");
} }
function TrackGoogleMapComponent_div_28_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 27);
    ɵngcc0.ɵɵtemplate(1, TrackGoogleMapComponent_div_28_div_1_Template, 2, 1, "div", 28);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.list);
} }
class BaseGoogleMapComponent {
    constructor() {
        this.center = { lat: -33.469086, lng: -70.63889 };
        this.eventHandlers = {};
        this.eventDispath = function (type, data) {
            var eventHandlers = this.eventHandlers[type];
            if (eventHandlers) {
                for (var handler of eventHandlers) {
                    handler({ type: type, data: data });
                }
            }
        };
    }
    ngOnInit() {
    }
    addEventHandler(type, eventHandler) {
        var eventHandlers = this.eventHandlers[type] || [];
        if (typeof eventHandler === 'function') {
            if (eventHandlers.indexOf(eventHandler) < 0) {
                eventHandlers.push(eventHandler);
            }
        }
        else if (Array.isArray(eventHandler)) {
            for (var i in eventHandler) {
                var handler = eventHandler[i];
                if (typeof handler === 'function' && eventHandlers.indexOf(handler) < 0) {
                    eventHandlers.push(handler);
                }
            }
        }
        this.eventHandlers[type] = eventHandlers;
    }
    onMapReady(map) {
        this.map = map;
        this.map_bounds = new google.maps.LatLngBounds();
        var myStyle = [
            {
                featureType: "administrative",
                elementType: "labels",
                stylers: [
                    { visibility: "off" }
                ]
            }, {
                featureType: "poi",
                elementType: "labels",
                stylers: [
                    { visibility: "off" }
                ]
            }, {
                featureType: "water",
                elementType: "labels",
                stylers: [
                    { visibility: "off" }
                ]
            }, {
                featureType: "road",
                elementType: "labels",
                stylers: [
                    { visibility: "off" }
                ]
            }, {
                featureType: "transit",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            }
        ];
        this.map.mapTypes.set('simple', new google.maps.StyledMapType(myStyle, { name: 'Simple' }));
        this.map.setOptions({
            center: this.center,
            mapTypeControl: true,
            mapTypeControlOptions: {
                mapTypeIds: ['roadmap', 'simple', 'terrain', 'satellite']
                //style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
            },
            mapTypeId: 'roadmap',
            scaleControl: true,
            scaleControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            },
            streetViewControl: true,
            rotateControl: true,
            fullscreenControl: true,
            fullscreenControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            },
            maxZoom: 20,
            minZoom: 2,
            zoom: 18,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            }
        });
        //function style geoJson on map
        this.map.data.setStyle(function (feature) {
            var color = feature.getProperty('color');
            return {
                fillColor: color,
                strokeWeight: 1
            };
        });
        console.log('MapReady');
        this.eventDispath(BaseGoogleMapComponent.Events.MapReady, {});
    }
    showMapTypeControl(val) {
        this.map.setOptions({ mapTypeControl: val });
    }
    addMarker(options) {
        if (options) {
            var opt = {
                position: this.center,
                map: this.map,
                title: '',
                zoom: 16,
            };
            Object.assign(opt, options);
            var marker = new google.maps.Marker(opt);
            if (options['center'] === true) {
                this.map.setOptions({ center: opt['position'], zoom: opt['zoom'] });
            }
        }
        return marker;
    }
    addSvgMarker(options) {
        if (options) {
            var opt = {
                position: this.center,
                map: this.map,
                title: '',
                zoom: 16,
            };
            Object.assign(opt, options);
            var latLng = new google.maps.LatLng(opt['position'].lat, opt['position'].lng);
            var marker = google_map_extends.SvgMarker({
                latlng: latLng,
                map: this.map,
                draggable: false,
                src: opt['src'],
                style: opt['style']
            });
            if (options['center'] === true) {
                this.map.setOptions({ center: opt['position'], zoom: opt['zoom'] });
            }
        }
        return marker;
    }
}
BaseGoogleMapComponent.ɵfac = function BaseGoogleMapComponent_Factory(t) { return new (t || BaseGoogleMapComponent)(); };
BaseGoogleMapComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BaseGoogleMapComponent, selectors: [["com-lib-base-google-map"]], inputs: { center: "center" }, decls: 1, vars: 0, consts: [[3, "mapReady"]], template: function BaseGoogleMapComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "agm-map", 0);
        ɵngcc0.ɵɵlistener("mapReady", function BaseGoogleMapComponent_Template_agm_map_mapReady_0_listener($event) { return ctx.onMapReady($event); });
        ɵngcc0.ɵɵelementEnd();
    } }, directives: [ɵngcc1.AgmMap], styles: ["agm-map[_ngcontent-%COMP%]{height:100%;width:100%}"] });
BaseGoogleMapComponent.Events = {
    MapReady: 'base.google.map.MapReady'
};
BaseGoogleMapComponent.ctorParameters = () => [];
BaseGoogleMapComponent.propDecorators = {
    center: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BaseGoogleMapComponent, [{
        type: Component,
        args: [{
                selector: 'com-lib-base-google-map',
                template: "<agm-map (mapReady)=\"onMapReady($event)\" >\n</agm-map>",
                styles: ["agm-map{height:100%;width:100%}"]
            }]
    }], function () { return []; }, { center: [{
            type: Input
        }] }); })();

class DialogComponent {
    constructor() { }
    ngOnInit() {
    }
}
DialogComponent.ɵfac = function DialogComponent_Factory(t) { return new (t || DialogComponent)(); };
DialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DialogComponent, selectors: [["com-lib-dialog"]], decls: 16, vars: 0, consts: [["id", "exampleModalCenter", "tabindex", "-1", "role", "dialog", "aria-labelledby", "exampleModalCenterTitle", "aria-hidden", "true", 1, "modal", "fade"], ["role", "document", 1, "modal-dialog", "modal-dialog-centered"], [1, "modal-content"], [1, "modal-header"], ["id", "exampleModalLongTitle", 1, "modal-title"], ["type", "button", "data-dismiss", "modal", "aria-label", "Close", 1, "close"], ["aria-hidden", "true"], [1, "modal-body"], [1, "modal-footer"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary"], ["type", "button", 1, "btn", "btn-primary"]], template: function DialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "h5", 4);
        ɵngcc0.ɵɵtext(5, "Modal title");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "button", 5);
        ɵngcc0.ɵɵelementStart(7, "span", 6);
        ɵngcc0.ɵɵtext(8, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵtext(10, " ... ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 8);
        ɵngcc0.ɵɵelementStart(12, "button", 9);
        ɵngcc0.ɵɵtext(13, "Close");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "button", 10);
        ɵngcc0.ɵɵtext(15, "Save changes");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
DialogComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogComponent, [{
        type: Component,
        args: [{
                selector: 'com-lib-dialog',
                template: "<!-- Modal -->\n<div class=\"modal fade\" id=\"exampleModalCenter\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"exampleModalCenterTitle\" aria-hidden=\"true\">\n    <div class=\"modal-dialog modal-dialog-centered\" role=\"document\">\n      <div class=\"modal-content\">\n        <div class=\"modal-header\">\n          <h5 class=\"modal-title\" id=\"exampleModalLongTitle\">Modal title</h5>\n          <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n            <span aria-hidden=\"true\">&times;</span>\n          </button>\n        </div>\n        <div class=\"modal-body\">\n          ...\n        </div>\n        <div class=\"modal-footer\">\n          <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\">Close</button>\n          <button type=\"button\" class=\"btn btn-primary\">Save changes</button>\n        </div>\n      </div>\n    </div>\n  </div>",
                styles: [""]
            }]
    }], function () { return []; }, null); })();

class ServiceFile {
    constructor(http) {
        this.http = http;
        this.conf = {};
    }
    setConf(conf) {
        this.conf = conf;
    }
    upload(uploadedFiles) {
        let formData = new FormData();
        for (var i = 0; i < uploadedFiles.length; i++) {
            formData.append("formFile", uploadedFiles[i], uploadedFiles[i].name);
        }
        return this.http.post(this.conf['uploadUrl'], formData, {
            reportProgress: true,
            observe: 'events'
        });
    }
    errorHadler(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        }
        else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return error;
    }
}
ServiceFile.ɵfac = function ServiceFile_Factory(t) { return new (t || ServiceFile)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient)); };
ServiceFile.ɵprov = ɵɵdefineInjectable({ factory: function ServiceFile_Factory() { return new ServiceFile(ɵɵinject(HttpClient)); }, token: ServiceFile, providedIn: "root" });
ServiceFile.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServiceFile, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.HttpClient }]; }, null); })();

class FileUploaderEvent {
    constructor() {
        this.ok = true;
        this.message = '';
        this.errors = [];
    }
}

class FileUploaderComponent {
    constructor(serviceFile) {
        this.serviceFile = serviceFile;
        this.upload_message = 'Select File';
        this.upload_message_error = 'Error Uploading File:';
        this.upload_message_success = 'File successfully created!';
        this.upload_btn_txt = 'Upload';
        this.upload_url = '/';
        this.upload_accept = '*';
        this.onComplete = new EventEmitter();
        this.onFileUpload = new EventEmitter();
        this.result = new FileUploaderEvent();
        this.progress = 0;
    }
    ngOnInit() {
        // this.serviceFile.setConf({uploadUrl:this.upload_url})
    }
    onUpload(evt) {
        //console.log(evt)
        let el = this.inputFile.nativeElement;
        el.value = '';
        el.click();
    }
    onFileSelected(element) {
        this.progress = 0;
        this.uploadedFiles = element.target.files;
        let ext = this.getFileExt(this.uploadedFiles);
        this.onFileUpload.emit(ext);
        // this.serviceFile.setConf({uploadUrl:this.upload_url})
    }
    getFileExt(elementList) {
        for (var i = 0; i < elementList.length; i++) {
            return elementList[i].name.split('.').pop();
        }
    }
    ngOnChanges(changes) {
        if (changes && changes.upload_url) {
            this.serviceFile.setConf({ uploadUrl: this.upload_url });
            this.serviceFile.upload(this.uploadedFiles).
                pipe(catchError((err) => {
                console.log(err);
                let err_message = '';
                //alert(this. upload_message_error+' '+err.error.message);
                this.progress = 0;
                this.result.ok = false;
                this.result.message = err.error.message ? err.error.message : err.message;
                this.result.errors = err.error.errors ? err.error.errors : [];
                this.onComplete.emit(this.result);
                throw err;
            })).subscribe((event) => {
                switch (event.type) {
                    case HttpEventType.Sent:
                        //console.log('Request has been made!');
                        break;
                    case HttpEventType.ResponseHeader:
                        //console.log('Response header has been received!');
                        break;
                    case HttpEventType.UploadProgress:
                        this.progress = Math.round(event.loaded / event.total * 100);
                        //console.log(`Uploaded! ${this.progress}%`);
                        break;
                    case HttpEventType.Response:
                        //console.log('User successfully created!', event.body);
                        setTimeout(() => {
                            //alert(this.upload_message_success)
                            this.result.ok = true;
                            this.result.message = this.upload_message_success;
                            this.onComplete.emit(this.result);
                        }, 1000);
                        break;
                    default:
                    //console.log(event)
                }
            });
        }
    }
}
FileUploaderComponent.ɵfac = function FileUploaderComponent_Factory(t) { return new (t || FileUploaderComponent)(ɵngcc0.ɵɵdirectiveInject(ServiceFile)); };
FileUploaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FileUploaderComponent, selectors: [["com-lib-file-uploader"]], viewQuery: function FileUploaderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputFile = _t.first);
    } }, inputs: { upload_message: "upload_message", upload_message_error: "upload_message_error", upload_message_success: "upload_message_success", upload_btn_txt: "upload_btn_txt", upload_url: "upload_url", upload_accept: "upload_accept" }, outputs: { onComplete: "onComplete", onFileUpload: "onFileUpload" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 11, vars: 5, consts: [[1, "upload-file"], [1, "upload-file-box"], [1, "upload_messge"], ["type", "file", "name", "file_input_upload", "id", "file_input_upload", 2, "display", "none", 3, "accept", "change"], ["file_input_upload", ""], [1, "btn", "btn-block", "btn-primary", "mb-2", "fs-15", 2, "color", "white", 3, "click"], ["src", "/assets/icons/upload.svg", 1, "upload_btn_icon"], [1, "upload-file-progress"], ["role", "progressbar", 1, "progress-bar", "progress-bar-striped", "bg-success"]], template: function FileUploaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "input", 3, 4);
        ɵngcc0.ɵɵlistener("change", function FileUploaderComponent_Template_input_change_4_listener($event) { return ctx.onFileSelected($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "a", 5);
        ɵngcc0.ɵɵlistener("click", function FileUploaderComponent_Template_a_click_6_listener($event) { return ctx.onUpload($event); });
        ɵngcc0.ɵɵelement(7, "img", 6);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵelement(10, "div", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.upload_message);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("accept", ctx.upload_accept);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.upload_btn_txt, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("width", ctx.progress, "%");
    } }, styles: [".upload-file[_ngcontent-%COMP%]{display:inline-flex;flex-direction:column;border:none;padding:4px;margin:1px;height:47px}.upload-file-box[_ngcontent-%COMP%]{height:34px}.btn[_ngcontent-%COMP%], .upload-file-box[_ngcontent-%COMP%]{display:inline-flex;flex-direction:row}.btn[_ngcontent-%COMP%]{width:auto;line-height:15px;padding:3px 12px 0 3px;color:#fff}.upload_btn_icon[_ngcontent-%COMP%]{width:19px;height:20px;margin:-3px 9px 0 4px}.upload_messge[_ngcontent-%COMP%]{margin-right:10px;color:#4990e2}.upload-file-progress[_ngcontent-%COMP%]{background:#ccc}.progress-bar[_ngcontent-%COMP%]{height:3px}.upload-icon[_ngcontent-%COMP%]{fill:green!important}"] });
FileUploaderComponent.ctorParameters = () => [
    { type: ServiceFile }
];
FileUploaderComponent.propDecorators = {
    inputFile: [{ type: ViewChild, args: ['file_input_upload', { static: false },] }],
    upload_message: [{ type: Input }],
    upload_message_error: [{ type: Input }],
    upload_message_success: [{ type: Input }],
    upload_btn_txt: [{ type: Input }],
    upload_url: [{ type: Input }],
    upload_accept: [{ type: Input }],
    onComplete: [{ type: Output }],
    onFileUpload: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FileUploaderComponent, [{
        type: Component,
        args: [{
                selector: 'com-lib-file-uploader',
                template: "<!--form  action=\"{{upload_acction}}\" method=\"post\" enctype=\"multipart/form-data\" -->\n<div class=\"upload-file\">\n    <div class=\"upload-file-box\">\n        <span class=\"upload_messge\">{{upload_message}}</span>\n        <input type=\"file\" name=\"file_input_upload\" id=\"file_input_upload\" #file_input_upload style=\"display:none\" (change)=\"onFileSelected($event)\" accept=\"{{upload_accept}}\">\n        <a class=\"btn btn-block btn-primary mb-2 fs-15\" (click)=\"onUpload($event)\" style=\"color: white;\">\n            <img class=\"upload_btn_icon\" src=\"/assets/icons/upload.svg\" />\n            {{upload_btn_txt}}\n        </a>\n    </div>\n     <!-- Progress Bar -->\n     <!-- <div class=\"progress form-group\" *ngIf=\"progress > 0\"> -->\n    <div class=\"upload-file-progress\" >\n        <div class=\"progress-bar progress-bar-striped bg-success\" role=\"progressbar\" [style.width.%]=\"progress\">\n        </div>\n    </div>\n</div>\n<!--/form-->\n",
                styles: [".upload-file{display:inline-flex;flex-direction:column;border:none;padding:4px;margin:1px;height:47px}.upload-file-box{height:34px}.btn,.upload-file-box{display:inline-flex;flex-direction:row}.btn{width:auto;line-height:15px;padding:3px 12px 0 3px;color:#fff}.upload_btn_icon{width:19px;height:20px;margin:-3px 9px 0 4px}.upload_messge{margin-right:10px;color:#4990e2}.upload-file-progress{background:#ccc}.progress-bar{height:3px}.upload-icon{fill:green!important}"]
            }]
    }], function () { return [{ type: ServiceFile }]; }, { upload_message: [{
            type: Input
        }], upload_message_error: [{
            type: Input
        }], upload_message_success: [{
            type: Input
        }], upload_btn_txt: [{
            type: Input
        }], upload_url: [{
            type: Input
        }], upload_accept: [{
            type: Input
        }], onComplete: [{
            type: Output
        }], onFileUpload: [{
            type: Output
        }], inputFile: [{
            type: ViewChild,
            args: ['file_input_upload', { static: false }]
        }] }); })();

class MessageBarService {
    constructor() {
        this.requerid = new EventEmitter();
        this.message = undefined;
    }
    /**
     * Check if the service has been called
     */
    static getInstance() {
        if (MessageBarService.instance == null) {
            MessageBarService.isCreating = true;
            MessageBarService.instance = new MessageBarService();
            MessageBarService.isCreating = false;
        }
        return MessageBarService.instance;
    }
    setMessage(message) {
        this.message = message;
    }
    getMessage() {
        return this.message;
    }
    validatedRequerid(form) {
        let result = [];
        Object.keys(form.controls).forEach(key => {
            const controlErrors = form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    if (keyError == 'required') {
                        let error = {
                            key_control: key,
                            key_error: keyError,
                            err_value: controlErrors[keyError]
                        };
                        result.push(error);
                    }
                    console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
                });
            }
        });
        return result;
    }
    getRequerid() {
        return this.requerid;
    }
}
MessageBarService.ɵfac = function MessageBarService_Factory(t) { return new (t || MessageBarService)(); };
MessageBarService.instance = null;
MessageBarService.isCreating = false;
MessageBarService.ɵprov = ɵɵdefineInjectable({ factory: function MessageBarService_Factory() { return new MessageBarService(); }, token: MessageBarService, providedIn: "root" });
MessageBarService.ctorParameters = () => [];
MessageBarService.propDecorators = {
    requerid: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MessageBarService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, { requerid: [{
            type: Output
        }] }); })();

class MessageBarComponent {
    constructor(messageBarService, router, translate) {
        this.messageBarService = messageBarService;
        this.router = router;
        this.translate = translate;
        this.type = 'success';
        this.endMessage = new EventEmitter();
        this.message = undefined;
        this.messageBarService = MessageBarService.getInstance();
        if (this.messageBarService.getMessage() != undefined) {
            this.showmessage(this.messageBarService.getMessage());
        }
        else {
            this.message = undefined;
        }
    }
    set viewMessage(value) {
        if (value == undefined) {
            this.message = value;
        }
        else {
            this.showmessage(value);
        }
    }
    ngOnInit() {
    }
    /**
     * Show message in the current view
     * @param message
     */
    showmessage(message) {
        this.message = message;
        this.messageBarService.message = undefined;
        setTimeout(() => {
            let div = document.getElementById("divMessage");
            div.classList.remove('isVisible');
            this.message = undefined;
            this.endMessage.emit('');
        }, 4000);
    }
}
MessageBarComponent.ɵfac = function MessageBarComponent_Factory(t) { return new (t || MessageBarComponent)(ɵngcc0.ɵɵdirectiveInject(MessageBarService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.TranslateService)); };
MessageBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MessageBarComponent, selectors: [["com-lib-message-bar"]], inputs: { type: "type", viewMessage: "viewMessage" }, outputs: { endMessage: "endMessage" }, decls: 4, vars: 8, consts: [["id", "divMessage", 1, "alert-msg", 3, "ngClass"], [1, "alert-msg__text"]], template: function MessageBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "p", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(4, _c1, ctx.type == "danger", ctx.type == "success", ctx.message));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, ctx.message));
    } }, directives: [ɵngcc5.NgClass], pipes: [ɵngcc4.TranslatePipe], styles: [""] });
MessageBarComponent.ctorParameters = () => [
    { type: MessageBarService },
    { type: Router },
    { type: TranslateService }
];
MessageBarComponent.propDecorators = {
    viewMessage: [{ type: Input }],
    type: [{ type: Input }],
    endMessage: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MessageBarComponent, [{
        type: Component,
        args: [{
                selector: 'com-lib-message-bar',
                template: "<div id=\"divMessage\" class=\"alert-msg \" [ngClass]=\"{'alert-msg--danger': type == 'danger', 'alert-msg--success':  type == 'success', 'isVisible': message}\" >\n    <p class=\"alert-msg__text\">{{message | translate}}</p>\n</div>\n  ",
                styles: [""]
            }]
    }], function () { return [{ type: MessageBarService }, { type: ɵngcc3.Router }, { type: ɵngcc4.TranslateService }]; }, { type: [{
            type: Input
        }], endMessage: [{
            type: Output
        }], viewMessage: [{
            type: Input
        }] }); })();

const moment = moment_;
class TableConfigurableComponent {
    constructor(datepipe, translateService) {
        this.datepipe = datepipe;
        this.translateService = translateService;
        this.loading = true;
        this.total_rows = 0;
        this.filters_value = {};
        this.set_default_values = false;
        // outputs
        this.filters_data = new EventEmitter();
        this.goto_data = new EventEmitter();
        this.buttons_data = new EventEmitter();
        this.sort_data = new EventEmitter();
        this.debouncer = new Subject();
        /** default values */
        this.rows_number = 10;
        this.rows_per_page = [10, 25, 50];
        this.msg_report = "";
        this.empty_message = "No data found.";
        /** placeholders inputs */
        this.placeholder_input_text = "Search by";
        this.placeholder_dropdown = "Select";
        this.placeholder_calendar = "Select Date";
        this.default_calendar_items = {};
        let localDate = moment.localeData('es');
        this.locale_date = {
            daysOfWeek: localDate.weekdaysMin(),
            monthNames: localDate.monthsShort()
        };
        this.debouncer
            .pipe(debounceTime(400))
            .subscribe((filter) => {
            this.filters_data.emit(filter);
        });
    }
    ngOnInit() {
        console.log('Config Columns');
        console.log(this.config_cols);
        console.log('Data of Columns');
        console.log(this.data);
    }
    /** filter for all inputs
     * @param value
     * @param field
     */
    //array_field es un arreglo de campos para buscar en la query de los filtros
    inputsFilter(value, field, type, array_field) {
        let filter = {};
        if (array_field && array_field.length > 0) {
            filter = { "value": value, "field": field, "type": type, "field_array": array_field };
        }
        else {
            filter = { "value": value, "field": field, "type": type };
        }
        this.debouncer.next(filter);
    }
    /** emit event for link item
     * @param field
     * @param url
    */
    goToDetail(field, url) {
        let ulrdetail = { "field": field, "url": url };
        this.goto_data.emit(ulrdetail);
    }
    /**
     * emit event for buttons in body
     * @param item
     * @param action
     */
    btnFunctions(item, action) {
        let funtions = { "item": item, "action": action };
        this.buttons_data.emit(funtions);
    }
    /**
     * condition evaluation for buttons of actions
     * @param item
     * @param field
     * @param value
     */
    btnConditions(item, field, value) {
        if (typeof (value) == "string" && this.NestedData(item, field) == value) {
            return true;
        }
        else if (value.length > 0 && value.includes(this.NestedData(item, field))) {
            return true;
        }
        return false;
    }
    /**
     * function for nested data in table configuration
     * @param data
     * @param key
     */
    NestedData(data, key) {
        key = key.replace(/\[(\w+)\]/g, '.$1');
        key = key.replace(/^\./, '');
        var a = key.split('.');
        for (var i = 0, n = a.length; i < n; ++i) {
            var k = a[i];
            if (k in data) {
                data = data[k];
            }
            else {
                return '';
            }
        }
        return data;
    }
    /**
     * objects $date to string with format
     * @param time
     * @param format
     */
    dateTimeFormat(time, format) {
        let formated_date = "";
        if (!time) {
            return this.translateService.instant('trip.without_registration');
        }
        if (time.$date) {
            let date = new Date(time.$date);
            formated_date = this.datepipe.transform(date, format);
        }
        return formated_date;
    }
    /**
     * get string with concat fields from objects array
     * @param array
     * @param value
     */
    getArrayData(array, value) {
        let final_value = "";
        let tmp_array = [];
        if (array) {
            for (let i = 0; i < array.length; i++) {
                if (array[i][value]) {
                    tmp_array.push(array[i][value]);
                }
            }
        }
        final_value = tmp_array.join(", ");
        return final_value;
    }
    /**
     * get string with concat fields from objects array
     * @param array
     * @param value
     */
    getArrayData2(array, value) {
        let final_value = "";
        let tmp_array = [];
        let tmp_array_fields = [];
        let concat_strings;
        if (array) {
            for (let i = 0; i < array.length; i++) {
                if (value && value.length > 0) {
                    concat_strings = null;
                    tmp_array_fields = [];
                    for (let j = 0; j < value.length; j++) {
                        if (array[i][value[j]]) {
                            tmp_array_fields.push(array[i][value[j]]);
                        }
                    }
                    concat_strings = tmp_array_fields.join(" ");
                    tmp_array.push(concat_strings);
                }
            }
            final_value = tmp_array.join(", ");
        }
        return final_value;
    }
    /**
     * emit event for sorts and page selected
     * @param event
     */
    loadLazy(event) {
        let field = undefined;
        let header = undefined;
        if (!isNullOrUndefined(event.sortField)) {
            //if (!isNullOrUndefined(event.sortField)) {
            field = event.sortField.field;
            header = event.sortField.header;
        }
        let sort = { "field": field, "header": header, "order": event.sortOrder, "pageNumber": event.first / event.rows, "nPerPage": event.rows };
        this.sort_data.emit(sort);
    }
    /**
     * set default values to input type calendar
     * @param type_input
     * @param value_default
     * @param field
     * @param model
     */
    setDefaultValueCalendar(type_input, value_default, field) {
        if (value_default == 'today' && !this.default_calendar_items[field] && this.set_default_values) {
            if (isNullOrUndefined(this.filters_value[field].startDate)
                && isNullOrUndefined(this.filters_value[field].endDate)) {
                this.default_calendar_items[field] = true;
                let tmp_date = { 'startDate': moment(), 'endDate': moment() };
                let filter = { "value": tmp_date, "field": field, "type": type_input };
                this.filters_data.emit(filter);
            }
            else {
                this.default_calendar_items[field] = true;
            }
        }
    }
}
TableConfigurableComponent.ɵfac = function TableConfigurableComponent_Factory(t) { return new (t || TableConfigurableComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DatePipe), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.TranslateService)); };
TableConfigurableComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TableConfigurableComponent, selectors: [["com-lib-table-configurable"]], viewQuery: function TableConfigurableComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.table = _t.first);
    } }, inputs: { loading: "loading", total_rows: "total_rows", filters_value: "filters_value", set_default_values: "set_default_values", data: "data", config_cols: "config_cols", table_info: "table_info" }, outputs: { filters_data: "filters_data", goto_data: "goto_data", buttons_data: "buttons_data", sort_data: "sort_data" }, decls: 5, vars: 12, consts: [["styleClass", "ui-table-customers", 3, "columns", "value", "rowHover", "rows", "rowsPerPageOptions", "totalRecords", "loading", "paginator", "filterDelay", "showCurrentPageReport", "currentPageReportTemplate", "lazy", "onLazyLoad"], ["dt", ""], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "emptymessage"], ["class", "break-words", 3, "pSortableColumn", "pSortableColumnDisabled", "ngStyle", 4, "ngFor", "ngForOf"], [3, "ngSwitch", 4, "ngFor", "ngForOf"], [1, "break-words", 3, "pSortableColumn", "pSortableColumnDisabled", "ngStyle"], [3, "field", 4, "ngIf"], [3, "field"], [3, "ngSwitch"], ["styleClass", "ui-column-filter", 3, "options", "ngModel", "placeholder", "showClear", "ngModelChange", "onChange", 4, "ngSwitchCase"], ["pInputText", "", "type", "text", "class", "ui-column-filter", 3, "ngModel", "placeholder", "ngModelChange", "input", 4, "ngSwitchCase"], ["class", "row p-0 m-0 div-date-picker", 4, "ngSwitchCase"], ["styleClass", "ui-column-filter", 3, "options", "ngModel", "placeholder", "showClear", "ngModelChange", "onChange"], ["pTemplate", "selectedItem"], ["pTemplate", "item"], ["pInputText", "", "type", "text", 1, "ui-column-filter", 3, "ngModel", "placeholder", "ngModelChange", "input"], [1, "row", "p-0", "m-0", "div-date-picker"], ["type", "text", "ngxDaterangepickerMd", "", 1, "ui-column-filter-date-picker", "col", 3, "ngModel", "placeholder", "autoApply", "closeOnAutoApply", "showClearButton", "readonly", "locale", "datesUpdated", "ngModelChange"], ["class", "btn-clear col-2", 3, "click", 4, "ngIf"], [1, "btn-clear", "col-2", 3, "click"], [1, "ui-dropdown-clear-icon", "pi", "pi-times", "ng-tns-c7-0", "ng-star-inserted"], [4, "ngIf"], ["class", "break-words", 3, "ngSwitch", 4, "ngFor", "ngForOf"], [1, "break-words", 3, "ngSwitch"], [4, "ngSwitchCase"], ["class", "text-primary c-pointer", 3, "click", 4, "ngSwitchCase"], [3, "class", 4, "ngSwitchCase"], [4, "ngFor", "ngForOf"], [1, "display-block"], [1, "text-primary", "c-pointer", 3, "click"], ["class", "p-0 m-0", 4, "ngFor", "ngForOf"], [1, "p-0", "m-0"], [3, "ngbTooltip", "click", 4, "ngIf"], [3, "ngbTooltip", "click"], [1, "c-pointer", 2, "margin-bottom", ".3rem !important"], ["colspan", "14", 1, "p-datatable-no-data"]], template: function TableConfigurableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-table", 0, 1);
        ɵngcc0.ɵɵlistener("onLazyLoad", function TableConfigurableComponent_Template_p_table_onLazyLoad_0_listener($event) { return ctx.loadLazy($event); });
        ɵngcc0.ɵɵtemplate(2, TableConfigurableComponent_ng_template_2_Template, 4, 2, "ng-template", 2);
        ɵngcc0.ɵɵtemplate(3, TableConfigurableComponent_ng_template_3_Template, 1, 1, "ng-template", 3);
        ɵngcc0.ɵɵtemplate(4, TableConfigurableComponent_ng_template_4_Template, 4, 3, "ng-template", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("columns", ctx.config_cols)("value", ctx.data)("rowHover", true)("rows", ctx.rows_number)("rowsPerPageOptions", ctx.rows_per_page)("totalRecords", ctx.total_rows)("loading", ctx.loading)("paginator", true)("filterDelay", 300)("showCurrentPageReport", true)("currentPageReportTemplate", ctx.msg_report)("lazy", true);
    } }, directives: [ɵngcc6.Table, ɵngcc7.PrimeTemplate, ɵngcc5.NgForOf, ɵngcc6.SortableColumn, ɵngcc5.NgStyle, ɵngcc5.NgIf, ɵngcc6.SortIcon, ɵngcc5.NgSwitch, ɵngcc5.NgSwitchCase, ɵngcc8.Dropdown, ɵngcc9.NgControlStatus, ɵngcc9.NgModel, ɵngcc9.DefaultValueAccessor, ɵngcc10.InputText, ɵngcc11.DaterangepickerDirective, ɵngcc12.NgbTooltip], pipes: [ɵngcc4.TranslatePipe], styles: ["[_nghost-%COMP%]     .ui-table-customers{box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12)}[_nghost-%COMP%]     .ui-table-customers .customer-badge{border-radius:2px;padding:.25em .5em;text-transform:uppercase;font-weight:700;font-size:12px;letter-spacing:.3px}[_nghost-%COMP%]     .ui-table-customers .customer-badge.status-qualified{background-color:#c8e6c9;color:#256029}[_nghost-%COMP%]     .ui-table-customers .customer-badge.status-unqualified{background-color:#ffcdd2;color:#c63737}[_nghost-%COMP%]     .ui-table-customers .customer-badge.status-negotiation{background-color:#feedaf;color:#8a5340}[_nghost-%COMP%]     .ui-table-customers .customer-badge.status-new{background-color:#b3e5fc;color:#23547b}[_nghost-%COMP%]     .ui-table-customers .customer-badge.status-renewal{background-color:#eccfff;color:#694382}[_nghost-%COMP%]     .ui-table-customers .customer-badge.status-proposal{background-color:#ffd8b2;color:#805b36}[_nghost-%COMP%]     .ui-table-customers .flag{vertical-align:middle;width:30px;height:20px}[_nghost-%COMP%]     .ui-table-customers .ui-multiselect-representative-option{display:inline-block;vertical-align:middle}[_nghost-%COMP%]     .ui-table-customers .ui-multiselect-representative-option img{vertical-align:middle;width:24px}[_nghost-%COMP%]     .ui-table-customers .ui-multiselect-representative-option span{margin-top:.125em;vertical-align:middle;margin-left:.5em}[_nghost-%COMP%]     .ui-table-customers .ui-paginator .ui-dropdown{float:left}[_nghost-%COMP%]     .ui-table-customers .ui-paginator .ui-paginator-current{float:right}[_nghost-%COMP%]     .ui-table-customers .ui-dropdown{min-width:auto}[_nghost-%COMP%]     .ui-table-customers .ui-progressbar{height:8px;background-color:#d8dadc}[_nghost-%COMP%]     .ui-table-customers .ui-progressbar .ui-progressbar-value{background-color:#00acad}[_nghost-%COMP%]     .ui-table-customers .ui-column-filter{display:block}[_nghost-%COMP%]     .ui-table-customers .ui-column-filter input{width:100%}[_nghost-%COMP%]     .ui-table-customers .ui-table-globalfilter-container{float:right}[_nghost-%COMP%]     .ui-table-customers .ui-table-globalfilter-container input{width:200px}[_nghost-%COMP%]     .ui-table-customers .ui-datepicker{min-width:25em}[_nghost-%COMP%]     .ui-table-customers .ui-datepicker td{font-weight:400}[_nghost-%COMP%]     .ui-table-customers .ui-table-caption{border:0;padding:12px;text-align:left;font-size:20px}[_nghost-%COMP%]     .ui-table-customers .ui-paginator{border:0;padding:1em}[_nghost-%COMP%]     .ui-table-customers .ui-table-thead>tr>th{border:0;text-align:left}[_nghost-%COMP%]     .ui-table-customers .ui-table-thead>tr>th.ui-filter-column{border-top:1px solid #c8c8c8}[_nghost-%COMP%]     .ui-table-customers .ui-table-thead>tr>th:first-child{width:5em;text-align:center}[_nghost-%COMP%]     .ui-table-customers .ui-table-thead>tr>th:last-child{width:8em;text-align:center}[_nghost-%COMP%]     .ui-table-customers .ui-table-tbody>tr>td{border:0;cursor:auto}[_nghost-%COMP%]     .ui-table-customers .ui-table-tbody>tr>td:first-child{width:3em;text-align:center}[_nghost-%COMP%]     .ui-table-customers .ui-table-tbody>tr>td:last-child{width:8em;text-align:center}[_nghost-%COMP%]     .ui-table-customers .ui-dropdown-label:not(.ui-placeholder){text-transform:uppercase}[_nghost-%COMP%]     .ui-table-customers .ui-table-tbody>tr>td .ui-column-title{display:none}  body .ui-inputtext{font-size:14px;color:#333;background:#fff;padding:.429em;border:1px solid #a6a6a6;transition:border-color .2s;-webkit-appearance:none;-moz-appearance:none;appearance:none;width:100%}  .ui-table-wrapper{overflow-x:scroll;width:100%;min-height:400px}  .ui-table-wrapper>table{width:auto;margin-top:1px}  .ui-table-wrapper>table>thead>tr>th{min-width:150px;padding:10px 9px!important;font-family:Mark,Arial,Helvetica,Helvetica Neue,sans-serif;font-size:11px;font-weight:500;-webkit-font-smoothing:antialiased;color:#555!important;background-color:#fff!important}  .ui-table-wrapper>table>thead>tr:last-child>th{border-bottom:1px solid #ccc!important}  .ui-sortable-column.ui-state-highlight{color:#555!important;background-color:#fff!important}  .ui-column-filter{display:block!important;width:100%!important;padding:.532rem .75rem!important;font-size:13px!important;font-family:Mark,Arial,Helvetica,Helvetica Neue,sans-serif!important;font-weight:300;line-height:1.25;color:#333;background-color:#fff!important;background-image:none;background-clip:padding-box;border:1px solid #e5eaec!important;border-radius:4px;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;margin:0!important}  .ui-table-customers .ui-dropdown{min-width:auto;padding:1px 5px!important}  .ui-dropdown label.ui-dropdown-label{cursor:pointer;font-size:13px!important;font-family:Mark,Arial,Helvetica,Helvetica Neue,sans-serif!important;font-weight:300}  .pi{font-size:12px!important;color:#777}  .pi-sort:before{content:\"\\e902\"!important}.ui-paginator[_ngcontent-%COMP%]{background-color:#fff!important}.badge[_ngcontent-%COMP%]{display:-webkit-inline-box;min-height:20px;min-width:20px;font-size:12px;border-radius:50%;padding:4px 8px}.badge-indicator-danger[_ngcontent-%COMP%]{background-color:#ffe4e3}.badge-indicator-success[_ngcontent-%COMP%]{background-color:#5bc27f}  body .ui-table .ui-sortable-column.ui-state-highlight .ui-sortable-column-icon{color:#848484}  .pi-sort-up:before{content:\"\\e903\"}  .pi-sort-down:before{content:\"\\e902\"}  body .ui-dropdown .ui-dropdown-clear-icon{color:#848484;margin-right:1px}.btn-clear[_ngcontent-%COMP%]{background:#fff;border:none;margin:0;padding:0;border-radius:4px}  .ui-column-filter-date-picker{display:block!important;width:100%!important;padding:.532rem 0 .532rem .75rem;font-size:13px!important;font-family:Mark,Arial,Helvetica,Helvetica Neue,sans-serif!important;font-weight:300;line-height:1.25;color:#333;background-color:#fff!important;background-image:none;background-clip:padding-box;border:none!important;border-radius:4px;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;margin:0!important}.div-date-picker[_ngcontent-%COMP%]{border:1px solid #e5eaec!important;border-radius:4px}.break-words[_ngcontent-%COMP%]{overflow-wrap:break-word}"] });
TableConfigurableComponent.ctorParameters = () => [
    { type: DatePipe },
    { type: TranslateService }
];
TableConfigurableComponent.propDecorators = {
    data: [{ type: Input }],
    config_cols: [{ type: Input }],
    loading: [{ type: Input }],
    table_info: [{ type: Input }],
    total_rows: [{ type: Input }],
    filters_value: [{ type: Input }],
    set_default_values: [{ type: Input }],
    filters_data: [{ type: Output }],
    goto_data: [{ type: Output }],
    buttons_data: [{ type: Output }],
    sort_data: [{ type: Output }],
    table: [{ type: ViewChild, args: ['dt', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableConfigurableComponent, [{
        type: Component,
        args: [{
                selector: 'com-lib-table-configurable',
                template: "<!-- revisar Lazy Loading para datasets grandes -->\n<p-table #dt [columns]=\"config_cols\" [value]=\"data\" styleClass=\"ui-table-customers\"\n  [rowHover]=\"true\" [rows]=\"rows_number\" [rowsPerPageOptions]=\"rows_per_page\"\n  [totalRecords]=\"total_rows\"\n  [loading]=\"loading\" [paginator]=\"true\" [filterDelay]=\"300\"\n  [showCurrentPageReport]=\"true\" [currentPageReportTemplate]=\"msg_report\"\n  [lazy]=\"true\" (onLazyLoad)=\"loadLazy($event)\">\n  <!-- HEADERS -->\n  <ng-template pTemplate=\"header\">\n    <!-- HEADER TITLE -->\n    <tr>\n      <th *ngFor=\"let col of config_cols\" [pSortableColumn]=\"col\" [pSortableColumnDisabled]=\"col.sort==false\" [ngStyle]=\"{'width': col.width}\" class=\"break-words\">\n        {{ col.header != '' ? ( 'trip.'+col.header | translate ) : '' }}\n        <!-- SORT ICON -->\n        <p-sortIcon *ngIf=\"col.sort != false\" [field]=\"col.field\"></p-sortIcon>\n      </th>\n    </tr>\n    <!-- HEADER FINDERS -->\n    <tr>\n      <th *ngFor=\"let col of config_cols\" [ngSwitch]=\"col.filter\">\n        <!-- DROPDOWN -->\n        <p-dropdown *ngSwitchCase=\"'dropDown'\" [options]=\"col.options\" [(ngModel)]=\"filters_value[col.field]\"\n          (onChange)=\"inputsFilter($event.value, col.field, 'dropDown',null)\" styleClass=\"ui-column-filter\"\n          placeholder=\"{{'trip.placeholder_dropdown' | translate}}\" [showClear]=\"true\">\n          <ng-template let-item pTemplate=\"selectedItem\">\n              <span>{{ 'trip.'+item.label | translate }}</span>\n          </ng-template>\n          <ng-template let-option pTemplate=\"item\">\n            <span>{{ 'trip.'+option.label | translate }}</span>\n          </ng-template>\n        </p-dropdown>\n        <!-- INPUT TEXT -->\n        <input *ngSwitchCase=\"'inputText'\" pInputText type=\"text\" [(ngModel)]=\"filters_value[col.field]\"\n          (input)=\"inputsFilter($event.target.value, col.field, 'inputText',col.array_field_return)\"\n          placeholder=\"{{'trip.placeholder_input_text' | translate}} {{'trip.'+col.header | translate}}\" class=\"ui-column-filter\">\n\n\n          <!-- INPUT TEXT NUMBER -->\n        <input *ngSwitchCase=\"'inputTextNumber'\" pInputText type=\"text\" [(ngModel)]=\"filters_value[col.field]\"\n        (input)=\"inputsFilter($event.target.value, col.field, 'inputTextNumber',null)\"\n        placeholder=\"{{'trip.placeholder_input_text' | translate}} {{'trip.'+col.header | translate}}\" class=\"ui-column-filter\">\n        <!-- CALENDAR -->\n        <div *ngSwitchCase=\"'calendar'\" class=\"row p-0 m-0 div-date-picker\">\n            <!--\n              [(ngModel)]=\"this[col.default_calendar]\"\n              (ngModelChange)=\"setDefaultValueCalendar('calendar',col.default_value,col.field,col.default_calendar)\"\n            -->\n          <input type=\"text\"\n            ngxDaterangepickerMd\n            (datesUpdated)=\"inputsFilter($event, col.field, 'calendar',null)\"\n            [(ngModel)]=\"filters_value[col.field]\"\n            (ngModelChange)=\"setDefaultValueCalendar('calendar',col.default_value,col.field)\"\n            class=\"ui-column-filter-date-picker col\"\n            placeholder=\"{{'trip.placeholder_calendar' | translate}}\"\n            [autoApply]=\"true\"\n            [closeOnAutoApply]=\"true\"\n            [showClearButton]=\"true\"\n            [readonly]=\"true\"\n            [locale] = \"locale_date\"/>\n          <!-- CLEAR BUTTON CALENDAR INPUT -->\n          <button class=\"btn-clear col-2\" *ngIf=\"filters_value[col.field] && filters_value[col.field].startDate && filters_value[col.field].endDate\" (click)=\"filters_value[col.field]=''\">\n            <i class=\"ui-dropdown-clear-icon pi pi-times ng-tns-c7-0 ng-star-inserted\"></i>\n          </button>\n        </div>\n      </th>\n    </tr>\n  </ng-template>\n\n  <!-- BODY -->\n  <ng-template pTemplate=\"body\" let-item>\n    <tr *ngIf=\"!loading\">\n      <td *ngFor=\"let col of config_cols\" [ngSwitch]=\"col.body\" class=\"break-words\">\n        <!-- Text -->\n        <div *ngSwitchCase=\"'text'\">\n          {{(NestedData(item, col.field) != 'undefined' && NestedData(item, col.field) != 'null') ? NestedData(item, col.field) : ''}}\n        </div>\n        <!-- Text Translate-->\n        <div *ngSwitchCase=\"'text-translate'\">\n          {{(NestedData(item, col.field)!='undefined' && NestedData(item, col.field)!='null' && NestedData(item, col.field)!='') ? ('trip.'+NestedData(item, col.field) | translate) : '' }}\n        </div>\n        <!-- Text Calendar -->\n        <div *ngSwitchCase=\"'text-calendar'\">\n          {{ dateTimeFormat(NestedData(item, col.field), col.format) }}\n        </div>\n        <!-- Text Array -->\n        <div *ngSwitchCase=\"'text-array'\">\n          {{ getArrayData(NestedData(item, col.array), col.array_field) }}\n        </div>\n        <!-- Client Departure Arrival Array -->\n        <div *ngSwitchCase=\"'client-departure-arrival-array'\">\n          <ul>\n            <li *ngFor=\"let cda of item?.$client_departure_arrival_date\">\n              {{cda.place_name}}:\n              <small class=\"display-block\">{{dateTimeFormat(cda.departure, col.format)}} - {{dateTimeFormat(cda.arrival, col.format)}}</small>\n            </li>\n          </ul>\n        </div>\n          <!-- Text Array -->\n          <div *ngSwitchCase=\"'text-array-2'\">\n            {{ getArrayData2(NestedData(item, col.array), col.array_field_2) }}\n          </div>\n        <!-- Link -->\n        <a *ngSwitchCase=\"'link'\" class=\"text-primary c-pointer\" (click)=\"goToDetail(NestedData(item, col.field), col.url)\">\n            {{NestedData(item, col.field)}}\n        </a>\n        <!-- Indicator status -->\n        <span *ngSwitchCase=\"'indicator'\" class=\"badge {{ NestedData(item, col.field)==true ? 'badge-indicator-success' : 'badge-indicator-danger' }} \"></span>\n        <!-- Buttons -->\n        <div *ngSwitchCase=\"'buttons'\">\n            <div *ngFor=\"let btn of col.buttons\" class=\"p-0 m-0\">\n                <div (click)=\"btnFunctions(NestedData(item, col.field), btn.action)\" *ngIf=\"btn.condition ? btnConditions(item, btn.field_cond, btn.value_cond) : true\" ngbTooltip=\"{{ 'trip.'+btn.tooltip | translate}}\">\n                    <p class=\" c-pointer\" style=\"margin-bottom: .3rem !important\">\n                        <i class=\"fa {{btn.icon}}\" ></i>\n                    </p>\n                </div>\n            </div>\n        </div>\n      </td>\n    </tr>\n  </ng-template>\n\n  <!-- EMPTY MESSAGE -->\n  <ng-template pTemplate=\"emptymessage\">\n    <tr>\n      <td colspan=\"14\" class=\"p-datatable-no-data\">{{loading? '' : ('trip.empty_message' | translate)}}</td>\n    </tr>\n  </ng-template>\n</p-table>\n\n",
                styles: [":host ::ng-deep .ui-table-customers{box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12)}:host ::ng-deep .ui-table-customers .customer-badge{border-radius:2px;padding:.25em .5em;text-transform:uppercase;font-weight:700;font-size:12px;letter-spacing:.3px}:host ::ng-deep .ui-table-customers .customer-badge.status-qualified{background-color:#c8e6c9;color:#256029}:host ::ng-deep .ui-table-customers .customer-badge.status-unqualified{background-color:#ffcdd2;color:#c63737}:host ::ng-deep .ui-table-customers .customer-badge.status-negotiation{background-color:#feedaf;color:#8a5340}:host ::ng-deep .ui-table-customers .customer-badge.status-new{background-color:#b3e5fc;color:#23547b}:host ::ng-deep .ui-table-customers .customer-badge.status-renewal{background-color:#eccfff;color:#694382}:host ::ng-deep .ui-table-customers .customer-badge.status-proposal{background-color:#ffd8b2;color:#805b36}:host ::ng-deep .ui-table-customers .flag{vertical-align:middle;width:30px;height:20px}:host ::ng-deep .ui-table-customers .ui-multiselect-representative-option{display:inline-block;vertical-align:middle}:host ::ng-deep .ui-table-customers .ui-multiselect-representative-option img{vertical-align:middle;width:24px}:host ::ng-deep .ui-table-customers .ui-multiselect-representative-option span{margin-top:.125em;vertical-align:middle;margin-left:.5em}:host ::ng-deep .ui-table-customers .ui-paginator .ui-dropdown{float:left}:host ::ng-deep .ui-table-customers .ui-paginator .ui-paginator-current{float:right}:host ::ng-deep .ui-table-customers .ui-dropdown{min-width:auto}:host ::ng-deep .ui-table-customers .ui-progressbar{height:8px;background-color:#d8dadc}:host ::ng-deep .ui-table-customers .ui-progressbar .ui-progressbar-value{background-color:#00acad}:host ::ng-deep .ui-table-customers .ui-column-filter{display:block}:host ::ng-deep .ui-table-customers .ui-column-filter input{width:100%}:host ::ng-deep .ui-table-customers .ui-table-globalfilter-container{float:right}:host ::ng-deep .ui-table-customers .ui-table-globalfilter-container input{width:200px}:host ::ng-deep .ui-table-customers .ui-datepicker{min-width:25em}:host ::ng-deep .ui-table-customers .ui-datepicker td{font-weight:400}:host ::ng-deep .ui-table-customers .ui-table-caption{border:0;padding:12px;text-align:left;font-size:20px}:host ::ng-deep .ui-table-customers .ui-paginator{border:0;padding:1em}:host ::ng-deep .ui-table-customers .ui-table-thead>tr>th{border:0;text-align:left}:host ::ng-deep .ui-table-customers .ui-table-thead>tr>th.ui-filter-column{border-top:1px solid #c8c8c8}:host ::ng-deep .ui-table-customers .ui-table-thead>tr>th:first-child{width:5em;text-align:center}:host ::ng-deep .ui-table-customers .ui-table-thead>tr>th:last-child{width:8em;text-align:center}:host ::ng-deep .ui-table-customers .ui-table-tbody>tr>td{border:0;cursor:auto}:host ::ng-deep .ui-table-customers .ui-table-tbody>tr>td:first-child{width:3em;text-align:center}:host ::ng-deep .ui-table-customers .ui-table-tbody>tr>td:last-child{width:8em;text-align:center}:host ::ng-deep .ui-table-customers .ui-dropdown-label:not(.ui-placeholder){text-transform:uppercase}:host ::ng-deep .ui-table-customers .ui-table-tbody>tr>td .ui-column-title{display:none}::ng-deep body .ui-inputtext{font-size:14px;color:#333;background:#fff;padding:.429em;border:1px solid #a6a6a6;transition:border-color .2s;-webkit-appearance:none;-moz-appearance:none;appearance:none;width:100%}::ng-deep .ui-table-wrapper{overflow-x:scroll;width:100%;min-height:400px}::ng-deep .ui-table-wrapper>table{width:auto;margin-top:1px}::ng-deep .ui-table-wrapper>table>thead>tr>th{min-width:150px;padding:10px 9px!important;font-family:Mark,Arial,Helvetica,Helvetica Neue,sans-serif;font-size:11px;font-weight:500;-webkit-font-smoothing:antialiased;color:#555!important;background-color:#fff!important}::ng-deep .ui-table-wrapper>table>thead>tr:last-child>th{border-bottom:1px solid #ccc!important}::ng-deep .ui-sortable-column.ui-state-highlight{color:#555!important;background-color:#fff!important}::ng-deep .ui-column-filter{display:block!important;width:100%!important;padding:.532rem .75rem!important;font-size:13px!important;font-family:Mark,Arial,Helvetica,Helvetica Neue,sans-serif!important;font-weight:300;line-height:1.25;color:#333;background-color:#fff!important;background-image:none;background-clip:padding-box;border:1px solid #e5eaec!important;border-radius:4px;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;margin:0!important}::ng-deep .ui-table-customers .ui-dropdown{min-width:auto;padding:1px 5px!important}::ng-deep .ui-dropdown label.ui-dropdown-label{cursor:pointer;font-size:13px!important;font-family:Mark,Arial,Helvetica,Helvetica Neue,sans-serif!important;font-weight:300}::ng-deep .pi{font-size:12px!important;color:#777}::ng-deep .pi-sort:before{content:\"\\e902\"!important}.ui-paginator{background-color:#fff!important}.badge{display:-webkit-inline-box;min-height:20px;min-width:20px;font-size:12px;border-radius:50%;padding:4px 8px}.badge-indicator-danger{background-color:#ffe4e3}.badge-indicator-success{background-color:#5bc27f}::ng-deep body .ui-table .ui-sortable-column.ui-state-highlight .ui-sortable-column-icon{color:#848484}::ng-deep .pi-sort-up:before{content:\"\\e903\"}::ng-deep .pi-sort-down:before{content:\"\\e902\"}::ng-deep body .ui-dropdown .ui-dropdown-clear-icon{color:#848484;margin-right:1px}.btn-clear{background:#fff;border:none;margin:0;padding:0;border-radius:4px}::ng-deep .ui-column-filter-date-picker{display:block!important;width:100%!important;padding:.532rem 0 .532rem .75rem;font-size:13px!important;font-family:Mark,Arial,Helvetica,Helvetica Neue,sans-serif!important;font-weight:300;line-height:1.25;color:#333;background-color:#fff!important;background-image:none;background-clip:padding-box;border:none!important;border-radius:4px;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;margin:0!important}.div-date-picker{border:1px solid #e5eaec!important;border-radius:4px}.break-words{overflow-wrap:break-word}"]
            }]
    }], function () { return [{ type: ɵngcc5.DatePipe }, { type: ɵngcc4.TranslateService }]; }, { loading: [{
            type: Input
        }], total_rows: [{
            type: Input
        }], filters_value: [{
            type: Input
        }], set_default_values: [{
            type: Input
        }], filters_data: [{
            type: Output
        }], goto_data: [{
            type: Output
        }], buttons_data: [{
            type: Output
        }], sort_data: [{
            type: Output
        }], data: [{
            type: Input
        }], config_cols: [{
            type: Input
        }], table_info: [{
            type: Input
        }], table: [{
            type: ViewChild,
            args: ['dt', { static: true }]
        }] }); })();

class ZonesService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
    }
    getZonesByPointsAndTypes(params) {
        return this.http.post(this.env.urlPlaces + '/zone/search_AllTypeZones', params).toPromise();
    }
    getZoneTypes() {
        return this.http.get(this.env.urlPlaces + '/zone/type').toPromise();
    }
    getRisks() {
        return this.http.get(this.env.urlPlaces + '/zone/risk').toPromise();
    }
    getZones() {
        return this.http.get(this.env.urlPlaces + '/zone').toPromise();
    }
    getZonesbyPlace(id_place) {
        return this.http.get(this.env.urlPlaces + '/zone/findByPlace/' + id_place).toPromise();
    }
    getZonesbyAccount(id_account) {
        return this.http.get(this.env.urlPlaces + '/zone/findByAccount/' + id_account).toPromise();
    }
    /** Obtener el listado de alerts en mantenedor */
    getZoneListSearch(params) {
        return this.http.post(this.env.urlPlaces + '/zone/search', params);
    }
    createZone(params) {
        return this.http.post(this.env.urlPlaces + '/zone', params).toPromise();
    }
    getZonebyId(id_zone) {
        return this.http.get(this.env.urlPlaces + '/zone/' + id_zone).toPromise();
    }
    getRoute(account_id, route_id) {
        return this.http.get(this.env.urlRoutes + '/get_route/' + account_id + '/' + route_id).toPromise();
    }
}
ZonesService.ɵfac = function ZonesService_Factory(t) { return new (t || ZonesService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject('env')); };
ZonesService.ɵprov = ɵɵdefineInjectable({ factory: function ZonesService_Factory() { return new ZonesService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: ZonesService, providedIn: "root" });
ZonesService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ZonesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();

class TripsService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
    }
    /** Obtener el listado de viajes */
    getTripsList(params, account_id) {
        return this.http.post(this.env.urlTrips + '/list/account/' + account_id + '/', params);
    }
    /** Obtener detalle de un viaje */
    getTripDetail(account_id, trip_id) {
        console.log("ruta getTripDetail:");
        console.log(this.env.urlTrips + '/' + trip_id + '/account/' + account_id + '/');
        return this.http.get(this.env.urlTrips + '/' + trip_id + '/account/' + account_id + '/');
    }
    getCurrentGPSLocationbyTrip(trip_id, account_id) {
        return this.http.get(this.env.urlStats + '/map/findLocationbyTripId/' + trip_id + '/account/' + account_id, { headers: new HttpHeaders }).toPromise()
            .catch((err) => {
            // simple logging, but you can do a lot more, see below
            console.error('An error occurred getCurrentGPSLocationbyTrip :', err.error);
        });
    }
    getCurrentRoute(trip_id, account_id, date) {
        let parameters;
        if (date !== undefined) {
            parameters = new HttpParams().set("tripId", trip_id).set("accountId", account_id).set("dateTime", date); //Create new HttpParams
        }
        else {
            parameters = new HttpParams().set("tripId", trip_id).set("accountId", account_id);
        }
        return this.http.get(this.env.urlStats + '/map/findRoute?tripId=' + trip_id + '&accountId=' + account_id);
    }
    // ConFiltros
    getCurrentRouteConFiltros(trip_id, account_id, usaFiltros, fechaLimiteInferior = 0) {
        const rutaPosicionesResumidas = 'findRouteSummary';
        const rutaPosicionesDetalladas = 'findRouteDetailedByHour';
        const metodoUsar = usaFiltros ? rutaPosicionesResumidas : rutaPosicionesDetalladas;
        let urlUsar = this.env.urlStats + '/map/' + metodoUsar + '?tripId=' + trip_id + '&accountId=' + account_id; // +'&resumida='+usaFiltros;
        if (metodoUsar === rutaPosicionesDetalladas)
            urlUsar += '&limitInferiorDate=' + fechaLimiteInferior;
        // console.log('getCurrentRouteConFiltros - urlUsar: ' + urlUsar );
        return this.http.get(urlUsar);
    }
    getDatesOfSignalsRoute(trip_id, account_id) {
        const urlUsar = this.env.urlStats + '/map/getDatesOfSignalsRoute?tripId=' + trip_id + '&accountId=' + account_id;
        console.log('getDatesOfSignalsRoute - urlUsar: ' + urlUsar);
        return this.http.get(urlUsar);
    }
    getInitialTraffic() {
        return this.http.get(this.env.urlTrafficService + '/traffic').toPromise().catch((err) => {
            // simple logging, but you can do a lot more, see below
            console.error('An error occurred getInitialTraffic :', err.error);
        });
    }
    getCurrentTraffic(bottom, left, top, right) {
        let cadena = this.env.urlTrafficService + '/traffic/' + bottom + '&' + left + '&' + top + '&' + right;
        return this.http.get(cadena).toPromise().catch((err) => {
            // simple logging, but you can do a lot more, see below
            console.error('An error occurred getCurrentTraffic :', err.error);
        });
    }
    getRoute(rutaTimeLine) {
        console.log(rutaTimeLine);
        let cadena = '';
        var length = rutaTimeLine.features.length;
        for (let i = 0; i < length - 1; i++) {
            if (rutaTimeLine.features[i].geometry.type == "Point") {
                cadena += rutaTimeLine.features[i].geometry.coordinates + ';';
            }
        }
        if (rutaTimeLine.features[length - 1].geometry.type == "Point") {
            cadena += rutaTimeLine.features[length - 1].geometry.coordinates;
        }
        return this.http.get('http://router.project-osrm.org/route/v1/driving/' +
            cadena + '?steps=true&geometries=geojson&overview=full').toPromise();
    }
    getRouteMatchLatLng(trip_id, account_id, id, waypoints, radiuses = 20) {
        var data = {
            "trip_id": trip_id,
            "account_id": account_id,
            "id": id,
            "coordinates": waypoints,
            "radiuses": radiuses
        };
        return this.http.post(this.env.urlOsrm + '/match/', data).toPromise().catch(error => {
            console.log(error.error);
            return throwError('Capital not found!');
        });
    }
    getFinal_OriginZonesbyTrip(tripId) {
        tripId = encodeURIComponent(tripId);
        return this.http.get(this.env.urlPlaces + '/zone/trip/' + tripId).toPromise();
    }
    getTransport(trans_id, account_id) {
        return this.http.get(this.env.urlTransport + '/get_gps/' + trans_id + '/account/' + account_id);
    }
}
TripsService.ɵfac = function TripsService_Factory(t) { return new (t || TripsService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject('env')); };
TripsService.ɵprov = ɵɵdefineInjectable({ factory: function TripsService_Factory() { return new TripsService(ɵɵinject(HttpClient), ɵɵinject("env")); }, token: TripsService, providedIn: "root" });
TripsService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TripsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();

class MapRealtimeComponent {
    constructor(zonesService, tripService, translateService) {
        this.zonesService = zonesService;
        this.tripService = tripService;
        this.translateService = translateService;
        this.map_coordinates_center = [0, 0];
        this.map_token_mapbox = "pk.eyJ1IjoiY3ZhcHBzIiwiYSI6ImNqeHAybmx0ajBkZGczZW5ybWRoZWYxbmwifQ.KiEi8bJWMmnVblYnFgqOgg";
        this.map_route_timeline = { "type": "FeatureCollection", "features": [] };
        this.gps_update_time = 5 * 1000;
        this.gps_positions_all = {};
        this.gps_route_colors = ['#4990e2', '#ff6a00', '#1bff00', '#002bff', '#fb00ff'];
        this.gps_signals_ids = [];
        this.gps_signal_id_selected = null;
        this.layer_real_time = L.layerGroup(); // Embotellamientos
        this.layer_gps_points = L.layerGroup(); // ruta
        this.layer_gps_points_direction = L.layerGroup(); // ruta
        this.layer_route = L.layerGroup(); // ruta dirección
        this.layer_route_direction = L.layerGroup(); // ruta dirección
        this.layer_route_realtime = L.layerGroup(); // ruta dirección
        this.layer_route_realtime_direction = L.layerGroup(); // ruta dirección
        this.layer_jams = L.layerGroup(); // Embotellamientos
        this.layer_alerts = L.layerGroup(); // Alertas
        this.language = 'es';
        this._center = false;
        this._track = false;
        this._overview = false;
        this._showTraffic = false;
        this._showRoute = true;
        this.display_loading = true;
        this.slider_duration = 10 * 10000;
        this.slider_steps = 1 * 10000;
        this.centerZoom = 15;
        this.trackinZoom = 18;
        this.promises = [];
        this.realTime = false;
        this.routeLine = false;
        this.alertsStatic = false;
        this.alertsRealTime = false;
        this.zones = false;
        this.slider = false;
        this.finder_lat_lng = "";
        this.zones_trip = { "type": "FeatureCollection", "features": [] };
        this.timeoutCurrentPosition = null;
        this.gps_route_layers = {};
        this.translateService.use(this.language);
        this.userLogueado = JSON.parse(localStorage.getItem('User'));
        this.account_id = this.userLogueado['account']['id'];
        this.map_coordinates_center = [-33.4475556, -70.661685];
    }
    finderClick() {
        try {
            var d = this.finder_lat_lng.split(',');
            var lat = d[0].trim();
            var lng = d[1].trim();
            if (this.finder_marker) {
                this.map.removeControl(this.finder_marker);
            }
            this.map.flyTo([lat, lng], this.trackinZoom);
            this.finder_marker = L.marker([lat, lng]).addTo(this.map);
        }
        catch (error) {
            this.finder_lat_lng = "";
        }
    }
    finderPaste(evt) {
        console.log(evt);
    }
    ngOnInit() {
        this.initMap();
        this.initIcons();
        if (this.realTime) {
            this.gpsCurrentPosition().then(res => {
                var route = this.gps_positions_all[this.gps_signal_id_selected];
                if (route && route.current_position) {
                    this.display_loading = false;
                    this.map.flyTo(route.current_position, this.trackinZoom);
                }
            });
        }
        // this.gpsRoute().then(res =>{
        // })
        this.initServices();
    }
    initMap() {
        // replace with your Mapbox API Access token. Create a Mabpox account and find it on https://www.mapbox.com/studio/
        let token = this.map_token_mapbox;
        this.map = L.map('map').setView(this.map_coordinates_center, this.trackinZoom);
        let gl = L.mapboxGL({
            accessToken: token,
            style: 'mapbox://styles/mapbox/streets-v9'
        }).addTo(this.map);
        this.map.options.minZoom = 3;
        this.map.options.maxZoom = 20;
        this.map.addControl(new L.Control.Fullscreen());
        this.map.addLayer(this.layer_real_time);
        //this.initLogoWaze()
        var mapflyTo = this.map.flyTo;
        var me = this;
        this.map.flyTo = function () {
            me.offAllLayers();
            var ret = mapflyTo.apply(this, arguments);
            //me.onAllLayers();
            return ret;
        };
        //SET MAP EVENTS
        this.map.on("zoomstart", this.zoomStart.bind(this));
        this.map.on("zoomend", this.zoomEnd.bind(this));
        this.map.on("moveend", this.moveend.bind(this));
    }
    initIcons() {
        this.icon_truck = L.svgIcon({
            iconUrl: '/assets/trips/map-realtime/route_icons/LocationPoint.svg',
            iconSize: [50, 50],
            styles: {
                'Path': 'fill:green'
            }
        });
        /*this.icon_destination = L.icon({
          iconUrl: this.destination_path,
          iconSize: [125, 90]
        });
        this.icon_origin = L.icon({
          iconUrl: this.origin_path,
          iconSize: [125, 90]
        });
        this.icon_alert = L.icon({
          iconUrl: this.alert_path,
          iconSize: [45, 45]
        });
        this.icon_stop = L.icon({
          iconUrl: this.stop_path,
          iconSize:[35,35]
        })*/
    }
    initSlider() {
        let slider = L.timelineSliderControl({
            duration: this.slider_duration,
            steps: this.slider_steps,
            enablePlayback: true,
            formatOutput: (date) => {
                return new Date(date).toString();
            },
            showTicks: false
        });
        this.map.addControl(slider);
        let tripLayer = L.layerGroup();
        let TimeLine = L.timeline(this.map_route_timeline, {
            pointToLayer: (features, latlng) => {
                let marker = L.marker(latlng, { icon: this.icon_truck }).bindPopup('<p><strong>Patente: </strong>' + features.properties.num_plate + '</p>' +
                    '<p><strong>Ultimo seguimiento: </strong>' + features.properties.start + '</p>');
                return marker;
            }
        });
        TimeLine.addTo(this.map);
        slider.addTimelines(TimeLine);
    }
    initServices() {
        this.promises.push(this.zonesService.getZonesbyAccount(this.account_id).then(result => {
            for (const iterator of result['list']) {
                iterator["geoJson"]["properties"]["color"] = iterator["color_risk"];
                iterator["geoJson"]["properties"]["name"] = iterator["zone_name"];
                this.zones_trip["features"].push(iterator["geoJson"]);
            }
            this.drawZone(this.zones_trip);
        }, error => {
            console.log("Error get zones= " + error);
        }));
        this.promises.push(this.tripService.getTripDetail(this.account_id, this.trip_id).subscribe((response) => {
            if (response && response.code != 500) {
                console.log('INFO TRIP');
                console.log(response);
                var orig = response["origin"];
                var dest = response["final_destination"];
                var final_lat = response["final_destination"]["latitude"];
                var final_lng = response["final_destination"]["longitude"];
                var origin_lat = response["origin"]["latitude"];
                var origin_lng = response["origin"]["longitude"];
                this.coordinates_origin = [origin_lat, origin_lng];
                this.coordinates_destination = [final_lat, final_lng];
                this.trip_detail = response;
                this.createSvgMarker({
                    iconUrl: '/assets/trips/map-realtime/route_icons/OriginPoint.svg',
                    position: [orig.latitude, orig.longitude],
                    popUp: '<strong>ORIGEN:' + orig.name + '</strong>'
                });
                this.createSvgMarker({
                    iconUrl: '/assets/trips/map-realtime/route_icons/DestinationPoint.svg',
                    position: [dest.latitude, dest.longitude],
                    popUp: '<strong>DESTINO: ' + dest.name + '</strong>'
                });
                if (response.events) {
                    for (var i in response.events) {
                        var evt = response.events[i];
                        if (evt.business && evt.business.namespace == "CALL_CENTER") {
                            this.createSvgMarker({
                                iconUrl: '/assets/trips/map-realtime/route_icons/Alert.svg',
                                position: [evt.place.latitude, evt.place.longitude],
                                popUp: '<p><strong>' + evt.type.description + '</strong></p>' + '<p><strong>' + evt.creation_date + '</strong></p>'
                            });
                        }
                    }
                }
            }
        }, (error) => {
            console.log("Error get trip detail: " + error);
        }));
    }
    createSvgMarker(options) {
        options.iconSize = options.iconSize || [50, 50];
        var icon = L.svgIcon(options);
        console.log('SVG MARKER :' + options.popUp);
        console.log(options.position);
        var marker = L.marker(options.position, { icon: icon });
        marker.bindPopup(options.popUp);
        marker.addTo(this.map);
    }
    ngOnDestroy() {
        clearTimeout(this.timeoutCurrentPosition);
    }
    gpsCurrentPosition() {
        var promise = this.tripService.getCurrentGPSLocationbyTrip(this.trip_id, this.account_id).then(response => {
            var data = response;
            //console.log(data)
            if (data && data.features && data.features.length > 0) {
                var feature = null;
                var id = null;
                for (var i = 0; i < data.features.length; i++) {
                    feature = data.features[i];
                    id = data.features[i].properties.num_plate;
                    this.gps_positions_all[id] = this.gps_positions_all[id] || {};
                    var route = this.gps_positions_all[id];
                    var p = feature.geometry.coordinates;
                    //route.realtime_positions = route.realtime_positions || [];
                    if (route.realtime_positions && route.current_position && (route.current_position.lng != p[0] || route.current_position.lat != p[1])) {
                        route.realtime_positions.push(p); //([p[1],p[0]]);
                    }
                    else {
                        console.log('last point already on route!!');
                    }
                    console.log('this.current_position:');
                    console.log(route.current_position);
                    console.log(p);
                    route.current_position = L.latLng(p[1], p[0]);
                    if (!this.gps_signal_id_selected) {
                        this.gps_signal_id_selected = id;
                    }
                    if (this._track) {
                        this.map.flyTo(route.current_position, this.trackinZoom);
                    }
                    route.iconTruck = L.svgIcon({
                        iconUrl: '/assets/trips/map-realtime/route_icons/LocationPoint.svg',
                        iconSize: [50, 50],
                        styles: {
                            'Path': 'fill:' + route.color
                        }
                    });
                    route.iconTruckMarker = L.marker(route.current_position, { icon: route.iconTruck });
                    route.iconTruckMarker.bindPopup('<p><strong>Patente: </strong>' + feature.properties.num_plate + '</p>' +
                        '<p><strong>Ultimo seguimiento: </strong>' + feature.properties.time + '</p>');
                    if (this.gps_signal_id_selected == id) {
                        //draw realtime track
                        this.layer_real_time.clearLayers();
                        route.iconTruckMarker.addTo(this.layer_real_time);
                        //var realtimeRoute = L.polyline(route.realtime_positions, { color: route.color });
                        //realtimeRoute.addTo(this.layer_real_time)
                        //this.gpsRouteRealTimeDrawFix(id,route,route.color)
                    }
                }
            }
            clearTimeout(this.timeoutCurrentPosition);
            this.timeoutCurrentPosition = setTimeout(() => {
                this.gpsCurrentPosition();
            }, this.gps_update_time);
        });
        return promise;
    }
    gpsRoute() {
        console.log('this.trip_id:' + this.trip_id);
        return this.tripService.getCurrentRoute(this.trip_id, this.account_id).subscribe((data) => {
            console.log(data);
            this.display_loading = false;
            var route = this.gps_positions_all[this.gps_signal_id_selected];
            if (route && route.current_position) {
                this.map.flyTo(route.current_position, this.trackinZoom);
            }
            this.gps_positions_all = this.gps_positions_all || {};
            if (data && data.length > 0) {
                this.checkColors(data);
                this.gps_signals_ids = [];
                var route = null;
                for (var i = 0; i < data.length; i++) {
                    var id = data[i]['_id'];
                    route = this.gps_positions_all[id] || {};
                    this.gps_positions_all[id] = route;
                    for (var attr in data[i]) {
                        route[attr] = data[i][attr];
                    }
                    route['color'] = this.gps_route_colors[i];
                    this.gps_signals_ids.push({ id: route['_id'], style: { 'background-color': this.gps_route_colors[i] } });
                    if (!route.realtime_positions) {
                        route.realtime_positions = [];
                        var pts = route['lng_lat'];
                        var p = pts[pts.length - 1];
                        route.realtime_positions.push(p);
                    }
                }
                //por defecto selecciona la patente con mayor número de señales
                i = this.signalLargest(data);
                route = data[i];
                this.gps_signal_id_selected = route['_id'];
                this.onChange(this.gps_signals_ids[i]);
            }
        }, error => {
            console.log("GET ROUTE ERROR!!");
        });
    }
    onChange(evt) {
        console.log(evt);
        var route = this.gps_positions_all[evt.id];
        var positions = route["lat_lng"];
        var color = route["color"];
        this.layer_real_time.clearLayers();
        if (route.iconTruckMarker) {
            route.iconTruckMarker.addTo(this.layer_real_time);
            L.polyline(route.realtime_positions, { color: route.color }).addTo(this.layer_real_time);
        }
        this.gpsRouteDrawFix(route['_id'], route["lng_lat"], color);
        this.map_route_timeline.features = route["route_timeline"];
        if (this.slider) {
            this.initSlider();
        }
        if (positions.length > 0) {
            /*var lastPoint = positions[positions.length - 1]
            if(!route.realtime_positions){
              route.realtime_positions = [];
              route.realtime_positions.push(lastPoint)
              route.current_position = lastPoint;
      
            }*/
            var routeLine = L.polyline(positions, { color: '#4990e2' }); //.addTo(this.map);
            //console.log(route)
            route.bounds = routeLine._bounds;
            if (this.slider) {
                this.overview();
            }
            this.gpsDrawRoutePoints(route['_id'], positions, color, 0);
        }
    }
    signalLargest(data) {
        if (data && data.length > 0) {
            var l = 0;
            for (var i = 1; i < data.length; i++) {
                if (data[i]["lng_lat"].length > data[l]["lng_lat"].length) {
                    l = i;
                }
            }
            return l;
        }
        return -1;
    }
    /**
     * Determina si los colores iniciales son suficientes para cada ruta, de no ser así genera colores random adicionales
     * @param data
     */
    checkColors(data) {
        if (data && data.length > this.gps_route_colors.length) {
            var l = this.gps_route_colors.length;
            for (var i = l; i < data.length; i++) {
                var r = Math.round(Math.random() * 255);
                var g = Math.round(Math.random() * 255);
                var b = Math.round(Math.random() * 255);
                this.gps_route_colors.push('rgb(' + r + ',' + g + ',' + b + ')');
            }
        }
    }
    gpsDrawRoutePoints(id, positions, color, i) {
        this.gps_route_layers[id] = this.gps_route_layers[id] || {};
        var layers = this.gps_route_layers[id];
        if (i == 0 && layers.layer_gps_points) {
            this.offAllLayers();
            this.layer_gps_points = layers.layer_gps_points;
            this.onAllLayers();
        }
        else {
            if (!layers.layer_gps_points)
                layers.layer_gps_points = L.layerGroup();
            var N = 1000;
            for (var k = 0; k < N && i < positions.length; k++, i++) {
                var position = { "type": "Feature", "properties": { "start": {}, "end": {}, "num_plate": {} }, "geometry": { "type": "Point", "coordinates": [0, 0] } };
                var circle = L.circle(positions[i], {
                    color: color,
                    radius: 1,
                });
                if (k > 0) {
                    var poly = L.polyline([positions[k - 1], positions[k]], { color: 'red' }); //.addTo(this.map);
                    var arrowHead = L.polylineDecorator(poly, {
                        patterns: [
                            { offset: 1, repeat: 0, symbol: L.Symbol.arrowHead({ pixelSize: 5, polygon: false, pathOptions: { color: color, stroke: true } }) }
                        ]
                    });
                    layers.layer_gps_points.addLayer(arrowHead);
                }
                layers.layer_gps_points.addLayer(circle);
            }
            if (i < positions.length) {
                setTimeout(() => {
                    this.gpsDrawRoutePoints(id, positions, color, i);
                }, 1);
            }
            else {
                this.offAllLayers();
                this.layer_gps_points = layers.layer_gps_points;
                this.onAllLayers();
            }
        }
    }
    gpsRouteDrawFix(id, lng_lat, color) {
        this.gps_route_layers[id] = this.gps_route_layers[id] || {};
        var layers = this.gps_route_layers[id];
        if (layers.layer_route) {
            this.offAllLayers();
            this.layer_route = layers.layer_route;
            this.layer_route_direction = layers.layer_route_direction;
            this.onAllLayers();
        }
        else {
            this.tripService.getRouteMatchLatLng(this.trip_id, this.account_id, id, lng_lat).then(result => {
                layers.layer_route = L.layerGroup();
                layers.layer_route_direction = L.layerGroup();
                this.gps_route_layers[id] = layers;
                //console.log('RESULT:')
                //console.log(result)
                var c = result['route_points'];
                //c = L.GeoJSON.coordsToLatLng(c)
                //console.log(c)
                if (c) {
                    this.drawRouteFix(layers, color, c, 0);
                }
                else {
                    console.log('ERROR: no match data were obtained');
                }
            });
        }
    }
    drawRouteFix(layers, color, c, i) {
        let MAX = 1000;
        for (var k = 0, i = i + 1; k < MAX && i < c.length; k++, i++) {
            var a = [c[i - 1][1], c[i - 1][0]];
            var b = [c[i][1], c[i][0]];
            var poly = L.polyline([a, b], { color: color }); //.addTo(this.map);
            var arrowHead = L.polylineDecorator(poly, {
                patterns: [
                    { offset: '10%', repeat: 0, symbol: L.Symbol.arrowHead({ pixelSize: 5, polygon: false, pathOptions: { color: color, stroke: true } }) }
                ]
            }); //.addTo(this.map);
            layers.layer_route.addLayer(poly);
            layers.layer_route_direction.addLayer(arrowHead);
        }
        if (i < c.length) {
            setTimeout((layers, color, c, i) => {
                this.drawRouteFix(layers, color, c, i);
            }, 200, layers, color, c, i);
        }
        else {
            this.offAllLayers();
            this.layer_route = layers.layer_route;
            this.layer_route_direction = layers.layer_route_direction;
            this.onAllLayers();
        }
    }
    gpsRouteRealTimeDrawFix(id, route, color) {
        this.tripService.getRouteMatchLatLng(this.trip_id, this.account_id, id + '-real', route.realtime_positions).then(result => {
            //console.log('RESULT:')
            //console.log(result)
            var c = result['route_points'];
            //c = L.GeoJSON.coordsToLatLng(c)
            //console.log(c)
            this.layer_route_realtime.clearLayers();
            for (var i = 1; i < c.length; i += 1) {
                var a = [c[i - 1][1], c[i - 1][0]];
                var b = [c[i][1], c[i][0]];
                var poly = L.polyline([a, b], { color: color }); //.addTo(this.map);
                var arrowHead = L.polylineDecorator(poly, {
                    patterns: [
                        { offset: '10%', repeat: 0, symbol: L.Symbol.arrowHead({ pixelSize: 5, polygon: false, pathOptions: { color: color, stroke: true } }) }
                    ]
                }); //.addTo(this.map);
                this.layer_route_realtime.addLayer(poly);
                this.layer_route_realtime.addLayer(arrowHead);
            }
        });
    }
    drawZone(zones) {
        let polygon;
        let latlng;
        let circle;
        for (let i = 0; i < zones.features.length; i++) {
            if (zones.features[i].geometry.type == "Polygon") {
                //latlng = zones.features[i].geometry.coordinates;
                latlng = [];
                for (const array_polygon of zones.features[i].geometry.coordinates) {
                    for (const polygon of array_polygon) {
                        latlng.push([polygon[1], polygon[0]]);
                    }
                }
                polygon = L.polygon(latlng, { color: zones.features[i].properties.color }).addTo(this.map);
                polygon.bindTooltip(zones.features[i].properties.name);
            }
            if (zones.features[i].geometry.type == "Point") {
                var lng = zones.features[i].geometry.coordinates[0];
                var lat = zones.features[i].geometry.coordinates[1];
                circle = L.circle([lat, lng], {
                    color: zones.features[i].properties.color,
                    radius: zones.features[i].properties.radius,
                    fillOpacity: 0.7
                }).addTo(this.map);
                circle.bindTooltip(zones.features[i].properties.name);
            }
        }
    }
    ////TOOLBOX/////
    //TODO: cambiar currentPosition actual de head enves de this.currentPosition.features[0] , cuando datos se obtengan de trip
    center() {
        var route = this.gps_positions_all[this.gps_signal_id_selected];
        if (route && route.current_position) {
            this._center = true;
            this._overview = false;
            this._track = false;
            this.map.flyTo(route.current_position, this.centerZoom);
        }
        else {
            alert("No hay datos de posición !!");
        }
    }
    activeTrack() {
        var route = this.gps_positions_all[this.gps_signal_id_selected];
        this._track = !this._track;
        this._center = false;
        this._overview = false;
        if (this._track && route && route.current_position) {
            this.map.flyTo(route.current_position, this.trackinZoom);
        }
    }
    overview() {
        var route = this.gps_positions_all[this.gps_signal_id_selected];
        if (route && route.bounds) {
            this._center = false;
            this._overview = true;
            this._track = false;
            console.log("route bounds");
            console.log(route.bounds);
            this.map.flyToBounds(route.bounds);
        }
        else {
            alert("No hay datos de posición !!");
        }
    }
    routeView() {
        this.display_loading = true;
        this._showRoute = !this._showRoute;
        this.showRoute();
        this.display_loading = false;
    }
    showRoute() {
        this.map.removeLayer(this.layer_gps_points);
        this.map.removeLayer(this.layer_route);
        this.map.removeLayer(this.layer_route_direction);
        this.map.removeLayer(this.layer_route_realtime);
        this.map.removeLayer(this.layer_route_realtime_direction);
        if (this._showRoute) {
            this.map.addLayer(this.layer_route);
            this.map.addLayer(this.layer_route_realtime);
            if (this.map_current_zoom >= 17) {
                this.map.addLayer(this.layer_route_direction);
                this.map.addLayer(this.layer_route_realtime_direction);
            }
        }
        else {
            this.map.addLayer(this.layer_gps_points);
        }
    }
    showTraffic() {
        this._showTraffic = !this._showTraffic;
        //Limpio mapa
        this.layer_jams.clearLayers();
        this.layer_alerts.clearLayers();
        //Lanzo denuevo Trafico
        this.getCurrentTraffic();
    }
    getCurrentTraffic() {
        if (this._showTraffic) {
            let variable = this.map.getBounds();
            let top = variable._northEast.lat; //top
            let right = variable._northEast.lng; //right 
            let bottom = variable._southWest.lat; //south
            let left = variable._southWest.lng; //left 
            this.tripService.getCurrentTraffic(bottom, left, top, right)
                .then(res => {
                if (res) {
                    this.traffic = res;
                    this.getJams();
                    this.getAlerts();
                }
            });
        }
    }
    getJams() {
        this.layer_jams.clearLayers();
        if (this.traffic && this.traffic.jams) {
            for (let i = 0; i < this.traffic.jams.length; i++) {
                let line = this.traffic.jams[i].line;
                let city = this.traffic.jams[i].city;
                let street = this.traffic.jams[i].street;
                let speed = this.traffic.jams[i].speedKMH;
                switch (this.traffic.jams[i].level) {
                    case 1:
                        this.addLine(line, '#ffe000e6', 'TRÁFICO LEVE', city, street, speed);
                        break;
                    case 2:
                        this.addLine(line, '#ff8100e6', 'TRÁFICO MODERADO', city, street, speed);
                        break;
                    case 3:
                        this.addLine(line, '#ff3b00e6', 'TRÁFICO DENSO', city, street, speed);
                        break;
                    case 4:
                        this.addLine(line, '#ff0000c4', 'TRÁFICO MUY INTENSO', city, street, speed);
                        break;
                }
            }
        }
    }
    addLine(line, color, message, city, street, speed) {
        let polyline = L.polyline(this.obtenerLatLngYX(line), { color: color });
        polyline.bindPopup('<p><strong>' + message + '</strong> </p>' +
            '<p><strong>Comuna: </strong>' + city + '</p>' +
            '<p><strong>Calle:</strong> ' + street + '</p>' +
            '<p><strong>Velocidad media</strong>: ' + speed + 'KM/h</p>');
        this.layer_jams.addLayer(polyline).addTo(this.map);
    }
    getAlerts() {
        this.layer_alerts.clearLayers();
        if (this.traffic && this.traffic.alerts) {
            for (let i = 0; i < this.traffic.alerts.length; i++) {
                let lat = this.traffic.alerts[i].location.y;
                let long = this.traffic.alerts[i].location.x;
                let street = this.traffic.alerts[i].street;
                let alerttype = this.traffic.alerts[i].type;
                let alertsubtype = this.traffic.alerts[i].subtype;
                switch (alerttype) {
                    case 'ROAD_CLOSED':
                        this.addAlert(lat, long, street, 'CALLE CERRADA', 'road_closed.png');
                        break;
                    case 'ACCIDENT':
                        this.addAlert(lat, long, street, 'ACCIDENTE', 'accident.png');
                        break;
                    case 'POLICE':
                        this.addAlert(lat, long, street, 'POLICIA', 'police.png');
                        break;
                    case 'JAM':
                        switch (alertsubtype) {
                            case 'JAM_MODERATE_TRAFFIC':
                                this.addAlert(lat, long, street, 'EMBOTELLAMIENTO MODERADO', 'jam3.png');
                                break;
                            case 'JAM_STAND_STILL_TRAFFIC':
                                this.addAlert(lat, long, street, 'EMBOTELLAMIENTO PESADO', 'jam2.png');
                                break;
                            case 'JAM_HEAVY_TRAFFIC':
                                this.addAlert(lat, long, street, 'EMBOTELLAMIENTO TOTAL', 'jam.png');
                                break;
                            default:
                                //console.log("JAM NOT HANDLED:"+alertsubtype)
                                this.addAlert(lat, long, street, 'EMBOTELLAMIENTO TOTAL', 'jam.png');
                                break;
                        }
                        break;
                    case 'HAZARD':
                        this.addAlert(lat, long, street, 'OBJETO EN LA VÍA', 'hazard.png');
                        break;
                    default:
                        console.log("NOT HANDLED:" + alerttype);
                        break;
                }
            }
        }
    }
    addAlert(lat, long, street, message, image) {
        let iconAlerta = {
            icon: L.icon({
                iconSize: [45, 55],
                iconUrl: 'assets/img/waze/' + image
            })
        };
        let markerAlerta = L.marker([lat, long], iconAlerta);
        markerAlerta.bindPopup('<p><strong>' + message + '</strong></p>' +
            '<p><strong>Calle:</strong> ' + street + '</p>');
        this.layer_alerts.addLayer(markerAlerta).addTo(this.map);
    }
    obtenerLatLngYX(coordenadasACambiar) {
        let coordenadasLatLng = [];
        for (let i = 0; i < coordenadasACambiar.length; i++) {
            coordenadasLatLng.push([coordenadasACambiar[i].y, coordenadasACambiar[i].x]);
        }
        return coordenadasLatLng;
    }
    offAllLayers() {
        console.log('offAllLayers');
        this.map.removeLayer(this.layer_gps_points);
        this.map.removeLayer(this.layer_route);
        this.map.removeLayer(this.layer_route_direction);
        this.map.removeLayer(this.layer_route_realtime);
        this.map.removeLayer(this.layer_route_realtime_direction);
    }
    onAllLayers() {
        console.log('onAllLayers');
        this.showRoute();
    }
    zoomStart(evt) {
        //this.offAllLayers();
    }
    zoomEnd(evt) {
        this._center = false;
        this._overview = false;
        //this.checkAlertsZoom();
        //this.getCurrentTraffic();
        this.map_current_zoom = evt.target._zoom;
        this.getCurrentTraffic();
        this.showRoute();
    }
    moveend() {
        this._center = false;
        this._overview = false;
        this.getCurrentTraffic();
    }
}
MapRealtimeComponent.ɵfac = function MapRealtimeComponent_Factory(t) { return new (t || MapRealtimeComponent)(ɵngcc0.ɵɵdirectiveInject(ZonesService), ɵngcc0.ɵɵdirectiveInject(TripsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.TranslateService)); };
MapRealtimeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MapRealtimeComponent, selectors: [["com-lib-map-realtime"]], inputs: { realTime: "realTime", routeLine: "routeLine", alertsStatic: "alertsStatic", alertsRealTime: "alertsRealTime", zones: "zones", slider: "slider", trip_id: "trip_id" }, decls: 18, vars: 26, consts: [["id", "map", 1, "map"], [3, "background_color", "display"], [1, "leaflet-top", "leaflet-bar", "finder-map-container"], ["placeholder", "Lat , Lng", 1, "finder-input", 3, "ngModel", "ngModelChange", "paste"], ["type", "button", 1, "finder-button", 3, "click"], [1, "leaflet-top", "leaflet-bar", "ng-select-map-container"], ["bindLabel", "id", "bindValue", "id", 3, "items", "ngModel", "ngModelChange", "change"], ["ng-label-tmp", ""], ["ng-option-tmp", ""], [1, "leaflet-top", "leaflet-bar", "map-toolbox"], ["title", "Real Time Track", 1, "map-toolbox-button", "map-toolbox-button-track", 3, "ngClass", "click"], ["title", "Center On Track", 1, "map-toolbox-button", "map-toolbox-button-center", 3, "ngClass", "click"], ["title", "Tracking Overview", 1, "map-toolbox-button", "map-toolbox-button-overview", 3, "ngClass", "click"], ["title", "Route View", 1, "map-toolbox-button", 3, "ngClass", "click"], ["title", "Waze Traffic", 1, "map-toolbox-button", "map-toolbox-button-waze", 3, "ngClass", "click"], [1, "map-zoom"], [2, "display", "flex", "flex-direction", "row"], [1, "ng-select-template-color", 3, "ngStyle"], [1, "ng-select-template-text"]], template: function MapRealtimeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "com-lib-track-loading", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "input", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function MapRealtimeComponent_Template_input_ngModelChange_3_listener($event) { return ctx.finder_lat_lng = $event; })("paste", function MapRealtimeComponent_Template_input_paste_3_listener($event) { return ctx.finderPaste($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "input", 4);
        ɵngcc0.ɵɵlistener("click", function MapRealtimeComponent_Template_input_click_4_listener() { return ctx.finderClick(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "ng-select", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function MapRealtimeComponent_Template_ng_select_ngModelChange_6_listener($event) { return ctx.gps_signal_id_selected = $event; })("change", function MapRealtimeComponent_Template_ng_select_change_6_listener($event) { return ctx.onChange($event); });
        ɵngcc0.ɵɵtemplate(7, MapRealtimeComponent_ng_template_7_Template, 4, 2, "ng-template", 7);
        ɵngcc0.ɵɵtemplate(8, MapRealtimeComponent_ng_template_8_Template, 4, 2, "ng-template", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 9);
        ɵngcc0.ɵɵelementStart(10, "a", 10);
        ɵngcc0.ɵɵlistener("click", function MapRealtimeComponent_Template_a_click_10_listener() { return ctx.activeTrack(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "a", 11);
        ɵngcc0.ɵɵlistener("click", function MapRealtimeComponent_Template_a_click_11_listener() { return ctx.center(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "a", 12);
        ɵngcc0.ɵɵlistener("click", function MapRealtimeComponent_Template_a_click_12_listener() { return ctx.overview(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "a", 13);
        ɵngcc0.ɵɵlistener("click", function MapRealtimeComponent_Template_a_click_13_listener() { return ctx.routeView(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "a", 14);
        ɵngcc0.ɵɵlistener("click", function MapRealtimeComponent_Template_a_click_14_listener() { return ctx.showTraffic(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 15);
        ɵngcc0.ɵɵelementStart(16, "span");
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("display", ctx.display_loading);
        ɵngcc0.ɵɵproperty("background_color", "rgba(0,0,0,0.8)");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.finder_lat_lng);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("items", ctx.gps_signals_ids)("ngModel", ctx.gps_signal_id_selected);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(11, _c4, ctx._track, ctx.slider));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(14, _c4, ctx._center, ctx.slider));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(17, _c5, ctx._overview));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(19, _c6, ctx._showRoute, ctx._showRoute, !ctx._showRoute));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(23, _c4, ctx._showTraffic, ctx.slider));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.map_current_zoom);
    } }, directives: function () { return [TrackLoadingComponent, ɵngcc9.DefaultValueAccessor, ɵngcc9.NgControlStatus, ɵngcc9.NgModel, ɵngcc13.NgSelectComponent, ɵngcc13.ɵh, ɵngcc13.ɵf, ɵngcc5.NgClass, ɵngcc5.NgStyle]; }, styles: [".iconClassMap{background:transparent}  .mysecondclass{position:absolute!important;margin-left:50%!important;margin-top:50%!important;transform:translate(-50%,-50%)!important;color:#fff;font-weight:700}  .leaflet-popup-content-wrapper{border-radius:3px!important}  .leaflet-container a.leaflet-popup-close-button{top:2px!important;right:2px!important}#map[_ngcontent-%COMP%]{height:100%;width:100%}[_nghost-%COMP%]     .leaflet-left{width:calc(100% - 280px)!important}[_nghost-%COMP%]     .leaflet-timeline-control{background:rgba(0,0,0,.6);border-radius:10px;position:relative;height:19px;border:none;width:100%;margin:0 0 10px 140px}[_nghost-%COMP%]     .sldr-ctrl-container{width:320px!important;position:absolute;left:calc(50% - 160px);top:-22px;background:rgba(0,0,0,.62);color:#fff;border-radius:10px}[_nghost-%COMP%]     .time-slider{position:absolute;top:2px;left:20px;width:calc(100% - 40px)!important}[_nghost-%COMP%]     .button-container{width:calc(100% - 40px);top:2px;left:20px;position:absolute;outline:none;height:0;visibility:hidden}div.map[_ngcontent-%COMP%]{height:580px;width:100%}.checkMap[_ngcontent-%COMP%]{align-self:center;margin-right:5px}.labelCheckBox[_ngcontent-%COMP%]{align-content:center;color:#000;font-family:Mark,Arial,Helvetica,Helvetica Neue,sans-serif}.btnStyle1[_ngcontent-%COMP%]{height:20px;width:80px;box-shadow:inset 0 1px 0 0 #bbdaf7;background:linear-gradient(180deg,#79bbff 5%,#378de5);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#79bbff\",endColorstr=\"#378de5\",GradientType=0);background-color:#79bbff;border-radius:6px;border:1px solid #84bbf3;display:inline-block;cursor:pointer;color:#fff;font-family:Arial;font-size:10px;font-weight:700;padding:3px 12px;text-decoration:none;text-shadow:0 1px 0 #528ecc}.btnStyle1[_ngcontent-%COMP%]:hover{background:linear-gradient(180deg,#378de5 5%,#79bbff);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#378de5\",endColorstr=\"#79bbff\",GradientType=0);background-color:#378de5}.btnStyle1[_ngcontent-%COMP%]:active{position:relative;top:1px}.btnStyle2[_ngcontent-%COMP%]{height:20px;box-shadow:inset 0 1px 0 0 #fce2c1;background:linear-gradient(180deg,#ffc477 5%,#fb9e25);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ffc477\",endColorstr=\"#fb9e25\",GradientType=0);background-color:#ffc477;border-radius:6px;border:1px solid #eeb44f;display:inline-block;cursor:pointer;color:#fff;font-family:Arial;font-size:10px;font-weight:700;padding:3px 12px;text-decoration:none;text-shadow:0 1px 0 #cc9f52}.btnStyle2[_ngcontent-%COMP%]:hover{background:linear-gradient(180deg,#fb9e25 5%,#ffc477);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#fb9e25\",endColorstr=\"#ffc477\",GradientType=0);background-color:#fb9e25}.btnStyle2[_ngcontent-%COMP%]:active{position:relative;top:1px}.map-toolbox[_ngcontent-%COMP%]{background:#fff;left:2px;top:110px;width:40px!important}.map-toolbox-button[_ngcontent-%COMP%]{width:30px;height:30px;margin:5px;background-size:20px 20px!important;border:2px solid #cecece!important;background-color:#e9e9e9!important;border-radius:8px;pointer-events:auto}.map-toolbox-button-hidden[_ngcontent-%COMP%]{display:none}.map-toolbox-button-active[_ngcontent-%COMP%]{border:2px solid #00dbff!important}.map-toolbox-button[_ngcontent-%COMP%]:hover{margin:6px;border:1px solid #fff;width:28px;height:28px}.map-toolbox-button[_ngcontent-%COMP%]:active{margin:6px;border:1px solid #ff002f!important;background-color:#900000!important;filter:invert(1);width:28px;height:28px}.map-toolbox-button-track[_ngcontent-%COMP%]{background:url(/assets/trips/map-realtime/toolbox/track.svg) no-repeat 50%;background-size:16px 16px!important}.map-toolbox-button-center[_ngcontent-%COMP%]{background:url(/assets/trips/map-realtime/toolbox/center.svg) no-repeat 50%}.map-toolbox-button-overview[_ngcontent-%COMP%]{background:url(/assets/trips/map-realtime/toolbox/overview.svg) no-repeat 50%}.map-toolbox-button-route[_ngcontent-%COMP%]{background:url(/assets/trips/map-realtime/toolbox/route.svg) no-repeat 50%}.map-toolbox-button-route-dots[_ngcontent-%COMP%]{background:url(/assets/trips/map-realtime/toolbox/route_dots.svg) no-repeat 50%}.map-toolbox-button-waze[_ngcontent-%COMP%]{background:url(/assets/trips/map-realtime/toolbox/waze.svg) no-repeat 50%}.map-zoom[_ngcontent-%COMP%]{position:absolute;right:10px;top:10px;color:#fff;background:rgba(0,0,0,.16862745098039217);border-radius:10px;padding:4px;z-index:999;text-align:right}[_nghost-%COMP%]     .ng-select{position:absolute;top:2px;left:2px;bottom:2px;right:2px;background-color:#fff}[_nghost-%COMP%]     .ng-select-container{min-height:25px!important;max-height:25px!important}[_nghost-%COMP%]     .ng-input{left:24px!important}[_nghost-%COMP%]     .ng-dropdown-panel{background-color:hsla(0,0%,100%,.45098039215686275)}[_nghost-%COMP%]     .ng-dropdown-panel{background:#fff;top:21px}.ng-select-map-container[_ngcontent-%COMP%]{top:10px;left:50px;width:115px;height:30px;pointer-events:auto;position:absolute}.ng-select-template-color[_ngcontent-%COMP%]{width:10px;height:10px;margin:4px 0 0 4px}.ng-select-template-text[_ngcontent-%COMP%]{margin-left:4px}.finder-map-container[_ngcontent-%COMP%]{top:10px;left:200px;height:24px;pointer-events:auto;position:absolute;display:flex;background:#fff;padding:2px}.finder-input[_ngcontent-%COMP%]{width:150px;font-size:12px;text-align:center}.finder-button[_ngcontent-%COMP%]{width:24px;height:20px;margin:0 2px 0 4px;background:url(/assets/trips/map-realtime/toolbox/finder.svg) 50% no-repeat;background-size:10px 10px}"] });
MapRealtimeComponent.ctorParameters = () => [
    { type: ZonesService },
    { type: TripsService },
    { type: TranslateService }
];
MapRealtimeComponent.propDecorators = {
    trip_id: [{ type: Input }],
    realTime: [{ type: Input }],
    routeLine: [{ type: Input }],
    alertsStatic: [{ type: Input }],
    alertsRealTime: [{ type: Input }],
    zones: [{ type: Input }],
    slider: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MapRealtimeComponent, [{
        type: Component,
        args: [{
                selector: 'com-lib-map-realtime',
                template: "<div class=\"map\" id=\"map\">\n   <com-lib-track-loading \n    [background_color]=\"'rgba(0,0,0,0.8)'\"\n    display=\"{{display_loading}}\"\n    ></com-lib-track-loading>\n\n    <!-- <div class=\"leaflet-bottom leaflet-left\">\n        <form [formGroup]=\"wazeForm\">\n            <label class=\"labelCheckBox\">\n                <input type=\"checkbox\" class=\"checkMap span3 leaflet-control\" formControlName=\"check_trafico\" (ngModelChange)=\"onFilterChange()\">\n                {{'trip.traffic' | translate}}\n            </label><br>\n            <label class=\"labelCheckBox\">\n                <input type=\"checkbox\"  class=\"checkMap span3 leaflet-control\" formControlName=\"check_alertas\" (ngModelChange)=\"onFilterChange()\">\n                {{'trip.traffic_reports' | translate}}\n            </label>\n        </form>\n        <button type=\"button\" id=\"Btn1\" (click)=\"center()\" class=\"btnStyle1 span3 leaflet-control\">{{'trip.center' | translate}}</button>\n        <button type=\"button\" id=\"Btn2\" (click)=\"overview()\" class=\"btnStyle2 span3 leaflet-control\">{{'trip.overview' | translate}}</button>\n    </div> -->\n    <div class=\"leaflet-top leaflet-bar finder-map-container\">\n        <input [(ngModel)]=\"finder_lat_lng\" (paste)=\"finderPaste($event)\" class=\"finder-input\" placeholder=\"Lat , Lng\">\n        <input type=\"button\" (click)=\"finderClick()\" class=\"finder-button\" >\n    </div>\n    <div class=\"leaflet-top leaflet-bar ng-select-map-container\">\n        <ng-select [items]=\"gps_signals_ids\" [(ngModel)]=\"gps_signal_id_selected\" bindLabel=\"id\" bindValue=\"id\"  (change)=\"onChange($event)\">\n            <ng-template ng-label-tmp let-item=\"item\">\n                <div style=\"display:flex;flex-direction:row\">\n                    <div class=\"ng-select-template-color\" [ngStyle]=\"item.style\"></div>\n                    <span class=\"ng-select-template-text\">{{item.id}}</span>\n                </div>\n            </ng-template>\n            <ng-template ng-option-tmp let-item=\"item\" let-index=\"index\" let-search=\"searchTerm\">\n                <div style=\"display:flex;flex-direction:row\">\n                    <div class=\"ng-select-template-color\" [ngStyle]=\"item.style\"></div>\n                    <span class=\"ng-select-template-text\" >{{item.id}}</span>\n                </div>\n            </ng-template>\n        </ng-select>\n    </div>\n    <div class=\"leaflet-top leaflet-bar map-toolbox\">\n            <a title=\"Real Time Track\" class=\"map-toolbox-button map-toolbox-button-track\" (click)=\"activeTrack()\"\n            [ngClass]=\"{'map-toolbox-button-active': _track,\n                        'map-toolbox-button-hidden':slider}\"></a>\n            <a title=\"Center On Track\" class=\"map-toolbox-button map-toolbox-button-center\" (click)=\"center()\"\n            [ngClass]=\"{'map-toolbox-button-active': _center,\n                        'map-toolbox-button-hidden':slider}\"></a>\n            <a title=\"Tracking Overview\" class=\"map-toolbox-button map-toolbox-button-overview\" (click)=\"overview()\"\n            [ngClass]=\"{'map-toolbox-button-active': _overview}\"></a>\n            <a title=\"Route View\" class=\"map-toolbox-button \" (click)=\"routeView()\"\n            [ngClass]=\"{'map-toolbox-button-active': _showRoute,\n                        'map-toolbox-button-route': _showRoute,\n                        'map-toolbox-button-route-dots': !_showRoute\n                        }\"></a>\n            <a title=\"Waze Traffic\"  class=\"map-toolbox-button  map-toolbox-button-waze\" (click)=\"showTraffic()\"\n            [ngClass]=\"{'map-toolbox-button-active': _showTraffic,\n                        'map-toolbox-button-hidden':slider}\"></a>\n    </div>\n    <div class=\"map-zoom\">\n        <span>{{map_current_zoom}}</span>\n    </div>\n</div>",
                styles: ["::ng-deep .iconClassMap{background:transparent}::ng-deep .mysecondclass{position:absolute!important;margin-left:50%!important;margin-top:50%!important;transform:translate(-50%,-50%)!important;color:#fff;font-weight:700}::ng-deep .leaflet-popup-content-wrapper{border-radius:3px!important}::ng-deep .leaflet-container a.leaflet-popup-close-button{top:2px!important;right:2px!important}#map{height:100%;width:100%}:host ::ng-deep .leaflet-left{width:calc(100% - 280px)!important}:host ::ng-deep .leaflet-timeline-control{background:rgba(0,0,0,.6);border-radius:10px;position:relative;height:19px;border:none;width:100%;margin:0 0 10px 140px}:host ::ng-deep .sldr-ctrl-container{width:320px!important;position:absolute;left:calc(50% - 160px);top:-22px;background:rgba(0,0,0,.62);color:#fff;border-radius:10px}:host ::ng-deep .time-slider{position:absolute;top:2px;left:20px;width:calc(100% - 40px)!important}:host ::ng-deep .button-container{width:calc(100% - 40px);top:2px;left:20px;position:absolute;outline:none;height:0;visibility:hidden}div.map{height:580px;width:100%}.checkMap{align-self:center;margin-right:5px}.labelCheckBox{align-content:center;color:#000;font-family:Mark,Arial,Helvetica,Helvetica Neue,sans-serif}.btnStyle1{height:20px;width:80px;box-shadow:inset 0 1px 0 0 #bbdaf7;background:linear-gradient(180deg,#79bbff 5%,#378de5);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#79bbff\",endColorstr=\"#378de5\",GradientType=0);background-color:#79bbff;border-radius:6px;border:1px solid #84bbf3;display:inline-block;cursor:pointer;color:#fff;font-family:Arial;font-size:10px;font-weight:700;padding:3px 12px;text-decoration:none;text-shadow:0 1px 0 #528ecc}.btnStyle1:hover{background:linear-gradient(180deg,#378de5 5%,#79bbff);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#378de5\",endColorstr=\"#79bbff\",GradientType=0);background-color:#378de5}.btnStyle1:active{position:relative;top:1px}.btnStyle2{height:20px;box-shadow:inset 0 1px 0 0 #fce2c1;background:linear-gradient(180deg,#ffc477 5%,#fb9e25);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ffc477\",endColorstr=\"#fb9e25\",GradientType=0);background-color:#ffc477;border-radius:6px;border:1px solid #eeb44f;display:inline-block;cursor:pointer;color:#fff;font-family:Arial;font-size:10px;font-weight:700;padding:3px 12px;text-decoration:none;text-shadow:0 1px 0 #cc9f52}.btnStyle2:hover{background:linear-gradient(180deg,#fb9e25 5%,#ffc477);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#fb9e25\",endColorstr=\"#ffc477\",GradientType=0);background-color:#fb9e25}.btnStyle2:active{position:relative;top:1px}.map-toolbox{background:#fff;left:2px;top:110px;width:40px!important}.map-toolbox-button{width:30px;height:30px;margin:5px;background-size:20px 20px!important;border:2px solid #cecece!important;background-color:#e9e9e9!important;border-radius:8px;pointer-events:auto}.map-toolbox-button-hidden{display:none}.map-toolbox-button-active{border:2px solid #00dbff!important}.map-toolbox-button:hover{margin:6px;border:1px solid #fff;width:28px;height:28px}.map-toolbox-button:active{margin:6px;border:1px solid #ff002f!important;background-color:#900000!important;filter:invert(1);width:28px;height:28px}.map-toolbox-button-track{background:url(/assets/trips/map-realtime/toolbox/track.svg) no-repeat 50%;background-size:16px 16px!important}.map-toolbox-button-center{background:url(/assets/trips/map-realtime/toolbox/center.svg) no-repeat 50%}.map-toolbox-button-overview{background:url(/assets/trips/map-realtime/toolbox/overview.svg) no-repeat 50%}.map-toolbox-button-route{background:url(/assets/trips/map-realtime/toolbox/route.svg) no-repeat 50%}.map-toolbox-button-route-dots{background:url(/assets/trips/map-realtime/toolbox/route_dots.svg) no-repeat 50%}.map-toolbox-button-waze{background:url(/assets/trips/map-realtime/toolbox/waze.svg) no-repeat 50%}.map-zoom{position:absolute;right:10px;top:10px;color:#fff;background:rgba(0,0,0,.16862745098039217);border-radius:10px;padding:4px;z-index:999;text-align:right}:host ::ng-deep .ng-select{position:absolute;top:2px;left:2px;bottom:2px;right:2px;background-color:#fff}:host ::ng-deep .ng-select-container{min-height:25px!important;max-height:25px!important}:host ::ng-deep .ng-input{left:24px!important}:host ::ng-deep .ng-dropdown-panel{background-color:hsla(0,0%,100%,.45098039215686275)}:host ::ng-deep .ng-dropdown-panel{background:#fff;top:21px}.ng-select-map-container{top:10px;left:50px;width:115px;height:30px;pointer-events:auto;position:absolute}.ng-select-template-color{width:10px;height:10px;margin:4px 0 0 4px}.ng-select-template-text{margin-left:4px}.finder-map-container{top:10px;left:200px;height:24px;pointer-events:auto;position:absolute;display:flex;background:#fff;padding:2px}.finder-input{width:150px;font-size:12px;text-align:center}.finder-button{width:24px;height:20px;margin:0 2px 0 4px;background:url(/assets/trips/map-realtime/toolbox/finder.svg) 50% no-repeat;background-size:10px 10px}"]
            }]
    }], function () { return [{ type: ZonesService }, { type: TripsService }, { type: ɵngcc4.TranslateService }]; }, { realTime: [{
            type: Input
        }], routeLine: [{
            type: Input
        }], alertsStatic: [{
            type: Input
        }], alertsRealTime: [{
            type: Input
        }], zones: [{
            type: Input
        }], slider: [{
            type: Input
        }], trip_id: [{
            type: Input
        }] }); })();

const routes = [];
class CommonsLibRoutingModule {
}
CommonsLibRoutingModule.ɵfac = function CommonsLibRoutingModule_Factory(t) { return new (t || CommonsLibRoutingModule)(); };
CommonsLibRoutingModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CommonsLibRoutingModule });
CommonsLibRoutingModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[RouterModule.forChild(routes)], RouterModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CommonsLibRoutingModule, { imports: function () { return [ɵngcc3.RouterModule]; }, exports: function () { return [RouterModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CommonsLibRoutingModule, [{
        type: NgModule,
        args: [{
                imports: [RouterModule.forChild(routes)],
                exports: [RouterModule]
            }]
    }], null, null); })();

class TrackLoadingComponent {
    constructor() {
        this._display = false;
        this.background_color = 'black';
    }
    set display(val) {
        val = (val === "true" ? true : (val === "false" ? false : val));
        this._display = val;
        console.log('setting display:' + val);
    }
    get display() {
        return this._display;
    }
    ngOnInit() {
        document.documentElement.style.setProperty('--loading-background-color', this.background_color);
    }
}
TrackLoadingComponent.ɵfac = function TrackLoadingComponent_Factory(t) { return new (t || TrackLoadingComponent)(); };
TrackLoadingComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TrackLoadingComponent, selectors: [["com-lib-track-loading"]], inputs: { background_color: "background_color", display: "display" }, decls: 11, vars: 3, consts: [[1, "loading-screen", 3, "ngClass"], [1, "loading-logo-container"], ["src", "assets/logos/main-logo.png", "alt", "ALTO", 1, "loading-logo"], [1, "loading-logo-text"], [1, "dots-loader"], [1, "dots-loader__item"]], template: function TrackLoadingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "img", 2);
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵtext(4, "MOVUP");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelement(6, "span", 5);
        ɵngcc0.ɵɵelement(7, "span", 5);
        ɵngcc0.ɵɵelement(8, "span", 5);
        ɵngcc0.ɵɵelement(9, "span", 5);
        ɵngcc0.ɵɵelement(10, "span", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c7, !ctx._display));
    } }, directives: [ɵngcc5.NgClass], styles: [".TruckLoader[_ngcontent-%COMP%]{position:relative;width:150px;height:47px;background:#444;animation:put-put 2s infinite,move-truck 10s infinite;background-size:100% auto;border-radius:4px;-webkit-box-reflect:below 15px -webkit-gradient(linear,left top,left bottom,from(transparent),color-stop(.1,transparent),to(hsla(0,0%,100%,.1)))}.TruckLoader[_ngcontent-%COMP%]:before{left:6px}.TruckLoader[_ngcontent-%COMP%]:after{right:6px}.TruckLoader[_ngcontent-%COMP%]:after, .TruckLoader[_ngcontent-%COMP%]:before{content:\"\";display:block;border-radius:50%;width:16px;height:16px;border:2px solid #fff;background:#333;position:absolute;bottom:-10px}.TruckLoader-cab[_ngcontent-%COMP%]{position:absolute;left:-69px;bottom:0;width:57px;height:21px;background:#333;border-radius:23% 0 4px 4px;-webkit-box-reflect:below 15px -webkit-gradient(linear,left top,left bottom,from(transparent),color-stop(.1,transparent),to(hsla(0,0%,100%,.1)))}.TruckLoader-cab[_ngcontent-%COMP%]:before{width:20px;height:15px;top:-15px;right:0;border-radius:100% 0 0 0}.TruckLoader-cab[_ngcontent-%COMP%]:after{border-radius:50%;width:16px;height:16px;background:#444;left:5px;border:2px solid #fff;background:#333;position:absolute;bottom:-10px}.TruckLoader-cab[_ngcontent-%COMP%]:after, .TruckLoader-cab[_ngcontent-%COMP%]:before{position:absolute;content:\"\";display:block;background:#333}.TruckLoader-cab-bed[_ngcontent-%COMP%]{position:absolute;left:-35px;bottom:0;width:28px;height:40px;background:#333}.TruckLoader-cab-bed[_ngcontent-%COMP%]:before{content:\"\";position:absolute;top:-23px;left:29px;width:5px;height:63px;background:#333}.TruckLoader-smoke[_ngcontent-%COMP%]{animation:smoke-1 2s infinite}.TruckLoader-smoke[_ngcontent-%COMP%], .TruckLoader-smoke[_ngcontent-%COMP%]:after, .TruckLoader-smoke[_ngcontent-%COMP%]:before{position:absolute;content:\"\";display:block;width:10px;height:10px;right:-1px;bottom:-5px;border-radius:50%;background:#333}.TruckLoader-smoke[_ngcontent-%COMP%]:before{animation:smoke-3 4s infinite}.TruckLoader-smoke[_ngcontent-%COMP%]:after{animation:smoke-2 3s infinite}.track[_ngcontent-%COMP%]{position:relative}.track-logo[_ngcontent-%COMP%]{width:60px;margin:4px 0 0 14px}.track-text[_ngcontent-%COMP%]{color:#fff;font-size:12px;position:absolute;top:16px;left:76px}.loading-screen[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;justify-content:center;background-color:var(--loading-background-color);height:100%;z-index:9999;position:absolute;top:0;left:0;right:0;bottom:0}.loading-logo-container[_ngcontent-%COMP%]{display:flex;flex-direction:row}.loading-logo-text[_ngcontent-%COMP%]{color:#fff;font-size:28px;font-weight:700;font-family:Mark,Arial,Helvetica,Helvetica Neue,sans-serif;margin:4px 0 0 5px}.loading-logo[_ngcontent-%COMP%]{max-width:150px;margin:0 auto;animation:bouncing-logo 1.5s cubic-bezier(.4,0,.6,1) infinite}.loading-screen-hide[_ngcontent-%COMP%]{display:none}.dots-loader[_ngcontent-%COMP%]{padding-left:24px}.dots-loader__item[_ngcontent-%COMP%]{background-color:#fff;display:inline-block;width:8px;height:8px;border-radius:50%;margin:20px 4px;animation:scale 1.1s cubic-bezier(.4,0,.6,1) infinite alternate}.dots-loader__item[_ngcontent-%COMP%]:nth-child(2){animation-delay:.1s}.dots-loader__item[_ngcontent-%COMP%]:nth-child(3){animation-delay:.2s}.dots-loader__item[_ngcontent-%COMP%]:nth-child(4){animation-delay:.3s}.dots-loader__item[_ngcontent-%COMP%]:nth-child(5){animation-delay:.4s}@keyframes scale{0%{transform:scale(.75);opacity:0}50%{transform:scale(1.3);opacity:1}to{transform:scale(1);opacity:0}}"] });
TrackLoadingComponent.ctorParameters = () => [];
TrackLoadingComponent.propDecorators = {
    background_color: [{ type: Input }],
    display: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TrackLoadingComponent, [{
        type: Component,
        args: [{
                selector: 'com-lib-track-loading',
                template: "\n<div class=\"loading-screen\"\n    [ngClass]=\"{'loading-screen-hide': !_display}\"\n>\n        <div class=\"loading-logo-container\">\n            <img class=\"loading-logo\" src=\"assets/logos/main-logo.png\" alt=\"ALTO\">\n            <span class=\"loading-logo-text\">MOVUP</span>\n        </div>\n        <div class=\"dots-loader\">\n            <span class=\"dots-loader__item\"></span>\n            <span class=\"dots-loader__item\"></span>\n            <span class=\"dots-loader__item\"></span>\n            <span class=\"dots-loader__item\"></span>\n            <span class=\"dots-loader__item\"></span>\n        </div>\n</div>",
                styles: [".TruckLoader{position:relative;width:150px;height:47px;background:#444;animation:put-put 2s infinite,move-truck 10s infinite;background-size:100% auto;border-radius:4px;-webkit-box-reflect:below 15px -webkit-gradient(linear,left top,left bottom,from(transparent),color-stop(.1,transparent),to(hsla(0,0%,100%,.1)))}.TruckLoader:before{left:6px}.TruckLoader:after{right:6px}.TruckLoader:after,.TruckLoader:before{content:\"\";display:block;border-radius:50%;width:16px;height:16px;border:2px solid #fff;background:#333;position:absolute;bottom:-10px}.TruckLoader-cab{position:absolute;left:-69px;bottom:0;width:57px;height:21px;background:#333;border-radius:23% 0 4px 4px;-webkit-box-reflect:below 15px -webkit-gradient(linear,left top,left bottom,from(transparent),color-stop(.1,transparent),to(hsla(0,0%,100%,.1)))}.TruckLoader-cab:before{width:20px;height:15px;top:-15px;right:0;border-radius:100% 0 0 0}.TruckLoader-cab:after{border-radius:50%;width:16px;height:16px;background:#444;left:5px;border:2px solid #fff;background:#333;position:absolute;bottom:-10px}.TruckLoader-cab:after,.TruckLoader-cab:before{position:absolute;content:\"\";display:block;background:#333}.TruckLoader-cab-bed{position:absolute;left:-35px;bottom:0;width:28px;height:40px;background:#333}.TruckLoader-cab-bed:before{content:\"\";position:absolute;top:-23px;left:29px;width:5px;height:63px;background:#333}.TruckLoader-smoke{animation:smoke-1 2s infinite}.TruckLoader-smoke,.TruckLoader-smoke:after,.TruckLoader-smoke:before{position:absolute;content:\"\";display:block;width:10px;height:10px;right:-1px;bottom:-5px;border-radius:50%;background:#333}.TruckLoader-smoke:before{animation:smoke-3 4s infinite}.TruckLoader-smoke:after{animation:smoke-2 3s infinite}.track{position:relative}.track-logo{width:60px;margin:4px 0 0 14px}.track-text{color:#fff;font-size:12px;position:absolute;top:16px;left:76px}.loading-screen{display:flex;flex-direction:column;align-items:center;justify-content:center;background-color:var(--loading-background-color);height:100%;z-index:9999;position:absolute;top:0;left:0;right:0;bottom:0}.loading-logo-container{display:flex;flex-direction:row}.loading-logo-text{color:#fff;font-size:28px;font-weight:700;font-family:Mark,Arial,Helvetica,Helvetica Neue,sans-serif;margin:4px 0 0 5px}.loading-logo{max-width:150px;margin:0 auto;animation:bouncing-logo 1.5s cubic-bezier(.4,0,.6,1) infinite}.loading-screen-hide{display:none}.dots-loader{padding-left:24px}.dots-loader__item{background-color:#fff;display:inline-block;width:8px;height:8px;border-radius:50%;margin:20px 4px;animation:scale 1.1s cubic-bezier(.4,0,.6,1) infinite alternate}.dots-loader__item:nth-child(2){animation-delay:.1s}.dots-loader__item:nth-child(3){animation-delay:.2s}.dots-loader__item:nth-child(4){animation-delay:.3s}.dots-loader__item:nth-child(5){animation-delay:.4s}@keyframes scale{0%{transform:scale(.75);opacity:0}50%{transform:scale(1.3);opacity:1}to{transform:scale(1);opacity:0}}"]
            }]
    }], function () { return []; }, { background_color: [{
            type: Input
        }], display: [{
            type: Input
        }] }); })();

class MessageErrorComponent {
    constructor(activeModal, ref) {
        this.activeModal = activeModal;
        this.ref = ref;
        this._title = "Error";
        this._sub_title = "";
        this._message = "";
        this.reasonStatus = null;
        this.lenguage = false;
        this.cancelButton = false;
        this.textCancelButton = "Cancelar";
        this.textOkButton = "Aceptar";
        this.id = "";
    }
    set type(type) {
        if (type == "question") {
            this._title = 'modal.question';
        }
        if (type == "confirmation") {
            this._title = 'modal.confirmation';
        }
    }
    set sub_title(sub_title) {
        if (sub_title != undefined && sub_title.length > 0)
            this._sub_title = sub_title;
        //else
        //this._sub_title = 'Parece que hay un problema de conexión.'
    }
    ;
    set message(message) {
        if (message != undefined && message.length > 0)
            this._message = message;
        else
            this._message = 'Restablezca su conexión para guardar sus cambios.';
    }
    ;
    set reason(reason) {
        this.reasonStatus = reason.status;
    }
    ngOnInit() {
        if (this.openModal) {
            this.activeModal.close();
        }
        this.openModal = true;
    }
    ngOnDestroy() {
        this.openModal = false;
        this.ref.detach();
    }
    save() {
        this.activeModal.close(this.id);
        this.openModal = false;
    }
    cancel() {
        this.activeModal.dismiss(this.id);
        this.openModal = false;
    }
    set openModal(open) {
        if (open === undefined)
            return;
        localStorage.setItem("open_modal", JSON.stringify(open));
    }
    get openModal() {
        return JSON.parse(localStorage.getItem("open_modal"));
    }
}
MessageErrorComponent.ɵfac = function MessageErrorComponent_Factory(t) { return new (t || MessageErrorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc12.NgbActiveModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
MessageErrorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MessageErrorComponent, selectors: [["com-lib-message-error"]], inputs: { lenguage: "lenguage", cancelButton: "cancelButton", textCancelButton: "textCancelButton", textOkButton: "textOkButton", id: "id", type: "type", sub_title: "sub_title", message: "message", reason: "reason" }, decls: 17, vars: 10, consts: [[1, "modal-header"], ["class", "modal-header__title", 4, "ngIf"], ["type", "button", "aria-label", "Close", 1, "btn", "btn-xs", "modal-close", 3, "click"], [1, "fa", "fa-close"], [1, "modal-body"], ["class", "mb-0", 4, "ngIf"], [1, "modal-footer"], ["type", "button", "class", "btn btn-secondary", 3, "click", 4, "ngIf"], ["type", "button", "class", "modal-btn btn btn-primary", 3, "click", 4, "ngIf"], [1, "modal-header__title"], [1, "mb-0"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"], ["type", "button", 1, "modal-btn", "btn", "btn-primary", 3, "click"]], template: function MessageErrorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵtemplate(2, MessageErrorComponent_h2_2_Template, 2, 1, "h2", 1);
        ɵngcc0.ɵɵtemplate(3, MessageErrorComponent_h2_3_Template, 3, 3, "h2", 1);
        ɵngcc0.ɵɵelementStart(4, "button", 2);
        ɵngcc0.ɵɵlistener("click", function MessageErrorComponent_Template_button_click_4_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵelement(5, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "div");
        ɵngcc0.ɵɵtemplate(8, MessageErrorComponent_p_8_Template, 2, 1, "p", 5);
        ɵngcc0.ɵɵtemplate(9, MessageErrorComponent_p_9_Template, 2, 1, "p", 5);
        ɵngcc0.ɵɵtemplate(10, MessageErrorComponent_p_10_Template, 3, 3, "p", 5);
        ɵngcc0.ɵɵtemplate(11, MessageErrorComponent_p_11_Template, 3, 3, "p", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 6);
        ɵngcc0.ɵɵtemplate(13, MessageErrorComponent_button_13_Template, 2, 1, "button", 7);
        ɵngcc0.ɵɵtemplate(14, MessageErrorComponent_button_14_Template, 3, 3, "button", 7);
        ɵngcc0.ɵɵtemplate(15, MessageErrorComponent_button_15_Template, 2, 1, "button", 8);
        ɵngcc0.ɵɵtemplate(16, MessageErrorComponent_button_16_Template, 3, 3, "button", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.lenguage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.lenguage);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.lenguage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.lenguage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.lenguage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.lenguage);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.cancelButton && !ctx.lenguage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.cancelButton && ctx.lenguage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.lenguage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.lenguage);
    } }, directives: [ɵngcc5.NgIf], pipes: [ɵngcc4.TranslatePipe], styles: [""] });
MessageErrorComponent.ctorParameters = () => [
    { type: NgbActiveModal },
    { type: ChangeDetectorRef }
];
MessageErrorComponent.propDecorators = {
    lenguage: [{ type: Input }],
    cancelButton: [{ type: Input }],
    textCancelButton: [{ type: Input }],
    textOkButton: [{ type: Input }],
    id: [{ type: Input }],
    type: [{ type: Input }],
    sub_title: [{ type: Input }],
    message: [{ type: Input }],
    reason: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MessageErrorComponent, [{
        type: Component,
        args: [{
                selector: 'com-lib-message-error',
                template: "<div>\n    <div class=\"modal-header\">\n        <h2 *ngIf=\"!lenguage\" class=\"modal-header__title\">{{_title}}</h2>\n        <h2 *ngIf=\"lenguage\" class=\"modal-header__title\">{{_title | translate}}</h2>\n        <button type=\"button\" class=\"btn btn-xs modal-close\" aria-label=\"Close\" (click)=\"cancel()\">\n            <i class=\"fa fa-close\"></i>\n        </button>\n    </div>\n\n    <div class=\"modal-body\">\n        <div>\n            <p *ngIf=\"!lenguage\" class=\"mb-0\">{{_sub_title}}</p>\n            <p *ngIf=\"!lenguage\" class=\"mb-0\">{{_message}}</p>\n            <p *ngIf=\"lenguage\" class=\"mb-0\">{{_sub_title | translate}}</p>\n            <p *ngIf=\"lenguage\" class=\"mb-0\">{{_message | translate}}</p>\n        </div>\n    </div>\n        \n    <div class=\"modal-footer\">\n        <button *ngIf=\"cancelButton && !lenguage\" type=\"button\" class=\"btn btn-secondary\" (click)=\"cancel()\">{{ textCancelButton}}</button>\n        <button *ngIf=\"cancelButton && lenguage\" type=\"button\" class=\"btn btn-secondary\" (click)=\"cancel()\">{{ textCancelButton | translate}}</button>\n\n        <button *ngIf=\"!lenguage\" type=\"button\" class=\"modal-btn btn btn-primary\" (click)=\"save()\">{{ textOkButton }}</button>\n        <button *ngIf=\"lenguage\" type=\"button\" class=\"modal-btn btn btn-primary\" (click)=\"save()\">{{ textOkButton | translate}}</button>\n    </div>\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc12.NgbActiveModal }, { type: ɵngcc0.ChangeDetectorRef }]; }, { lenguage: [{
            type: Input
        }], cancelButton: [{
            type: Input
        }], textCancelButton: [{
            type: Input
        }], textOkButton: [{
            type: Input
        }], id: [{
            type: Input
        }], type: [{
            type: Input
        }], sub_title: [{
            type: Input
        }], message: [{
            type: Input
        }], reason: [{
            type: Input
        }] }); })();

class ManejoFiltradoSenalesGps {
    constructor() {
        this.opcionElegida = 'mas significativas';
        this.limiteInferior = '00';
        this.limiteSuperior = '01';
        this.listadoPatentes = [];
        this.listadoDispositivosGps = [];
        this.separador = '###';
        this.usarColoresDelSelect = false;
        this.colorDelSelect = '';
        this.patenteDefault = '';
        this.gpsDefault = '';
        this.gps_signal_gps_ids = [];
        this.todosLosPuntosSeHanCargado = false;
        this.marcadoresVerdaderos = [];
        this.listaDispositivosGPS = [];
        this.listaDispositivosGPSColor = [];
        this.señalesGPSJSONMostrar = [];
        this.señalesGPSJSONOcultar = [];
        this.marcadoresNuevos = [];
        this.latitudOrigen = 0;
        this.longitudOrigen = 0;
        this.latitudDestino = 0;
        this.longitudDestino = 0;
        this.señalesGPSJSON = {
            Señales: [
                {
                    latitud: -33.3892,
                    longitud: -70.6931,
                    gps: 'gps123',
                },
            ],
        };
        this.viajesJSON = null;
        this.todasSeñalesGPSMostrar = [];
        this.primerDisp = '';
        this.coloresHexadecimales = {
            colores: [
                '#00008b',
            ],
        };
        this.marcadoresPorGps = {
            gps1: { marcadores: ['A'] },
        };
        // se necesitan todas las patentes y dispositivos gps
        this.ObtenerDispositivoGPS = (indiceGPS, indicePatente) => this.listadoDispositivosGps[indiceGPS].substring(this.listadoPatentes[indicePatente].length + this.separador.length);
        // se necesitan todas las patentes y dispositivos gps
        this.obtenerColor = (indicePatente, indiceGPS, posicionesRestar) => this.coloresHexadecimales.colores[indiceGPS];
        // this.coloresHexadecimales.colores[ (((indicePatente*2)+indiceGPS)) + posicionesRestar ];//this.incrementoABorrar) + posicionesRestar ];
        this.EsPatenteDefault = (patente) => patente.trim() === this.patenteDefault.trim();
        this.EsGPSDefault = (gps) => gps.trim() === this.gpsDefault.trim();
        this.obtenerColorPorPatente = (indicePatente, indiceGPS, patente) => this.obtenerColor(indicePatente, indiceGPS, this.EsPatenteDefault(patente) ? 0 : -2); // 0);//
        this.EstablecerColorSelectGps = () => this.EstablecesPropiedadCSS('color', '#fff');
        this.EstablecerColorBackgroundSelectGps = (color) => this.EstablecesPropiedadCSS('background-color', color);
        this.EstablecesPropiedadCSS = (propiedad, valor) => (document.getElementById('select_gps').style[propiedad] = valor);
        this.ResetZonasCambioGps = () => { };
        this.ToogleMarcadoresVerdaderosMapa = (gps) => this.EsGPSDefault(gps)
            ? this.MostrarSoloMarcadoresVerdaderosMapa()
            : this.QuitarMarcadoresVerdaderosMapa();
        this.conteoSenalesdeGpsSeleccionado = 0;
        this.SeleccionarGPS = (identificadorGPS) => this.CambiarEstilos(identificadorGPS, !this.listaDispositivosGPS[identificadorGPS]);
        this.ObtenerEstiloPorSeleccion = (seleccionado) => seleccionado ? 'btn-danger' : 'btn-primary';
        this.CambiarEstilos = (identificadorGPS, seleccionado) => {
            const estiloAgregar = this.ObtenerEstiloPorSeleccion(seleccionado);
            const estiloQuitar = this.ObtenerEstiloPorSeleccion(!seleccionado);
            this.AgregarEstilo(identificadorGPS, estiloAgregar);
            this.QuitarEstilo(identificadorGPS, estiloQuitar);
            this.listaDispositivosGPS[identificadorGPS] = seleccionado;
            seleccionado
                ? this.MostrarSeñalesDispositivo(identificadorGPS)
                : this.OcultarSeñalesDispositivo(identificadorGPS);
        };
        this.gpsSeleccionado = '';
        this.EstablecerZonas = () => {
            alert('estableciendo zonas 1');
        };
        this.AgregarSeñalAlArregloCorrespondiente = (señal, mostrarSeñales) => mostrarSeñales
            ? this.señalesGPSJSONMostrar.push(señal)
            : this.señalesGPSJSONOcultar.push(señal);
        this.AgregarEstilo = (identificadorGPS, estilo) => document.getElementById(identificadorGPS + 'boton').classList.add(estilo);
        this.QuitarEstilo = (identificadorGPS, estilo) => document
            .getElementById(identificadorGPS + 'boton')
            .classList.remove(estilo);
        this.CrearMarcadorPersonalizado = (p, colorUsar = '#F00', rotacionAdicional = 0) => { };
        this.cambiarColor = (gps, color) => (this.listaDispositivosGPSColor[gps] = color);
        this.CrearIframeStreetView = (datosPunto, latitud = 0, longitud = 0) => { };
    }
    obtener_viajesJSON() {
        return __awaiter(this, void 0, void 0, function* () {
            // this.MostrarTiempo("inicio obtener_viajesJSON");
            const elementosConstruidos = [];
            for (let indicePatente = 0; indicePatente < this.listadoPatentes.length; indicePatente++) {
                const listadoUsar = [];
                for (let indiceGPS = 0; indiceGPS < this.listadoDispositivosGps.length; indiceGPS++)
                    if (this.listadoDispositivosGps[indiceGPS].indexOf(this.listadoPatentes[indicePatente]) > -1)
                        listadoUsar.push(this.ObtenerDispositivoGPS(indiceGPS, indicePatente));
                const elementoConstruido = {
                    Patente: this.listadoPatentes[indicePatente],
                    DispositivosGPS: listadoUsar,
                };
                elementosConstruidos.push(elementoConstruido);
            }
            this.viajesJSON = {
                Viaje: '001Viaje',
                Patentes: elementosConstruidos,
            };
            this.patenteDefault = this.viajesJSON.Patentes[0].Patente;
            this.gpsDefault = this.viajesJSON.Patentes[0].DispositivosGPS[0];
            // this.MostrarTiempo("fin obtener_viajesJSON");
        });
    }
    onGPSChange(identificadorGPS) {
        this.ResetZonasCambioGps();
        this.todasSeñalesGPSMostrar = [];
        this.EstablecerColorSelectGps();
        let coincide = false;
        let color = '';
        for (let indicePatente = 0; indicePatente < this.viajesJSON.Patentes.length; indicePatente++) {
            for (let indiceGPS = 0; indiceGPS < this.viajesJSON.Patentes[indicePatente].DispositivosGPS.length; indiceGPS++) {
                if (this.viajesJSON.Patentes[indicePatente].DispositivosGPS[indiceGPS] === identificadorGPS) {
                    coincide = true;
                    color = this.obtenerColorPorPatente(indicePatente, indiceGPS, this.viajesJSON.Patentes[indicePatente].Patente);
                    this.EstablecerColorBackgroundSelectGps(color);
                    this.usarColoresDelSelect = true;
                    this.colorDelSelect = color;
                    break;
                }
            }
        }
        if (!coincide)
            this.EstablecerColorBackgroundSelectGps(this.coloresHexadecimales.colores[0]);
        // this.ToogleMarcadoresVerdaderosMapa(identificadorGPS);//tal vez quitarlo
        this.MostrarSoloPocisionesNecesarias(identificadorGPS);
        // this.MostrarTiempo("fin onGPSChange");
    }
    MostrarSoloMarcadoresVerdaderosMapa() {
        this.MostrarMarcadoresVerdaderosMapa();
        this.todasSeñalesGPSMostrar = [];
        this.MostrarSeñalesDispositivo('');
    }
    obtenerSeñalesGPS(patente) {
        // this.MostrarTiempo("inicio obtenerSeñalesGPS");
        this.gps_signal_gps_ids = [];
        if (this.EsPatenteDefault(patente))
            this.gps_signal_gps_ids.push({ gps_id: this.gpsDefault });
        for (const [indicePatente, placa] of this.viajesJSON.Patentes.entries())
            for (const [indiceGPS, gps] of this.viajesJSON.Patentes[indicePatente].DispositivosGPS.entries())
                if (this.viajesJSON.Patentes[indicePatente].Patente.trim() === patente.trim())
                    if (this.gpsDefault.trim() !== this.viajesJSON.Patentes[indicePatente].DispositivosGPS[indiceGPS].trim())
                        this.gps_signal_gps_ids.push({
                            gps_id: this.viajesJSON.Patentes[indicePatente].DispositivosGPS[indiceGPS].trim(),
                        });
        // this.MostrarTiempo("fin obtenerSeñalesGPS");
        return this.gps_signal_gps_ids[0].gps_id;
    }
    MostrarSoloPocisionesNecesarias(GPSId) {
        this.conteoSenalesdeGpsSeleccionado = 0;
        if (this.todosLosPuntosSeHanCargado) {
            this.QuitarMarcadoresVerdaderosMapa().then(() => {
                this.MostrarMarcadoresMapaPorGPSId(GPSId);
            });
        }
    }
    onPlacaChange(patente) {
        return __awaiter(this, void 0, void 0, function* () {
            this.EstablecerColorBackgroundSelectGps(this.coloresHexadecimales.colores[0]);
            this.EstablecerColorSelectGps();
            this.gps_signal_gps_ids = [];
            let esPrimer = true;
            let esPrimerDispositivo = '';
            for (const placa of this.viajesJSON.Patentes) {
                if (placa.Patente.trim() === patente.trim()) {
                    if (esPrimer) {
                        esPrimerDispositivo = this.obtenerSeñalesGPS(patente);
                        esPrimer = false;
                        this.primerDisp = esPrimerDispositivo;
                    }
                    break;
                }
            }
            this.onGPSChange(esPrimerDispositivo); // this.viajesJSON.Patentes[1].DispositivosGPS[0]);
            this.usarColoresDelSelect = true;
            this.colorDelSelect = this.coloresHexadecimales.colores[0]; // "#C0392B";
            if (patente.trim() === this.patenteDefault.trim()) {
                this.EstablecerColorBackgroundSelectGps(this.coloresHexadecimales.colores[0]);
                this.MostrarSoloMarcadoresVerdaderosMapa();
            }
        });
    }
    mostrarDatosJSON() {
        for (const [indicePatente, placa] of this.viajesJSON.Patentes.entries())
            for (const [indiceGPS, gps] of this.viajesJSON.Patentes[indicePatente].DispositivosGPS.entries()) {
                const identificadorGPS = this.viajesJSON.Patentes[indicePatente].DispositivosGPS[indiceGPS];
                this.listaDispositivosGPS[identificadorGPS] = false;
                this.listaDispositivosGPSColor[identificadorGPS] = '#000';
            }
    }
    OcultarSeñalesDispositivo(identificadorGPS) {
        this.señalesGPSJSONOcultar = [];
        this.AgregarSeñalesCoincidentesGPS(identificadorGPS, false);
        this.EliminarSeñales();
        this.PintarMarcadoresEnMapa();
    }
    EliminarSeñales() {
        for (const [i, señalMostrar] of this.todasSeñalesGPSMostrar.entries())
            for (const señalOcultar of this.señalesGPSJSONOcultar)
                if (señalMostrar === señalOcultar)
                    this.todasSeñalesGPSMostrar.splice(i, 1);
    }
    QuitarMarcadoresMapa() {
        for (const marcador of this.marcadoresNuevos)
            marcador.setMap(null);
    }
    QuitarMarcadoresMapaPorGPSId(gpsId) {
        const marcadoresUsar = this.marcadoresPorGps[gpsId].marcadores;
        for (const marcador of marcadoresUsar)
            marcador.setMap(null);
    }
    QuitarMarcadoresVerdaderosMapa() {
        return __awaiter(this, void 0, void 0, function* () {
            for (const marcador of this.marcadoresVerdaderos)
                marcador.setMap(null);
        });
    }
    MostrarMarcadoresMapaPorGPSId(gpsId) {
        this.gpsSeleccionado = gpsId;
        // const marcadoresUsar = this.marcadoresPorGps[gpsId].marcadores;
        let marcadoresUsar = this.marcadoresPorGps[gpsId].marcadores;
        this.latitudOrigen = marcadoresUsar[0].position.lat();
        this.longitudOrigen = marcadoresUsar[0].position.lng();
        this.latitudDestino = marcadoresUsar[0].position.lat();
        this.longitudDestino = marcadoresUsar[0].position.lng();
        this.conteoSenalesdeGpsSeleccionado = marcadoresUsar.length;
        //alert('this.conteoSenalesdeGpsSeleccionado : ' + this.conteoSenalesdeGpsSeleccionado );
        for (const marcador of marcadoresUsar) {
            marcador.setMap(this.map);
            marcador.icon.strokeColor = document.getElementById('select_gps').style['background-color'];
            if (marcador.position.lat() < this.latitudOrigen)
                this.latitudOrigen = marcador.position.lat();
            if (marcador.position.lng() < this.longitudOrigen)
                this.longitudOrigen = marcador.position.lng();
            if (marcador.position.lat() > this.latitudDestino)
                this.latitudDestino = marcador.position.lat();
            if (marcador.position.lng() > this.longitudDestino)
                this.longitudDestino = marcador.position.lng();
        }
        //alert('conteoSenalesdeGpsSeleccionado: ' +  this.conteoSenalesdeGpsSeleccionado);
        this.EstablecerZonas();
    }
    MostrarMarcadoresVerdaderosMapa() {
        for (const marcador of this.marcadoresVerdaderos)
            marcador.setMap(null);
    }
    MostrarSeñalesDispositivo(identificadorGPS) {
        this.señalesGPSJSONMostrar = [];
        this.AgregarSeñalesCoincidentesGPS(identificadorGPS, true);
        this.todasSeñalesGPSMostrar = this.todasSeñalesGPSMostrar.concat(this.señalesGPSJSONMostrar);
        this.PintarMarcadoresEnMapa();
    }
    AgregarSeñalesCoincidentesGPS(identificadorGPS, mostrarSeñales) {
        for (const señal of this.señalesGPSJSON.Señales)
            if (señal.gps === identificadorGPS)
                this.AgregarSeñalAlArregloCorrespondiente(señal, mostrarSeñales);
    }
    PintarMarcadoresEnMapa() {
        this.QuitarMarcadoresMapa();
        this.marcadoresNuevos = [];
        for (const señal of this.todasSeñalesGPSMostrar) {
            const p = new google.maps.LatLng(señal.latitud, señal.longitud);
            const marcador = this.CrearMarcadorPersonalizado(p, this.listaDispositivosGPSColor[señal.gps]);
            this.marcadoresNuevos.push(marcador);
        }
        this.CrearListeners();
    }
    CrearListeners() {
        for (let i = 0; i < this.marcadoresNuevos.length; i++) {
            const alcance = this;
            const posicion = new google.maps.LatLng(this.todasSeñalesGPSMostrar[i].latitud, this.todasSeñalesGPSMostrar[i].longitud);
            const msg = alcance.CrearInfoWindowGPS(this.todasSeñalesGPSMostrar[i]);
            alcance.marcadoresNuevos[i].addListener('click', function () {
                let dotInfowindow = null;
                if (dotInfowindow != null)
                    dotInfowindow.close();
                dotInfowindow = new google.maps.InfoWindow({
                    content: msg,
                });
                dotInfowindow.setPosition(posicion);
                dotInfowindow.open(this.map);
            }, false);
        }
    }
    CrearInfoWindowGPS(datosPunto) {
        const msg = [];
        msg.push('<b>Gps:</b>');
        msg.push(datosPunto.gps);
        msg.push('<br>');
        msg.push('<b>Latitud:</b>');
        msg.push(datosPunto.latitud);
        msg.push('<br>');
        msg.push('<b>Longitud:</b>');
        msg.push(datosPunto.longitud);
        msg.push('<br>');
        msg.push(this.CrearIframeStreetView(datosPunto, datosPunto.latitud, datosPunto.longitud));
        return msg;
    }
    ObtenerValor(objeto, propiedad) {
        if (typeof propiedad === 'string')
            propiedad = propiedad.split('.');
        return propiedad.length
            ? this.ObtenerValor(objeto[propiedad.shift()], propiedad)
            : objeto;
    }
}

class ManejoZonas extends ManejoFiltradoSenalesGps {
    constructor() {
        super(...arguments);
        this.poligonos = [];
        this.poligonTriangle = null;
        this.poligonosCreados = [];
        this.nombreElegido = '';
        this.indiceNombre = 0;
        this.infos = [];
        this.contaInfos = 0;
        this.showDropDown = false;
        this.poligonosNombres = [];
        this.poligonosTipos = [];
        this.poligonosColores = [];
        this.contadorColoresTipos = 0;
        this.routes = [];
        this.shapes = [];
        // DATOS DE EJEMPLO
        this.tiposZonas = {
            tiposZonas: [
                {
                    id: 'danger',
                    nombre: 'zonas de riesgo',
                    color: '#0000FF'
                },
                {
                    id: 'rest',
                    nombre: 'zonas de descanso',
                    color: '#00FF00'
                }
            ]
        };
        this.zonas = null;
        this.listadoTiposZonas = [];
        this.ResetZonasCambioGps = () => {
            this.tiposZonasElegidas = [];
            this.idsTiposZonasElegidas = [];
            for (const poligono of this.poligonosCreados)
                poligono.setMap(null);
            this.poligonosCreados = [];
            this.infos = [];
            for (const elemento of this.list)
                elemento.checked = false;
        };
    }
    MostrarZonasElegidas() {
        let mensajeZonasElegidas = this.tiposZonasElegidas.join(', ');
        if (this.tiposZonasElegidas.length > 2)
            mensajeZonasElegidas = this.tiposZonasElegidas.slice(0, 2).join(', ') + ', ...';
        return mensajeZonasElegidas;
    }
    EliminarOpcionClient() {
        for (let i = 0; i < this.listadoTiposZonas.length; i++)
            if (this.listadoTiposZonas[i] === 'client')
                this.listadoTiposZonas.splice(i, 1);
    }
    getSelectedValue(elemento) {
        return elemento.id == "route" ? this.drawRoute(elemento) : this.drawPoligon(elemento);
    }
    drawPoligon(elemento) {
        setTimeout(() => {
            if (elemento.checked) {
                this.tiposZonasElegidas.push(elemento.name);
                this.idsTiposZonasElegidas.push(elemento.id);
            }
            else {
                const index = this.tiposZonasElegidas.indexOf(elemento.name);
                this.tiposZonasElegidas.splice(index, 1);
                this.idsTiposZonasElegidas.splice(index, 1);
            }
            this.currentSelected = { checked: elemento.checked, name: elemento.name };
            this.AgregarZonaPrueba();
        }, 10);
    }
    drawRoute(elemento) {
        var _a, _b;
        if (elemento.checked) {
            this.tiposZonasElegidas.push(elemento.name);
            this.idsTiposZonasElegidas.push(elemento.id);
            this.drawKMLRoutes((_a = this.kml) === null || _a === void 0 ? void 0 : _a.kml_geoJson);
            this.drawZones((_b = this.kml) === null || _b === void 0 ? void 0 : _b.zones);
        }
        else {
            const index = this.tiposZonasElegidas.indexOf(elemento.name);
            this.tiposZonasElegidas.splice(index, 1);
            this.idsTiposZonasElegidas.splice(index, 1);
            this.routes.forEach(el => el.setMap(null));
            this.shapes.forEach(el => el.setMap(null));
        }
    }
    // CARGA DE RUTAS DE KML
    drawKMLRoutes(kml) {
        console.log("-=PROCESING KML FOR DRAW ROUTES=-");
        if (kml && kml.length > 0) {
            kml.forEach(item => {
                if ((item === null || item === void 0 ? void 0 : item.features) !== undefined && (item === null || item === void 0 ? void 0 : item.features) !== null) {
                    console.log("Processing KML item");
                    item === null || item === void 0 ? void 0 : item.features.forEach(feature => {
                        var _a, _b, _c;
                        console.log("   -> Processing feature item");
                        if (((_a = feature === null || feature === void 0 ? void 0 : feature.geometry) === null || _a === void 0 ? void 0 : _a.coordinates) !== undefined && ((_b = feature === null || feature === void 0 ? void 0 : feature.geometry) === null || _b === void 0 ? void 0 : _b.coordinates) !== null) {
                            this.drawSimgleRoute((_c = feature === null || feature === void 0 ? void 0 : feature.geometry) === null || _c === void 0 ? void 0 : _c.coordinates);
                        }
                    });
                }
            });
        }
        else {
            console.log("No KML available on Route");
        }
    }
    drawSimgleRoute(coordinates) {
        const validatedCoordinates = [];
        console.log("   -> Drawing single route");
        coordinates.forEach(coord => {
            if (coord[0] !== undefined && coord[0] !== null && coord[1] !== undefined && coord[1] !== null) {
                validatedCoordinates.push({ lat: coord[1], lng: coord[0] });
            }
        });
        console.log("   -> validated Coordinates:");
        console.log(validatedCoordinates);
        const mapRoute = new google.maps.Polyline({
            path: validatedCoordinates,
            geodesic: true,
            strokeColor: "#4990E2",
            strokeOpacity: 1.3,
            strokeWeight: 5,
        });
        this.routes.push(mapRoute);
        mapRoute.setMap(this.map);
        console.log("[OK] Route Added");
    }
    drawZones(zones) {
        if (zones && zones.length > 0) {
            zones.forEach(zone => {
                if (zone && zone.geoJson && zone.geoJson.geometry) {
                    zone.visible_in_map = 1;
                    var shape = null;
                    switch (zone.geoJson.geometry.type) {
                        case 'Polygon':
                            shape = new google.maps.Polygon({
                                paths: this.createPath(zone.geoJson.geometry.coordinates[0]),
                                strokeColor: zone.color_risk,
                                strokeOpacity: 0.8,
                                strokeWeight: 2,
                                fillColor: zone.color_risk,
                                fillOpacity: 0.7,
                                shape_type: 'polygon'
                            });
                            // google.maps.event.addListener(shape, "mouseup", (event:any)=>{
                            //   console.log("CAMBIO EL POLIGONO")     
                            //   this.changeDataZones(event);
                            // });
                            break;
                        case "Circle":
                            var center = zone.geoJson.geometry.coordinates[0];
                            shape = new google.maps.Circle({
                                strokeColor: zone.color_risk,
                                strokeOpacity: 0.8,
                                strokeWeight: 2,
                                fillColor: zone.color_risk,
                                fillOpacity: 0.7,
                                center: { lng: center[0], lat: center[1] },
                                radius: zone.geoJson.properties["radius"],
                                shape_type: 'circle'
                            });
                            // google.maps.event.addListener(shape, "mouseup", (event:any)=>{
                            //   console.log("CAMBIO EL CIRCULO")     
                            //   this.changeDataZones(event);
                            // });
                            break;
                        case "Rectangle":
                            var sw = zone.geoJson.geometry.coordinates[0];
                            var ne = zone.geoJson.geometry.coordinates[1];
                            shape = new google.maps.Rectangle({
                                strokeColor: zone.color_risk,
                                strokeOpacity: 0.8,
                                strokeWeight: 2,
                                fillColor: zone.color_risk,
                                fillOpacity: 0.7,
                                bounds: new google.maps.LatLngBounds({ lng: sw[0], lat: sw[1] }, { lng: ne[0], lat: ne[1] }),
                                shape_type: 'rectangle'
                            });
                            // google.maps.event.addListener(shape, "bounds_changed", (event:any)=>{
                            //   console.log("CAMBIO EL RECTANGULO")     
                            //   this.changeDataZones(event)
                            // });
                            break;
                    }
                    if (shape != null) {
                        this.shapes.push(shape);
                        shape.setMap(this.map);
                        // this.map_shapes.push(shape);
                        // shape.addListener('click',(event)=>{this.onShapeClick(shape)})
                        //shape.addListener( "dragend", (event)=>{this.onShapeEdited(event)})
                    }
                }
                else {
                    console.error('zone without geometric data');
                    console.error(zone);
                }
            });
        }
        else {
            console.log("No Zones available on Route");
        }
    }
    createPath(array) {
        let c = [];
        array.forEach(par => {
            c.push({ lat: par[1], lng: par[0] });
        });
        return c;
    }
    ObtenerPoligono(indice) {
        return new google.maps.Polygon({
            paths: this.poligonos[indice],
            strokeColor: this.poligonosColores[indice],
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: this.poligonosColores[indice],
            fillOpacity: 0.35,
        });
    }
    getCirclesPoligono(indice) {
        return new google.maps.Circle({
            strokeColor: this.poligonos[indice].colorZona,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: this.poligonos[indice].colorZona,
            fillOpacity: 0.7,
            center: { lng: this.poligonos[indice].puntos[0], lat: this.poligonos[indice].puntos[1] },
            radius: this.poligonos[indice].radio,
            shape_type: 'circle'
        });
    }
    MostrarZonasEnMapa() {
        for (const poligono of this.poligonosCreados)
            poligono.setMap(null);
        this.poligonosCreados = [];
        this.infos = [];
        for (let i = 0; i < this.poligonos.length; i++) {
            const poligono = this.poligonos[i].tipoPoligono == "Circle" ? this.getCirclesPoligono(i) : this.ObtenerPoligono(i);
            poligono.setMap(this.map);
            this.nombreElegido = this.poligonosNombres[i];
            this.bindInfoWindow(poligono, this.map, this.nombreElegido);
            this.poligonosCreados.push(poligono);
        }
    }
    bindInfoWindow(marker, map, html) {
        marker.addListener('click', (event) => {
            const infoWindow = new google.maps.InfoWindow();
            infoWindow.setContent(html);
            infoWindow.setPosition(event.latLng);
            infoWindow.open(map);
        });
    }
    ObtenerTiposZonasPorLocalStorage() {
        const objetoLS = localStorage.getItem('User');
        const tiposZonasLS = JSON.parse(objetoLS).configuration_account.zones.zone_type;
        this.tiposZonas.tiposZonas = [];
        for (const tipo of tiposZonasLS) {
            const tipoZona = {
                id: tipo.code,
                nombre: tipo.name,
                color: '#0000FF'
            };
            this.tiposZonas.tiposZonas.push(tipoZona);
        }
        const tipoZona2 = {
            id: 'other',
            nombre: 'otros',
            color: '#808080'
        };
        this.tiposZonas.tiposZonas.push(tipoZona2);
        this.listadoTiposZonas = [];
        for (const tipoZona of this.tiposZonas.tiposZonas)
            this.listadoTiposZonas.push(tipoZona.id);
    }
    InicializarListaTiposZona() {
        this.ObtenerTiposZonasPorLocalStorage();
        this.list = [];
        const tipos = this.tiposZonas.tiposZonas;
        for (const indice in tipos)
            this.list.push({ id: tipos[indice].id, name: tipos[indice].nombre, checked: false });
    }
    AgregarZonaPrueba() {
        var _a, _b;
        this.poligonos = [];
        this.poligonosNombres = [];
        this.poligonosTipos = [];
        this.poligonosColores = [];
        for (let indiceTipoZona = 0; indiceTipoZona < this.idsTiposZonasElegidas.length; indiceTipoZona++) {
            for (let indice = 0; indice < this.zonas.zonas.length; indice++) {
                if (this.zonas.zonas[indice].tipoZona === this.idsTiposZonasElegidas[indiceTipoZona] && ((_a = this.zonas.zonas[indice]) === null || _a === void 0 ? void 0 : _a.tipoPoligono) == "Circle") {
                    this.poligonosNombres.push(this.zonas.zonas[indice].nombre);
                    this.poligonosTipos.push(indiceTipoZona);
                    this.poligonos.push(this.zonas.zonas[indice]);
                }
                if (this.zonas.zonas[indice].tipoZona === this.idsTiposZonasElegidas[indiceTipoZona] && ((_b = this.zonas.zonas[indice]) === null || _b === void 0 ? void 0 : _b.tipoPoligono) == "Polygon") {
                    let zonaTemporal = [];
                    const puntos = this.zonas.zonas[indice].puntos;
                    zonaTemporal = this.ArmarZonaTemporal(puntos, indice, zonaTemporal);
                    this.poligonosNombres.push(this.zonas.zonas[indice].nombre);
                    this.poligonosTipos.push(indiceTipoZona);
                    this.poligonos.push(zonaTemporal);
                    const tipos = this.tiposZonas.tiposZonas;
                    for (const tipo of tipos)
                        if (tipo.id === this.zonas.zonas[indice].tipoZona)
                            this.poligonosColores.push(this.zonas.zonas[indice].colorZona);
                }
            }
        }
        this.MostrarZonasEnMapa();
    }
    ArmarZonaTemporal(puntos, indice, zonaTemporal) {
        for (let i = 0; i < puntos.length; i++) {
            const coordenada = { tipoPoligono: this.zonas.zonas[indice].tipoPoligono, lat: this.zonas.zonas[indice].puntos[i][1], lng: this.zonas.zonas[indice].puntos[i][0] };
            zonaTemporal.push(coordenada);
        }
        return zonaTemporal;
    }
}

class ServicioZonasService {
    constructor(_http) {
        this._http = _http;
        this.url = "";
        this.headers = { "content-type": "application/json" };
        this.ObtenerZonasCoincidentes = (minLatitude, maxLatitude, minLongitude, maxLongitude, tipos) => {
            return this._http.get(this.url + "/zones/" + minLatitude + "/" + maxLatitude + "/" + minLongitude + "/" + maxLongitude + "/" + tipos);
        };
        this.url = "http://localhost:3201";
        //this.url="http://localhost:8006";
        //http://localhost:8006/api/v1/places/ui/#/zones/service.ServiceFacade.ServiceFacade.getZonesByPointsAndTypes
    }
}
ServicioZonasService.ɵfac = function ServicioZonasService_Factory(t) { return new (t || ServicioZonasService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient)); };
ServicioZonasService.ɵprov = ɵɵdefineInjectable({ factory: function ServicioZonasService_Factory() { return new ServicioZonasService(ɵɵinject(HttpClient)); }, token: ServicioZonasService, providedIn: "root" });
ServicioZonasService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServicioZonasService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.HttpClient }]; }, null); })();

const MAP_ELEMENTS = { ZONE: "map.zone" };
class TrackGoogleMapComponent extends ManejoZonas {
    constructor(tripService, zonesService, modalService, _servicioZonasService) {
        super();
        this.tripService = tripService;
        this.zonesService = zonesService;
        this.modalService = modalService;
        this._servicioZonasService = _servicioZonasService;
        this.trip_id = "";
        this.event_id = null;
        this.trip = null;
        // map toolbox
        this._center = false;
        this._track = false;
        this._overview = false;
        this._showTraffic = false;
        this._showRoute = false;
        this.velocidadPrueba = 0;
        this.rotacionPrueba = 0;
        this.loadPoints = new Subscription();
        this.center = { lat: -33.469086, lng: -70.63889 };
        this.signal_count = 0;
        this.gps_signal_all = {};
        this.gps_signal_events = [];
        this.gps_signal_num_plates = [];
        this.gps_signal_events_selected = 0;
        this.gps_real_time_listen = true;
        this.display_loading = true;
        this.account = null;
        this.start = null;
        this.traffic_alerts = [];
        this.showDotsTimeout = null;
        this.MostrarTiempo = (nombreFuncion) => console.log(nombreFuncion +
            " segundos transcurridos: " +
            (new Date().getTime() - this.start) / 1000 +
            "s ");
        this.EstablecerZonas = () => {
            let params = {
                columns: {
                    zone_type: { $in: this.listadoTiposZonas },
                    account_id: this.account.account_id,
                },
                maxLatitude: this.latitudDestino.toString(),
                maxLongitude: this.longitudDestino.toString(),
                minLatitude: this.latitudOrigen.toString(),
                minLongitude: this.longitudOrigen.toString(),
            };
            this.zonesService.getZonesByPointsAndTypes(params).then((res) => {
                this.zonas = res;
            });
        };
        this.GetKmlRoute = (route_id) => {
            this.zonesService.getRoute(this.account.account_id, route_id).then((res) => {
                this.kml = res;
            });
        };
        this.obtenerParrafo = (atributo, valor) => "<p><strong>" + atributo + ": </strong>" + valor + "</p>";
        this.ObtenerIconoSiExisteRotacion = (rotacion) => rotacion > 0
            ? google.maps.SymbolPath.FORWARD_CLOSED_ARROW
            : google.maps.SymbolPath.CIRCLE;
        this.UsarColorDelSelect = (colorDefault) => this.usarColoresDelSelect ? this.colorDelSelect : colorDefault;
        //public
        this.CrearMarcadorPersonalizado = (p, colorUsar = "#F00", rotacionAdicional = 0) => {
            colorUsar = this.UsarColorDelSelect(colorUsar);
            return new google.maps.Marker({
                position: p,
                icon: {
                    path: this.ObtenerIconoSiExisteRotacion(rotacionAdicional),
                    scale: 2,
                    rotation: rotacionAdicional,
                    strokeColor: colorUsar,
                },
                draggable: false,
                map: this.map,
            });
        };
        this.RevisarDatoIndefinido = (dato) => (!dato ? "N/A" : dato);
        this.account = JSON.parse(localStorage.getItem("User")).account;
        this.account = { account_id: this.account.id };
    }
    set account_id(value) {
        this.account = { account_id: value };
    }
    ngOnInit() {
        this.start = new Date().getTime();
        this.tiposZonasElegidas = [];
        this.idsTiposZonasElegidas = [];
        this.InicializarListaTiposZona();
    }
    MostrarZonasElegidas() {
        let mensajeZonasElegidas = this.tiposZonasElegidas.join(", ");
        if (this.tiposZonasElegidas.length > 2)
            mensajeZonasElegidas = this.tiposZonasElegidas.slice(0, 2).join(", ") + ", ...";
        return mensajeZonasElegidas;
    }
    onMapReady(map) {
        this.map = map;
        this.map_bounds = new google.maps.LatLngBounds();
        this.map.setOptions({
            center: this.center,
            mapTypeControl: true,
            mapTypeControlOptions: {
                mapTypeIds: ["roadmap", "terrain", "satellite"]
            },
            mapTypeId: "roadmap",
            scaleControl: true,
            scaleControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM,
            },
            streetViewControl: true,
            rotateControl: true,
            fullscreenControl: true,
            fullscreenControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP,
            },
            maxZoom: 20,
            minZoom: 2,
            zoom: 18,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM,
            },
        });
        // adding maps tools
        this.map.controls[google.maps.ControlPosition.LEFT_TOP].push(this.map_tools.nativeElement);
        this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(this.select_signals.nativeElement);
        // this.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(
        //   this.time_signals.nativeElement
        // );
        //function style geoJson on map
        this.map.data.setStyle(function (feature) {
            var color = feature.getProperty("color");
            return {
                fillColor: color,
                strokeWeight: 1,
            };
        });
        // Set mouseover event for each feature.
        var feature_infowindow = null;
        map.data.addListener("click", function (ev) {
            var element = ev.feature.getProperty("element");
            switch (element) {
                case MAP_ELEMENTS.ZONE:
                    var msg = "<p><strong>ZONA:</strong>" +
                        ev.feature.getProperty("name") +
                        "</p>";
                    if (feature_infowindow != null)
                        feature_infowindow.close();
                    feature_infowindow = new google.maps.InfoWindow({
                        content: msg,
                    });
                    feature_infowindow.setPosition(ev.latLng);
                    feature_infowindow.open(this.map);
                    break;
            }
        });
        if (this.trip != null) {
            //console.log("Se carga trip enviado");
            this.trip_id = this.trip.trip_id;
            //this.MostrarTiempo("antes de loadTripOnMap");
            this.loadTripOnMap(this.trip);
            //this.MostrarTiempo("despues de loadTripOnMap");
        }
        else {
            //console.log("Se obtiene trip: " + this.trip_id);
            //this.MostrarTiempo("antes de getTrip");
            this.getTrip();
            //this.MostrarTiempo("despues de getTrip");
        }
        //this.MostrarTiempo("antes de loadZones");
        /*
        this.loadZones({
          query: { zone_type: "danger", account_id: this.account.account_id },
        });
        */
        /*
        this.loadZones({
          query: { zone_type: {"$in":["danger","other","origin","route","client","fuel","safe","dark","virtual","commune","region","government"]}, account_id: this.account.account_id },
        });
        */
        /*
        this.loadZones({
          query: { zone_type: {"$in":["danger","other"]}, account_id: this.account.account_id },
        });
    */
        //this.MostrarTiempo("despues de loadZones");
    }
    procesosOverview() {
        this.map.fitBounds(this.map_bounds);
        this._overview = true;
    }
    procesosTrack(errorMsg) {
        if (!this.gps_signal_all[this.gps_signal_selected_num_plate]) {
            alert(errorMsg);
            return;
        }
        this.map.panTo(this.gps_signal_all[this.gps_signal_selected_num_plate].markers[this.gps_signal_selected_gps].latlng);
        this.animateMapZoomTo(this.map, 16, null);
        this._track = true;
    }
    procesosCenter(errorMsg) {
        if (!this.gps_signal_all[this.gps_signal_selected_num_plate]) {
            alert(errorMsg);
            return;
        }
        this.map.panTo(this.gps_signal_all[this.gps_signal_selected_num_plate].markers[this.gps_signal_selected_gps].latlng);
        this.animateMapZoomTo(this.map, 20, null);
        this._center = true;
    }
    procesosTrafico() {
        this._showTraffic = !this._showTraffic;
        this.getCurrentTraffic();
    }
    procesosRoute(errorMsg) {
        if (!this.gps_signal_all[this.gps_signal_selected_num_plate]) {
            alert(errorMsg);
            return;
        }
        this._showRoute = !this._showRoute;
        var map_dots = this.gps_signal_all[this.gps_signal_selected_num_plate]
            .map_dots[this.gps_signal_selected_gps];
        var show = this._showRoute;
        var map = this.map;
        var timeOut = this.showDotsTimeout;
        clearTimeout(timeOut);
        function showDots(k) {
            if (k < map_dots.length) {
                for (var i = 0; i < 100 && k + i < map_dots.length; i++)
                    map_dots[i + k].setMap(show ? null : map);
                k += i;
                timeOut = setTimeout(showDots, 10, k);
            }
        }
        showDots(0);
    }
    map_action(action) {
        this._center = false;
        this._track = false;
        this._overview = false;
        var errorMsg = "La señal seleccionada no dispone de datos GPS.";
        switch (action) {
            case "overview":
                this.procesosOverview();
                break;
            case "track":
                this.procesosTrack(errorMsg);
                break;
            case "center":
                this.procesosCenter(errorMsg);
                break;
            case "traffic":
                this.procesosTrafico();
                break;
            case "route":
                this.procesosRoute(errorMsg);
                break;
        }
    }
    onSignalGpsChange(e) {
        console.log(e);
    }
    getTrip() {
        console.log("CARGANDO TRIP");
        console.log(this.account.account_id);
        this.tripService
            .getTripDetail(this.account.account_id, this.trip_id)
            .toPromise()
            .then((response) => {
            //this.MostrarTiempo("despues de then getTrip");
            this.origenObtenido = response.origin;
            this.destinoObtenido = response.final_destination;
            this.display_loading = false;
            if (response && response.status != 500)
                this.loadTripOnMap(response);
            else
                alert("Error al cargar el trip");
            //this.MostrarTiempo("terminando then getTrip");
        });
    }
    loadTripOnMap(trip) {
        var _a, _b, _c;
        this.display_loading = false;
        var orig = trip["origin"];
        var dest = trip["final_destination"];
        // GPS Signals
        if (trip.stats && trip.stats.signals && trip.transport) {
            var signals = trip.stats.signals;
            var icolor = 0;
            //Revisar si todos los transportes con gps tienen la ultima señal
            for (var k in trip.transport) {
                var transport = trip.transport[k];
                var existSignal = false;
                for (var i in signals) {
                    var s = signals[i];
                    if (s["transport_id"] == transport["transport_id"]) {
                        existSignal = true;
                        var num_plate_info = { id: s.transport_id, gps: [] };
                        this.listadoPatentes.push(s.transport_id.trim());
                        this.gps_signal_num_plates.push(num_plate_info);
                        //this.gps_signal_num_plates.push({id: '91AK6Y'});//agregacion placa ejemplo
                        this.gps_signal_gps_ids = num_plate_info.gps;
                        this.gps_signal_all[s.transport_id] =
                            this.gps_signal_all[s.transport_id] || {};
                        this.gps_signal_all[s.transport_id].id = s.transport_id;
                        this.gps_signal_all[s.transport_id].type = s.transport_type;
                        //TODO: apply lenguage to popup in mapa
                        this.gps_signal_all[s.transport_id].markers = {};
                        if (!Array.isArray(s.last_signal))
                            s.last_signal = [s.last_signal];
                        for (var k in s.last_signal) {
                            var gps = s.last_signal[k];
                            var gpsColor = this.getColor(icolor++);
                            //num_plate_info.gps.push({gps_id:gps.gps_id, style:{'background-color':gpsColor}})
                            this.gps_signal_gps_ids.push({
                                gps_id: gps.gps_id,
                                style: { "background-color": gpsColor },
                            });
                            this.listadoDispositivosGps.push(s.transport_id.trim() + this.separador + gps.gps_id.trim());
                            // AGREGACION GPS EJEMPLO
                            //this.gps_signal_gps_ids.push({gps_id: '123XYZ999',style: { "background-color": "#FF0" },});
                            // FIN AGREGACION GPS EJEMPLO
                            var latLng = new google.maps.LatLng(gps.lat, gps.lng);
                            var lastRep = new Date(gps.date_time);
                            this.map_bounds.extend(latLng);
                            var marker = this.drawMarker({
                                latLng: latLng,
                                flyTo: false,
                                style: {
                                    blinking: "fill:" + gpsColor + ";",
                                    blinking_center: "fill:" + gpsColor + ";",
                                },
                            });
                            marker["signal_data"] = {
                                transport_id: s.transport_id,
                                transport_type: s.transport_type,
                                gps_id: gps.gps_id,
                                provider: gps.provider,
                                lastRep: lastRep,
                                lastUpd: new Date(),
                            };
                            this.gps_signal_all[s.transport_id].markers[gps.gps_id] = marker;
                        }
                    }
                }
                //this.contador++;
                if (!existSignal) {
                    this.tripService
                        .getTransport(transport["trans_id"], this.account.account_id)
                        .toPromise()
                        .then((response) => {
                        //this.MostrarTiempo("en el then del loadTripOnMap tripService");
                        var transport_get = {};
                        for (var k in trip.transport) {
                            var transport = trip.transport[k];
                            if (transport["trans_id"] == response["trans_id"])
                                transport_get = transport;
                        }
                        if (response != null) {
                            //var num_plate_info_get = {id:transport_get['transport_id'], gps:[]}
                            this.gps_signal_num_plates.push({
                                id: transport_get["transport_id"],
                                gps: [],
                            });
                            this.gps_signal_all[transport_get["transport_id"]] =
                                this.gps_signal_all[transport_get["transport_id"]] || {};
                            this.gps_signal_all[transport_get["transport_id"]].id =
                                transport_get["transport_id"];
                            this.gps_signal_all[transport_get["transport_id"]].type =
                                transport_get["transport_type"];
                            this.gps_signal_all[transport_get["transport_id"]].markers = {};
                            for (var w in transport_get["gps"]) {
                                var gpsTransport = transport_get["gps"][w];
                                for (var h in response["gps"]) {
                                    var gps = response["gps"][h];
                                    if (gpsTransport["id"] == gps["id"]) {
                                        var gpsColor = this.getColor(icolor++);
                                        this.gps_signal_gps_ids.push({
                                            gps_id: gps["id"],
                                            style: { "background-color": gpsColor },
                                        });
                                        // num_plate_info_get.gps.push({gps_id:gps['id'], style:{'background-color':gpsColor}})
                                        var latLng = new google.maps.LatLng(gps["last_position"]["lat"], gps["last_position"]["lng"]);
                                        var lastRep = new Date(gps["last_report"]["$date"]);
                                        this.map_bounds.extend(latLng);
                                        var marker = this.drawMarker({
                                            latLng: latLng,
                                            flyTo: false,
                                            style: {
                                                blinking: "fill:" + gpsColor + ";",
                                                blinking_center: "fill:" + gpsColor + ";",
                                            },
                                        });
                                        marker["signal_data"] = {
                                            transport_id: transport_get["transport_id"],
                                            transport_type: transport_get["transport_type"],
                                            gps_id: gps["id"],
                                            provider: gps["provider"],
                                            lastRep: lastRep,
                                            lastUpd: new Date(),
                                        };
                                        this.gps_signal_all[transport_get["transport_id"]].markers[gps["id"]] = marker;
                                    }
                                }
                            }
                        }
                        //this.MostrarTiempo("terminando el then del loadTripOnMap tripService");
                    });
                }
                //  window["gps_signal_all"] = this.gps_signal_all;
                //  window["gps_signal_num_plates"] = this.gps_signal_num_plates;
                //  this.MostrarTiempo("despues de establecer los windows loadTripOnMap tripService");
            }
            window["gps_signal_all"] = this.gps_signal_all;
            window["gps_signal_num_plates"] = this.gps_signal_num_plates;
            this.obtener_viajesJSON().then(() => {
                this.MostrarSeñalesPrimerGps();
            });
            //this.MostrarTiempo("despues del onPlacaChange del loadTripOnMap tripService");
        }
        // Places in Route
        if (trip.route && trip.route.length > 0) {
            var places = trip.route;
            for (var i in places) {
                var p = places[i];
                if (p.place_id &&
                    p.place_id != trip["origin"].place_id &&
                    p.place_id != trip["final_destination"].place_id) {
                    var latLng = new google.maps.LatLng(p.latitude, p.longitude);
                    this.map_bounds.extend(latLng);
                    this.drawMarker({
                        latLng: latLng,
                        popUp: this.placeInfo(p, "DESTINO"),
                        style: {
                            svg: "transform: scale(.6);",
                            blinking: "opacity:1;transform: scale(0.8) translate(6px, 6px);animation:none;stroke:black;fill:" +
                                (p.visited ? "#4fe800;" : "#b3b3b3"),
                            blinking_center: "fill:" + (p.visited ? "#0dd100" : "#6b6b6b"),
                        },
                    });
                }
                this.loadZones({
                    query: {
                        "place.place_id": p.place_id,
                        account_id: this.account.account_id,
                    },
                });
            }
        }
        // ORIGEN
        var latLng = new google.maps.LatLng(orig.latitude, orig.longitude);
        this.map_bounds.extend(latLng);
        this.drawMarker({
            latLng: latLng,
            popUp: this.placeInfo(orig, "ORIGEN"),
            style: {
                svg: "transform: scale(.6);",
                blinking: "opacity:1;transform: scale(0.8) translate(6px, 6px);animation:none;stroke:black;fill:orange",
                blinking_center: "fill:orange",
            },
        });
        // DESTINO
        var latLng = new google.maps.LatLng(dest.latitude, dest.longitude);
        this.map_bounds.extend(latLng);
        this.drawMarker({
            latLng: latLng,
            popUp: this.placeInfo(dest, "DESTINO FINAL"),
            style: {
                svg: "transform: scale(.6);",
                blinking: "opacity:1;transform: scale(0.8) translate(6px, 6px);animation:none;stroke:black;fill:yellow",
                blinking_center: "fill:yellow",
            },
        });
        //ALERTS
        if (trip.events) {
            for (var i in trip.events) {
                var evt = trip.events[i];
                if (evt.business && evt.business.namespace == "ROAD_EVENTS") {
                    let dateRep = null;
                    if (((_a = evt === null || evt === void 0 ? void 0 : evt.creation_date) === null || _a === void 0 ? void 0 : _a.$date) != undefined) {
                        dateRep = new Date((_b = evt === null || evt === void 0 ? void 0 : evt.creation_date) === null || _b === void 0 ? void 0 : _b.$date);
                    }
                    else if ((evt === null || evt === void 0 ? void 0 : evt.creation_date) != undefined) {
                        dateRep = new Date(evt === null || evt === void 0 ? void 0 : evt.creation_date);
                    }
                    evt.latLng = new google.maps.LatLng(evt.place.latitude, evt.place.longitude);
                    this.gps_signal_events.push(evt);
                    var alertInfo = [];
                    alertInfo.push("<h6>Alerta</h6><p><strong>");
                    alertInfo.push(evt.type.description);
                    alertInfo.push("</strong></p>");
                    // FECHA OK
                    if (dateRep != null) {
                        alertInfo.push("<p><strong>");
                        alertInfo.push(dateRep.toLocaleDateString('en-GB', {
                            month: '2-digit',
                            day: '2-digit',
                            year: 'numeric',
                        }));
                        alertInfo.push(" ");
                        alertInfo.push(dateRep.toLocaleTimeString());
                        alertInfo.push("</strong></p>");
                    }
                    else {
                        alertInfo.push("<p><strong>");
                        alertInfo.push("N/A");
                        alertInfo.push("</strong></p>");
                    }
                    alertInfo.push("<p><strong>lat,lng: </strong>");
                    alertInfo.push(evt.place.latitude);
                    alertInfo.push(",");
                    alertInfo.push(evt.place.longitude);
                    alertInfo.push("</p>");
                    var eventMarker = this.drawMarker({
                        iconSize: [20, 20],
                        latLng: evt.latLng,
                        popUp: alertInfo.join(""),
                        style: {
                            svg: "transform: scale(.5);",
                            blinking: "fill:red;",
                            blinking_center: "fill:red",
                        },
                    });
                    if (evt.event_id == this.event_id) {
                        this.map.panTo(evt.latLng);
                        this.animateMapZoomTo(this.map, 20, null);
                        google.maps.event.trigger(eventMarker, "click");
                    }
                }
            }
        }
        this.loadPoints = this.gpsRoute();
        //ROUTE ZONE
        if ("route_logic" in trip && "zones" in trip.route_logic)
            this.drawZone(trip.route_logic.zones);
        if (this.event_id == null)
            this.map_action("overview");
        // if it is active listen current gps position
        this.gps_real_time_listen = trip.active;
        if (this.gps_real_time_listen)
            socket_event.addEventListener("trip.signal.change", (e) => this.onSignalEvent(e));
        //  this.gpsCurrentPosition();
        this.GetKmlRoute((_c = trip === null || trip === void 0 ? void 0 : trip.route_logic) === null || _c === void 0 ? void 0 : _c.route_id);
    }
    MostrarSeñalesPrimerGps() {
        this.QuitarMarcadoresVerdaderosMapa().then(() => {
            this.onPlacaChange(this.patenteDefault).then(() => {
                setTimeout(() => {
                    this.QuitarMarcadoresVerdaderosMapa();
                    setTimeout(() => {
                        this.QuitarMarcadoresVerdaderosMapa();
                        this.onGPSChange(this.primerDisp);
                    }, 1000);
                }, 1000);
            });
        });
    }
    onSignalEvent(e) {
        //this.MostrarTiempo("inicio onSignalEvent");
        let data = e.data;
        if (data &&
            data.account.account_id == this.account.account_id &&
            decodeURI(data.trip_id) == decodeURI(this.trip_id)) {
            var transport_id = e.data.num_plate;
            this.gps_signal_all[transport_id] = this.gps_signal_all[transport_id] || {};
            var gps = data.signal;
            //get marker and update position and time last report
            var latLng = new google.maps.LatLng(gps.lat, gps.lng);
            var marker = this.gps_signal_all[transport_id].markers[gps.gps_id];
            if (!marker) {
                marker = this.drawMarker({
                    latLng: latLng,
                    flyTo: false,
                });
                marker["signal_data"] = {
                    transport_id: transport_id,
                    transport_type: "--",
                    gps_id: gps.gps_id,
                    provider: gps.provider,
                    lastRep: new Date(gps.date_time.$date),
                    lastUpd: new Date(),
                };
                this.gps_signal_all[transport_id].markers[gps.gps_id] = marker;
            }
            marker["signal_data"].lastRep = new Date(gps.date_time.$date);
            marker["signal_data"].lastUpd = new Date();
            marker.setPosition(latLng);
            // Last locations
            let locations = this.gps_signal_all[transport_id].last_signal[0].last_locations;
            // Add new position
            locations.push({ lat: gps.lat, lng: gps.lng });
            // Get point before
            let origin = locations.at(-2);
            // Calculate direction of the point
            let heading = locations.length >= 2
                ? SphericalUtil.computeHeading({ lat: origin.lat, lng: origin.lng }, { lat: gps.lat, lng: gps.lng })
                : Math.floor(Math.random() * 359);
            // Draw the point
            this.drawPointSimple(data, heading);
        }
        //this.MostrarTiempo("fin onSignalEvent");
    }
    // Draw simple point
    drawPointSimple(data, heading) {
        let gps = data.signal, current = this, map = this.map, p = new google.maps.LatLng(gps.lat, gps.lng), color = this.UsarColorDelSelect("#F00"), dot_infowindow = null, dot = new google.maps.Marker({
            position: p,
            icon: {
                path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                scale: 2,
                rotation: heading,
                strokeColor: color,
            },
            draggable: false,
            map: map,
        });
        dot["dot_data"] = {
            num_plate: data.num_plate,
            gps_id: gps.gps_id,
            provider: gps.provider,
            latLng: p,
            dateTime: new Date(gps.date_time.$date),
            carrier: 'N/A',
            speed: 'N/A',
        };
        dot.addListener("click", function (ev) {
            let msg = current.CrearInfoWindowPersonalizado(dot["dot_data"]);
            if (dot_infowindow != null)
                dot_infowindow.close();
            dot_infowindow = new google.maps.InfoWindow({
                content: msg,
            });
            dot_infowindow.setPosition(gps); // here 'this' is referencing to dot
            dot_infowindow.open(map);
        });
        this.marcadoresVerdaderos.push(dot);
        this.marcadoresPorGps[gps.gps_id.trim()].marcadores.push(dot);
        this.map_bounds.extend(p);
    }
    getColor(i) {
        var gps_colors = ["#4990e2", "#1bff00", "#002bff", "#fb00ff", , "#fa6a00"];
        if (i < gps_colors.length) {
            return gps_colors[i];
        }
        else {
            var r = Math.round(Math.random() * 255);
            var g = Math.round(Math.random() * 255);
            var b = Math.round(Math.random() * 255);
            return "rgb(" + r + "," + g + "," + b + ")";
        }
    }
    placeInfo(p, type) {
        var placeInfo = [];
        placeInfo.push(this.obtenerParrafo(type, p.name));
        placeInfo.push(this.obtenerParrafo("Dirección", p.address));
        placeInfo.push(this.obtenerParrafo("CODE", p.place_code));
        placeInfo.push(this.obtenerParrafo("lat,lng", p.latitude + "," + p.longitude));
        return placeInfo.join("");
    }
    gpsRoute() {
        return this.tripService
            .getCurrentRoute(this.trip_id, this.account.account_id)
            .subscribe(data => {
            //this.MostrarTiempo("inicio gpsRoute");
            if (data) {
                var signal = null;
                for (var num_plate in data) {
                    //num_plate selected
                    this.gps_signal_selected_num_plate = num_plate;
                    signal = this.gps_signal_all[num_plate] || {};
                    this.gps_signal_all[num_plate] = signal;
                    for (var attr in data[num_plate])
                        signal[attr] = data[num_plate][attr];
                    //alert('signal["last_signal"].length ' + signal["last_signal"].length);
                    for (var i in signal["last_signal"]) {
                        var gps = signal["last_signal"][i];
                        //gps selected
                        this.gps_signal_selected_gps = gps.gps_id;
                        //draw all dots
                        this.signal_count = gps["last_locations"].length;
                        signal["map_dots"] = {};
                        signal["map_dots"][gps.gps_id] = [];
                        var range = 300;
                        if (this.signal_count < 300)
                            range = this.signal_count;
                        if (!this.marcadoresPorGps[gps.gps_id.trim()])
                            this.marcadoresPorGps[gps.gps_id.trim()] = { marcadores: [] };
                        this.latitudOrigen = gps["last_locations"][0].lat;
                        this.longitudOrigen = gps["last_locations"][0].lng;
                        this.latitudDestino = gps["last_locations"][0].lat;
                        this.longitudDestino = gps["last_locations"][0].lng;
                        this.drawPoint(gps["last_locations"], gps, num_plate, signal, range, 0);
                    }
                    this.todosLosPuntosSeHanCargado = true;
                }
                signal["last_signal"].map(item => {
                    item["last_locations"].map(loc => {
                        if (loc.lat < this.latitudOrigen)
                            this.latitudOrigen = loc.lat;
                        if (loc.lng < this.longitudOrigen)
                            this.longitudOrigen = loc.lng;
                        if (loc.lat > this.latitudDestino)
                            this.latitudDestino = loc.lat;
                        if (loc.lng > this.longitudDestino)
                            this.longitudDestino = loc.lng;
                    });
                });
                this.EstablecerZonas();
                //TODO: centrar en head
                if (this.event_id == null)
                    this.map_action("overview");
            }
            //this.MostrarTiempo("fin gpsRoute");
        }, (error) => {
            alert("Problema al cargar ruta del viaje.");
        });
    }
    drawPoint(sig, gps, num_plate, signal, range, last_sig) {
        //console.log('range + last_sig ' + (range + last_sig));
        for (let index = last_sig; index < range + last_sig; index++) {
            var sig = gps["last_locations"][index];
            //console.log("sig : " +JSON.stringify(sig) );
            if (sig.lat < this.latitudOrigen)
                this.latitudOrigen = sig.lat;
            if (sig.lng < this.longitudOrigen)
                this.longitudOrigen = sig.lng;
            if (sig.lat > this.latitudDestino)
                this.latitudDestino = sig.lat;
            if (sig.lng > this.longitudDestino)
                this.longitudDestino = sig.lng;
            var p = new google.maps.LatLng(sig.lat, sig.lng);
            var dot = this.CrearMarcadorPersonalizado(p, "#F00", sig.cog);
            var map = this.map;
            dot["dot_data"] = {
                num_plate: num_plate,
                gps_id: gps.gps_id,
                provider: gps.provider,
                latLng: p,
                dateTime: new Date(sig.date_time.$date),
                carrier: sig.carrier,
                speed: sig.speed,
            };
            var dot_infowindow = null;
            var alcance = this;
            dot.addListener("click", function (ev) {
                var msg = alcance.CrearInfoWindowPersonalizado(this["dot_data"]);
                if (dot_infowindow != null)
                    dot_infowindow.close();
                dot_infowindow = new google.maps.InfoWindow({
                    content: msg,
                });
                dot_infowindow.setPosition(this["dot_data"].latLng); // here 'this' is referencing to dot
                dot_infowindow.open(map);
            });
            this.marcadoresVerdaderos.push(dot);
            this.marcadoresPorGps[gps.gps_id.trim()].marcadores.push(dot);
            this.map_bounds.extend(p);
            // <--revisar
            if (index == range + last_sig - 1) {
                if (index + range > gps["last_locations"].length)
                    range = gps["last_locations"].length - (index + 1);
                //setTimeout(() => {
                this.drawPoint(gps["last_locations"], gps, num_plate, signal, range, index + 1);
                //}, 2000);
            }
        }
    }
    onTimeSignals(evt) {
        //console.log(evt.target.value);
        var signal = this.gps_signal_all[this.gps_signal_selected_num_plate];
        //simulate click on gps dot
        google.maps.event.trigger(signal.map_dots[this.gps_signal_selected_gps][evt.target.value], "click");
    }
    createSignalMarkerContent(marker) {
        var data = marker["signal_data"];
        var infoSignal = [];
        infoSignal.push("<p><strong> Patente :</strong>" + data.transport_id + "</p>");
        infoSignal.push("<p><strong> Tipo Transporte :</strong>" + data.transport_type + "</p>");
        infoSignal.push("<p><strong> GPS :</strong>" + data.gps_id + "</p>");
        infoSignal.push("<p><strong> Proveedor :</strong>" + data.provider + "</p>");
        infoSignal.push("<p><strong>Último Reporte :</strong>" +
            data.lastRep.toLocaleDateString("en-GB") +
            " " +
            data.lastRep.toTimeString() +
            "</p>");
        infoSignal.push("<p><strong>Último Actualización :</strong>" +
            data.lastUpd.toLocaleDateString("en-GB") +
            " " +
            data.lastUpd.toTimeString() +
            "</p>");
        return infoSignal.join();
    }
    drawMarker(options) {
        var marker = google_map_extends.SvgMarker({
            latlng: options.latLng,
            map: this.map,
            draggable: false,
            src: "/assets/trips/map-realtime/markers/BlinkingPoint.svg",
            style: options.style,
        });
        if (options.flyTo) {
            this.map.panTo(options.latLng);
            this.animateMapZoomTo(this.map, 16, null);
        }
        var marker_infowindow = new google.maps.InfoWindow({
            content: options.popUp,
        });
        marker.addListener("click", (e) => {
            var content = options.popUp;
            if (marker["signal_data"])
                content = this.createSignalMarkerContent(marker);
            marker_infowindow.setOptions({
                content: content,
            });
            marker_infowindow.open(this.map, marker);
            setTimeout(() => {
                marker_infowindow.close();
            }, 1000 * 20);
            //return false;
        });
        return marker;
    }
    //TODO: cargar por bounds
    loadZones(filter) {
        //this.MostrarTiempo("loadZones 1.-");
        this.zonesService
            .getZoneListSearch({
            columns: filter.query,
            sort_type: "ASC",
            order_by: "place_id",
            pageNumber: filter.page || 0,
            nPerPage: 1500,
        })
            .toPromise()
            .then((res) => {
            //this.MostrarTiempo("loadZones despues del then 2.-");
            if (res && res.code != 500)
                this.drawZone(res[1]);
        });
    }
    drawZone(zones) {
        //this.MostrarTiempo("1.- en drawZone");
        for (var i in zones) {
            var zone = zones[i];
            if (zone && zone.geoJson) {
                let radius = 0;
                if (zone.geoJson.geometry.type == 'Circle') {
                    radius = zone.geoJson.properties.radius;
                }
                zone.geoJson.properties = {
                    element: MAP_ELEMENTS.ZONE,
                    color: zone.color_risk,
                    name: zone.zone_name,
                    type: zone.zone_type,
                };
                var coor = zone.geoJson.geometry.coordinates;
                if (coor && coor.length > 0) {
                    var p_init = coor[0][0];
                    var p_last = coor[0][coor[0].length - 1];
                    if (zone.geoJson.geometry &&
                        zone.geoJson.geometry.type &&
                        zone.geoJson.geometry.type == "Polygon" &&
                        (p_init[0] != p_last[0] || p_init[1] != p_last[1]))
                        coor[0].push(p_init);
                    if (zone.geoJson.geometry.type == 'Circle')
                        zone.geoJson.geometry = this.generateGeoJSONCircle(zone.geoJson.geometry.coordinates[0][1], zone.geoJson.geometry.coordinates[0][0], radius, 20);
                    if (zone.geoJson.geometry.type == 'Circle')
                        zone.geoJson.geometry = this.generateGeoJSONCircle(zone.geoJson.geometry.coordinates[0][1], zone.geoJson.geometry.coordinates[0][0], radius, 20);
                    this.map.data.addGeoJson(zone.geoJson);
                }
            }
        }
        //this.MostrarTiempo("2.- terminando drawZone");
    }
    generateGeoJSONCircle(lat, lng, radius, numSides) {
        var points = [], degreeStep = 360 / numSides;
        let center = {
            lat: lat,
            lng: lng
        };
        for (var i = 0; i < numSides; i++) {
            var gpos = SphericalUtil.computeOffset(center, radius, degreeStep * i);
            points.push([gpos.lng, gpos.lat]);
        }
        ;
        // Duplicate the last point to close the geojson ring
        points.push(points[0]);
        return {
            type: 'Polygon',
            coordinates: [points]
        };
    }
    animateMapZoomTo(map, targetZoom, czoom) {
        var currentZoom = czoom || map.getZoom();
        if (currentZoom != targetZoom) {
            google.maps.event.addListenerOnce(map, "zoom_changed", (event) => {
                this.animateMapZoomTo(map, targetZoom, currentZoom + (targetZoom > currentZoom ? 1 : -1));
            });
            setTimeout(function () {
                map.setZoom(currentZoom);
            }, 80);
        }
    }
    cleanTraffic() {
        for (var i in this.traffic_alerts)
            this.traffic_alerts[i].setMap(null);
        this.traffic_alerts = [];
    }
    getCurrentTraffic() {
        if (this._showTraffic) {
            let variable = this.map.getBounds();
            let top = variable.getNorthEast().lat(); //top
            let right = variable.getNorthEast().lng(); //right
            let bottom = variable.getSouthWest().lat(); //south
            let left = variable.getSouthWest().lng(); //left
            this.tripService
                .getCurrentTraffic(bottom, left, top, right)
                .then((res) => {
                if (res) {
                    this.getJams(res);
                    this.getAlerts(res);
                }
            });
        }
        else {
            this.cleanTraffic();
        }
    }
    getJams(traffic) {
        if (traffic && traffic.jams) {
            for (let i = 0; i < traffic.jams.length; i++) {
                let line = traffic.jams[i].line;
                let city = traffic.jams[i].city;
                let street = traffic.jams[i].street;
                let speed = traffic.jams[i].speedKMH;
                switch (traffic.jams[i].level) {
                    case 1:
                        this.addLine(line, "#ffe000e6", "TRÁFICO LEVE", city, street, speed);
                        break;
                    case 2:
                        this.addLine(line, "#ff8100e6", "TRÁFICO MODERADO", city, street, speed);
                        break;
                    case 3:
                        this.addLine(line, "#ff3b00e6", "TRÁFICO DENSO", city, street, speed);
                        break;
                    case 4:
                        this.addLine(line, "#ff0000c4", "TRÁFICO MUY INTENSO", city, street, speed);
                        break;
                }
            }
        }
    }
    addLine(line, color, message, city, street, speed) {
        //console.log(line);
        // let polyline = L.polyline(this.obtenerLatLngYX(line), { color: color });
        // polyline.bindPopup(
        //   '<p><strong>' + message + '</strong> </p>' +
        //   '<p><strong>Comuna: </strong>' + city + '</p>' +
        //   '<p><strong>Calle:</strong> ' + street + '</p>' +
        //   '<p><strong>Velocidad media</strong>: ' + speed + 'KM/h</p>'
        // );
        // this.layer_jams.addLayer(polyline).addTo(this.map);
    }
    getAlerts(traffic) {
        if (traffic && traffic.alerts) {
            for (let i = 0; i < traffic.alerts.length; i++) {
                let lat = traffic.alerts[i].location.y;
                let long = traffic.alerts[i].location.x;
                let street = traffic.alerts[i].street;
                let alerttype = traffic.alerts[i].type;
                let alertsubtype = traffic.alerts[i].subtype;
                switch (alerttype) {
                    case "ROAD_CLOSED":
                        this.addAlert(lat, long, street, "CALLE CERRADA", "road_closed.png");
                        break;
                    case "ACCIDENT":
                        this.addAlert(lat, long, street, "ACCIDENTE", "accident.png");
                        break;
                    case "POLICE":
                        this.addAlert(lat, long, street, "POLICIA", "police.png");
                        break;
                    case "JAM":
                        switch (alertsubtype) {
                            case "JAM_MODERATE_TRAFFIC":
                                this.addAlert(lat, long, street, "EMBOTELLAMIENTO MODERADO", "jam3.png");
                                break;
                            case "JAM_STAND_STILL_TRAFFIC":
                                this.addAlert(lat, long, street, "EMBOTELLAMIENTO PESADO", "jam2.png");
                                break;
                            case "JAM_HEAVY_TRAFFIC":
                                this.addAlert(lat, long, street, "EMBOTELLAMIENTO TOTAL", "jam.png");
                                break;
                            default:
                                //console.log("JAM NOT HANDLED:"+alertsubtype)
                                this.addAlert(lat, long, street, "EMBOTELLAMIENTO TOTAL", "jam.png");
                                break;
                        }
                        break;
                    case "HAZARD":
                        this.addAlert(lat, long, street, "OBJETO EN LA VÍA", "hazard.png");
                        break;
                    default:
                        //console.log("NOT HANDLED:" + alerttype);
                        break;
                }
            }
        }
    }
    addAlert(lat, long, street, message, image) {
        let marker = google_map_extends.ImageMarker({
            src: "assets/waze/" + image,
            latlng: new google.maps.LatLng(lat, long),
            map: this.map,
            style: "position: absolute;top: -55px;left: -24px;width: 50px;",
        });
        var infowindow = new google.maps.InfoWindow({
            content: "<p><strong>" +
                message +
                "</strong></p>" +
                "<p><strong>Calle:</strong> " +
                street +
                "</p>",
        });
        marker.addListener("click", function (e) {
            infowindow.open(this.map, marker);
            setTimeout(() => {
                infowindow.close();
            }, 1000 * 20);
        });
        this.traffic_alerts.push(marker);
    }
    // CUANDO SE ELIMINA ( SE CAMBIA A OTRA COMPONENT) LA COMPONENT
    ngOnDestroy() {
        if (this.loadPoints)
            this.loadPoints.unsubscribe();
    }
    CrearInfoWindowPersonalizado(datosPunto) {
        var msg = [];
        msg.push("<b>Placa:</b>");
        msg.push(datosPunto.num_plate);
        msg.push("<br>");
        msg.push("<b>GPS ID:</b>");
        msg.push(datosPunto.gps_id);
        msg.push("<br>");
        msg.push("<b>Fecha Hora:</b>");
        msg.push(datosPunto.dateTime.toLocaleDateString("en-GB", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
        }) +
            " " +
            datosPunto.dateTime.toLocaleTimeString());
        msg.push("<br>");
        msg.push("<b>Proveedor:</b>");
        msg.push(datosPunto.provider);
        msg.push("<br>");
        msg.push("<b>Velocidad:</b>");
        msg.push(`${datosPunto.speed ? datosPunto.speed : 0} kms/h`);
        msg.push("<br>");
        msg.push("<b>Latitud:</b>");
        msg.push(datosPunto.latLng.lat());
        msg.push("<br>");
        msg.push("<b>Longitud:</b>");
        msg.push(datosPunto.latLng.lng());
        msg.push("<br>");
        msg.push("<b>Origen:</b>");
        msg.push(this.RevisarDatoIndefinido(this.origenObtenido.place_code) +
            " " +
            this.RevisarDatoIndefinido(this.origenObtenido.place_type));
        msg.push("<br>");
        msg.push(this.RevisarDatoIndefinido(this.origenObtenido.name));
        msg.push("<br>");
        msg.push(this.RevisarDatoIndefinido(this.origenObtenido.address));
        msg.push("<br>");
        msg.push("<b>Destino:</b>");
        msg.push(this.RevisarDatoIndefinido(this.destinoObtenido.place_code) +
            " " +
            this.RevisarDatoIndefinido(this.destinoObtenido.place_type));
        msg.push("<br>");
        msg.push(this.RevisarDatoIndefinido(this.destinoObtenido.name));
        msg.push("<br>");
        msg.push(this.RevisarDatoIndefinido(this.destinoObtenido.address));
        msg.push("<br>");
        msg.push("<b>Nombre transportista:</b>");
        msg.push(this.RevisarDatoIndefinido(datosPunto.carrier));
        msg.push("<br>");
        return msg.join("");
    }
    ObtenerCoordenadasParaIFrame(latitud, longitud, datosPunto) {
        let url = [];
        if (latitud == 0)
            url.push(datosPunto.latLng.lat() + "," + datosPunto.latLng.lng());
        if (latitud != 0)
            url.push(latitud + "," + longitud);
        return url.join("");
    }
}
TrackGoogleMapComponent.ɵfac = function TrackGoogleMapComponent_Factory(t) { return new (t || TrackGoogleMapComponent)(ɵngcc0.ɵɵdirectiveInject(TripsService), ɵngcc0.ɵɵdirectiveInject(ZonesService), ɵngcc0.ɵɵdirectiveInject(ɵngcc12.NgbModal), ɵngcc0.ɵɵdirectiveInject(ServicioZonasService)); };
TrackGoogleMapComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TrackGoogleMapComponent, selectors: [["com-lib-track-google-map"]], viewQuery: function TrackGoogleMapComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c8, 3, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c9, 3, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c10, 3, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.map_tools = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.select_signals = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.time_signals = _t.first);
    } }, inputs: { trip_id: "trip_id", event_id: "event_id", trip: "trip", account_id: "account_id" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 31, vars: 27, consts: [[2, "display", "none"], [1, "map-toolbox"], ["map_tools", ""], ["title", "Real Time Track", 1, "map-toolbox-button", "map-toolbox-button-track", 3, "ngClass", "click"], ["title", "Center On Track", 1, "map-toolbox-button", "map-toolbox-button-center", 3, "ngClass", "click"], ["title", "Tracking Overview", 1, "map-toolbox-button", "map-toolbox-button-overview", 3, "ngClass", "click"], ["title", "Route View", 1, "map-toolbox-button", 3, "ngClass", "click"], ["title", "Waze Traffic", 1, "map-toolbox-button", "map-toolbox-button-waze", 3, "ngClass", "click"], [1, "select-container"], ["select_signals", ""], [1, "select-form"], [1, "select-label"], [1, "form-control", "select-map", 3, "change"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["id", "select_gps", 1, "form-control", "select-map", 2, "width", "175px!important", 3, "change"], [3, "ngValue", "ngStyle", 4, "ngFor", "ngForOf"], [1, "form-control", "select-map", 2, "width", "200px!important", 3, "mouseleave"], [1, "drop-toggle", "btn", "flat", 2, "background-color", "transparent!important", 3, "click"], [4, "ngIf"], ["style", "font-size: 10px !important;position:relative;top:-10px!important;left:-15px!important;", 4, "ngIf"], [1, "fa", "fa-angle-down"], ["class", "drop-show", 4, "ngIf"], [3, "mapReady"], [3, "background_color", "display"], [3, "ngValue"], [3, "ngValue", "ngStyle"], [2, "font-size", "10px !important", "position", "relative", "top", "-10px!important", "left", "-15px!important"], [1, "drop-show"], ["style", " background-color: white; width:200px!important;", 4, "ngFor", "ngForOf"], [2, "background-color", "white", "width", "200px!important"], ["type", "checkbox", 3, "ngModel", "ngModelChange", "change"]], template: function TrackGoogleMapComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1, 2);
        ɵngcc0.ɵɵelementStart(3, "a", 3);
        ɵngcc0.ɵɵlistener("click", function TrackGoogleMapComponent_Template_a_click_3_listener() { return ctx.map_action("track"); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "a", 4);
        ɵngcc0.ɵɵlistener("click", function TrackGoogleMapComponent_Template_a_click_4_listener() { return ctx.map_action("center"); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "a", 5);
        ɵngcc0.ɵɵlistener("click", function TrackGoogleMapComponent_Template_a_click_5_listener() { return ctx.map_action("overview"); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "a", 6);
        ɵngcc0.ɵɵlistener("click", function TrackGoogleMapComponent_Template_a_click_6_listener() { return ctx.map_action("route"); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "a", 7);
        ɵngcc0.ɵɵlistener("click", function TrackGoogleMapComponent_Template_a_click_7_listener() { return ctx.map_action("traffic"); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 8, 9);
        ɵngcc0.ɵɵelementStart(10, "div", 10);
        ɵngcc0.ɵɵelementStart(11, "label", 11);
        ɵngcc0.ɵɵtext(12, "Placa");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "select", 12);
        ɵngcc0.ɵɵlistener("change", function TrackGoogleMapComponent_Template_select_change_13_listener($event) { return ctx.onPlacaChange($event.target.value); });
        ɵngcc0.ɵɵtemplate(14, TrackGoogleMapComponent_option_14_Template, 2, 2, "option", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 10);
        ɵngcc0.ɵɵelementStart(16, "label", 11);
        ɵngcc0.ɵɵtext(17, "GPS");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "select", 14);
        ɵngcc0.ɵɵlistener("change", function TrackGoogleMapComponent_Template_select_change_18_listener($event) { return ctx.onGPSChange($event.target.value); });
        ɵngcc0.ɵɵtemplate(19, TrackGoogleMapComponent_option_19_Template, 2, 5, "option", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 10);
        ɵngcc0.ɵɵelementStart(21, "label", 11);
        ɵngcc0.ɵɵtext(22, "Zonas");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "div", 16);
        ɵngcc0.ɵɵlistener("mouseleave", function TrackGoogleMapComponent_Template_div_mouseleave_23_listener() { return ctx.showDropDown = false; });
        ɵngcc0.ɵɵelementStart(24, "button", 17);
        ɵngcc0.ɵɵlistener("click", function TrackGoogleMapComponent_Template_button_click_24_listener() { return ctx.showDropDown = !ctx.showDropDown; });
        ɵngcc0.ɵɵtemplate(25, TrackGoogleMapComponent_span_25_Template, 2, 0, "span", 18);
        ɵngcc0.ɵɵtemplate(26, TrackGoogleMapComponent_span_26_Template, 2, 1, "span", 19);
        ɵngcc0.ɵɵelement(27, "i", 20);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(28, TrackGoogleMapComponent_div_28_Template, 2, 1, "div", 21);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "agm-map", 22);
        ɵngcc0.ɵɵlistener("mapReady", function TrackGoogleMapComponent_Template_agm_map_mapReady_29_listener($event) { return ctx.onMapReady($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(30, "com-lib-track-loading", 23);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(12, _c4, ctx._track, ctx.slider));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(15, _c4, ctx._center, ctx.slider));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(18, _c5, ctx._overview));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(20, _c6, ctx._showRoute, ctx._showRoute, !ctx._showRoute));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(24, _c4, ctx._showTraffic, ctx.slider));
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.gps_signal_num_plates);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.gps_signal_gps_ids);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tiposZonasElegidas.length <= 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tiposZonasElegidas.length > 0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showDropDown);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("display", ctx.display_loading);
        ɵngcc0.ɵɵproperty("background_color", "rgba(0,0,0,0.8)");
    } }, directives: [ɵngcc5.NgClass, ɵngcc5.NgForOf, ɵngcc5.NgIf, ɵngcc1.AgmMap, TrackLoadingComponent, ɵngcc9.NgSelectOption, ɵngcc9.ɵangular_packages_forms_forms_z, ɵngcc5.NgStyle, ɵngcc9.CheckboxControlValueAccessor, ɵngcc9.NgControlStatus, ɵngcc9.NgModel], styles: ["agm-map[_ngcontent-%COMP%]{height:100%;width:100%}@keyframes fade{0%{opacity:.1;transform:scale(.5) translate(24px,24px)}25%{opacity:.3;transform:scale(.6) translate(16px,16px)}50%{opacity:.5;transform:scale(.8) translate(6px,6px)}75%{opacity:.3;transform:scale(.9) translate(3px,3px)}to{opacity:.1;transform:scale(1.2) translate(-4px,-4px)}}  .blinking{animation:fade 1s ease-out infinite}.select-container[_ngcontent-%COMP%], .select-form[_ngcontent-%COMP%]{display:flex}.select-label[_ngcontent-%COMP%]{margin:14px 0 0 11px;background:#c0bfbf;line-height:17px;height:-moz-fit-content;height:fit-content;padding:5px 7px;color:#fff;font-weight:700;border-top-left-radius:9px;border-bottom-left-radius:9px}.select-map[_ngcontent-%COMP%]{height:40px!important;width:88px;padding:2px 0 4px 9px;margin:10px 0 0;border:none;border-radius:0}.map-toolbox[_ngcontent-%COMP%], .select-map[_ngcontent-%COMP%]{background:#fff;box-shadow:0 1px 4px -1px rgba(0,0,0,.3)}.map-toolbox[_ngcontent-%COMP%]{border-radius:1px;display:flex;flex-direction:column;margin:10px;width:40px}.map-toolbox-button[_ngcontent-%COMP%]{width:30px;height:30px;margin:5px;background-size:20px 20px!important;border:2px solid #cecece!important;background-color:#e9e9e9!important;border-radius:8px;pointer-events:auto}.map-toolbox-button-hidden[_ngcontent-%COMP%]{display:none}.map-toolbox-button-active[_ngcontent-%COMP%]{border:2px solid #00dbff!important}.map-toolbox-button[_ngcontent-%COMP%]:hover{margin:6px;border:1px solid #fff;width:28px;height:28px}.map-toolbox-button[_ngcontent-%COMP%]:active{margin:6px;border:1px solid #ff002f!important;background-color:#900000!important;filter:invert(1);width:28px;height:28px}.map-toolbox-button-track[_ngcontent-%COMP%]{background:url(/assets/trips/map-realtime/toolbox/track.svg) no-repeat 50%;background-size:16px 16px!important}.map-toolbox-button-center[_ngcontent-%COMP%]{background:url(/assets/trips/map-realtime/toolbox/center.svg) no-repeat 50%}.map-toolbox-button-overview[_ngcontent-%COMP%]{background:url(/assets/trips/map-realtime/toolbox/overview.svg) no-repeat 50%}.map-toolbox-button-route[_ngcontent-%COMP%]{background:url(/assets/trips/map-realtime/toolbox/route.svg) no-repeat 50%}.map-toolbox-button-route-dots[_ngcontent-%COMP%]{background:url(/assets/trips/map-realtime/toolbox/route_dots.svg) no-repeat 50%}.map-toolbox-button-waze[_ngcontent-%COMP%]{background:url(/assets/trips/map-realtime/toolbox/waze.svg) no-repeat 50%}.slider[_ngcontent-%COMP%]{-webkit-appearance:none;width:100%;height:15px;border-radius:5px;background:#d3d3d3;outline:none;opacity:.7;transition:opacity .2s;bottom:24px!important}.slider[_ngcontent-%COMP%]::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:25px;height:25px;border-radius:50%;background:#2193f0;cursor:pointer}.slider[_ngcontent-%COMP%]::-moz-range-thumb{width:25px;height:25px;border-radius:50%;background:#1b22e4;cursor:pointer}"] });
TrackGoogleMapComponent.ctorParameters = () => [
    { type: TripsService },
    { type: ZonesService },
    { type: NgbModal },
    { type: ServicioZonasService }
];
TrackGoogleMapComponent.propDecorators = {
    map_tools: [{ type: ViewChild, args: ["map_tools", { read: ElementRef, static: true },] }],
    select_signals: [{ type: ViewChild, args: ["select_signals", { read: ElementRef, static: true },] }],
    time_signals: [{ type: ViewChild, args: ["time_signals", { read: ElementRef, static: true },] }],
    trip_id: [{ type: Input }],
    event_id: [{ type: Input }],
    trip: [{ type: Input }],
    account_id: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TrackGoogleMapComponent, [{
        type: Component,
        args: [{
                selector: "com-lib-track-google-map",
                template: "<!--\n<ng-template #content let-modal>\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\"\n            id=\"modal-basic-title\">\n            Seleccione los GPS del viaje {{viajesJSON.Viaje}} cuyas posiciones se mostraran\n        </h4>\n        <button type=\"button\" class=\"close\"\n                aria-label=\"Close\" (click)=\"modal.dismiss('Cross click')\">\n            <span aria-hidden=\"true\">\n                \u00D7\n            </span>\n        </button>\n    </div>\n    <div class=\"modal-body\">\n        <div *ngFor=\"let patente of viajesJSON.Patentes;let indice=index\" >\n            <div>\n                <h1 style=\"text-align: center;\" >-{{patente.Patente}}-</h1>\n                <table>\n                    <tr>\n                        <td *ngFor=\"let gps of patente.DispositivosGPS;let indice2=index\">\n                            <div style=\"display: none;\" >\n                                {{cambiarColor(gps,coloresHexadecimales.colores[(indice*2)+indice2])}}\n                            </div>\n                            <button id=\"{{gps}}boton\" type=\"button\" class=\"btn\"\n                            [ngClass]=\"listaDispositivosGPS[gps] ? 'btn-danger' : 'btn-primary'\"\n                            (click)=\"SeleccionarGPS(gps)\" >\n                                {{gps}}\n                            </button>\n                            &nbsp;\n                        </td>\n                    </tr>\n                </table>\n\n            </div>\n        </div>\n    </div>\n</ng-template>\n\n<button class=\"btn btn-lg btn-outline-primary\" (click)=\"open(content)\">\n    Elegir GPS\n</button>\n\n<span *ngFor=\"let patente of viajesJSON.Patentes;let indice=index\" >\n    {{patente.Patente}}:\n    <span *ngFor=\"let gps of patente.DispositivosGPS;let indice2=index\">\n        <span *ngIf=\"listaDispositivosGPS[gps]\" class=\"badge\"\n        [ngStyle]=\"{'background-color': coloresHexadecimales.colores[(indice*2)+indice2]}\" >\n            {{gps}}\n        </span>\n    </span>\n</span>\n-->\n<!--\n<button class=\"btn btn-lg btn-outline-primary\" (click)=\"probarUsoDiccionario()\">\n    probarUsoDiccionario\n</button>\n<button class=\"btn btn-lg btn-outline-primary\" (click)=\"FuncionMZ()\">\n    detonar algo\n</button>\n<button class=\"btn btn-lg btn-outline-primary\" >\n    prueba cambio\n</button>\n-->\n\n<div style=\"display: none;\">\n  <div class=\"map-toolbox\" #map_tools>\n      <a title=\"Real Time Track\" class=\"map-toolbox-button map-toolbox-button-track\" (click)=\"map_action('track')\" [ngClass]=\"{'map-toolbox-button-active': _track,'map-toolbox-button-hidden':slider}\"></a>\n      <a title=\"Center On Track\" class=\"map-toolbox-button map-toolbox-button-center\" (click)=\"map_action('center')\"\n          [ngClass]=\"{'map-toolbox-button-active': _center,\n                  'map-toolbox-button-hidden':slider}\"></a>\n      <a title=\"Tracking Overview\" class=\"map-toolbox-button map-toolbox-button-overview\"\n          (click)=\"map_action('overview')\" [ngClass]=\"{'map-toolbox-button-active': _overview}\"></a>\n      <a title=\"Route View\" class=\"map-toolbox-button \" (click)=\"map_action('route')\" [ngClass]=\"{'map-toolbox-button-active': _showRoute,\n                  'map-toolbox-button-route': _showRoute,\n                  'map-toolbox-button-route-dots': !_showRoute\n                  }\"></a>\n      <a title=\"Waze Traffic\" class=\"map-toolbox-button  map-toolbox-button-waze\" (click)=\"map_action('traffic')\"\n          [ngClass]=\"{'map-toolbox-button-active': _showTraffic,\n                  'map-toolbox-button-hidden':slider}\"></a>\n  </div>\n  <div class=\"select-container\" #select_signals>\n      <div class=\"select-form\">\n          <label class=\"select-label\">Placa</label>\n          <!--(ngModelChange)=\"onSignalChange($event)\"-->\n          <select class=\"form-control select-map\"\n          (change)=\"onPlacaChange($event.target.value)\">\n              <option *ngFor=\"let signal of gps_signal_num_plates\" [ngValue]=\"signal.id\">{{ signal.id }}</option>\n          </select>\n      </div>\n      <div class=\"select-form\">\n          <label class=\"select-label\">GPS</label>\n          <select id=\"select_gps\" class=\"form-control select-map\"\n          (change)=\"onGPSChange($event.target.value)\"\n          style=\"width: 175px!important;\"\n          >\n              <option *ngFor=\"let gps of gps_signal_gps_ids; let i = index\" [ngValue]=\"gps.gps_id\" [ngStyle]=\"{'background-color':coloresHexadecimales.colores[i]}\"\n              >\n                  {{ gps.gps_id }}\n              </option>\n          </select>\n      </div>\n      <div class=\"select-form\">\n          <label class=\"select-label\">Zonas</label>\n          <div class=\"form-control select-map\" style=\"width: 200px!important;\" (mouseleave)=\"showDropDown = false\">\n              <button class=\"drop-toggle btn flat\" style=\"background-color:transparent!important;\" (click)=\"showDropDown=!showDropDown\"><!-- -->\n                  <span *ngIf=\"tiposZonasElegidas.length<=0\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><!--Selecciona Zonas-->\n                  <span style=\"font-size: 10px !important;position:relative;top:-10px!important;left:-15px!important;\" *ngIf=\"tiposZonasElegidas.length>0\">\n                      {{MostrarZonasElegidas()}}\n                  </span>\n                  <i class=\"fa fa-angle-down\"></i>\n              </button>\n              <div class=\"drop-show\" *ngIf=\"showDropDown\"><!-- form-control select-map -->\n                  <div *ngFor=\"let a of list; let i = index\"  style=\" background-color: white; width:200px!important;\" >\n                      <div *ngIf=\"a.name!='Cliente'\">\n                          <input type=\"checkbox\" [(ngModel)]=\"a.checked\" (change)=\"getSelectedValue(a)\" />&nbsp;{{a.name}}<!--<span><b style=\"text-align:center;\" >&nbsp;{{a.name}}&nbsp;</b></span>-->\n                      </div>\n                  </div>\n              </div>\n          </div>\n      </div>\n  </div>\n</div>\n<agm-map (mapReady)=\"onMapReady($event)\">\n</agm-map>\n<com-lib-track-loading [background_color]=\"'rgba(0,0,0,0.8)'\" display=\"{{display_loading}}\"></com-lib-track-loading>\n",
                styles: ["agm-map{height:100%;width:100%}@keyframes fade{0%{opacity:.1;transform:scale(.5) translate(24px,24px)}25%{opacity:.3;transform:scale(.6) translate(16px,16px)}50%{opacity:.5;transform:scale(.8) translate(6px,6px)}75%{opacity:.3;transform:scale(.9) translate(3px,3px)}to{opacity:.1;transform:scale(1.2) translate(-4px,-4px)}}::ng-deep .blinking{animation:fade 1s ease-out infinite}.select-container,.select-form{display:flex}.select-label{margin:14px 0 0 11px;background:#c0bfbf;line-height:17px;height:-moz-fit-content;height:fit-content;padding:5px 7px;color:#fff;font-weight:700;border-top-left-radius:9px;border-bottom-left-radius:9px}.select-map{height:40px!important;width:88px;padding:2px 0 4px 9px;margin:10px 0 0;border:none;border-radius:0}.map-toolbox,.select-map{background:#fff;box-shadow:0 1px 4px -1px rgba(0,0,0,.3)}.map-toolbox{border-radius:1px;display:flex;flex-direction:column;margin:10px;width:40px}.map-toolbox-button{width:30px;height:30px;margin:5px;background-size:20px 20px!important;border:2px solid #cecece!important;background-color:#e9e9e9!important;border-radius:8px;pointer-events:auto}.map-toolbox-button-hidden{display:none}.map-toolbox-button-active{border:2px solid #00dbff!important}.map-toolbox-button:hover{margin:6px;border:1px solid #fff;width:28px;height:28px}.map-toolbox-button:active{margin:6px;border:1px solid #ff002f!important;background-color:#900000!important;filter:invert(1);width:28px;height:28px}.map-toolbox-button-track{background:url(/assets/trips/map-realtime/toolbox/track.svg) no-repeat 50%;background-size:16px 16px!important}.map-toolbox-button-center{background:url(/assets/trips/map-realtime/toolbox/center.svg) no-repeat 50%}.map-toolbox-button-overview{background:url(/assets/trips/map-realtime/toolbox/overview.svg) no-repeat 50%}.map-toolbox-button-route{background:url(/assets/trips/map-realtime/toolbox/route.svg) no-repeat 50%}.map-toolbox-button-route-dots{background:url(/assets/trips/map-realtime/toolbox/route_dots.svg) no-repeat 50%}.map-toolbox-button-waze{background:url(/assets/trips/map-realtime/toolbox/waze.svg) no-repeat 50%}.slider{-webkit-appearance:none;width:100%;height:15px;border-radius:5px;background:#d3d3d3;outline:none;opacity:.7;transition:opacity .2s;bottom:24px!important}.slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:25px;height:25px;border-radius:50%;background:#2193f0;cursor:pointer}.slider::-moz-range-thumb{width:25px;height:25px;border-radius:50%;background:#1b22e4;cursor:pointer}"]
            }]
    }], function () { return [{ type: TripsService }, { type: ZonesService }, { type: ɵngcc12.NgbModal }, { type: ServicioZonasService }]; }, { trip_id: [{
            type: Input
        }], event_id: [{
            type: Input
        }], trip: [{
            type: Input
        }], account_id: [{
            type: Input
        }], map_tools: [{
            type: ViewChild,
            args: ["map_tools", { read: ElementRef, static: true }]
        }], select_signals: [{
            type: ViewChild,
            args: ["select_signals", { read: ElementRef, static: true }]
        }], time_signals: [{
            type: ViewChild,
            args: ["time_signals", { read: ElementRef, static: true }]
        }] }); })();

//import { google } from '@agm/core/services/google-maps-types';
class MapaInternoComponent {
    //closeResult = ''; 
    constructor() { }
    //constructor(private modalService: NgbModal) {} 
    /*
      open(content) {
        this.modalService.open(content,
       {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
      }
    
      private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
        } else {
          return `with: ${reason}`;
        }
      }
    */
    ngOnInit() {
        alert("hola desde el mapa interno");
        this.loadScript();
    }
    loadScript() {
        console.log('preparing to load...');
        /*
        let node = document.createElement('script');
        //node.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBjy5Jpr1oSmOFSMaAeTSI2w6KZBMYEokg&callback=initialize";//url;
        node.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBjy5Jpr1oSmOFSMaAeTSI2w6KZBMYEokg";//url;
        node.type = 'text/javascript';
        node.async = true;
        node.charset = 'utf-8';
        document.getElementsByTagName('head')[0].appendChild(node);
        */
        //setTimeout(() => {
        this.initialize();
        //}, 2000);
    }
    initialize() {
        alert("inicializando");
        var latitud = -33.5298291; //this.getParameterByName('latitud',"");
        var longitud = -70.7060026; //this.getParameterByName('longitud',"");
        this.panorama = new google.maps.StreetViewPanorama(document.getElementById('street-view'), {
            position: {
                lat: latitud,
                lng: longitud //parseFloat(longitud)
            },
            pov: { heading: 165, pitch: 0 },
            zoom: 1
        });
        //this.open(this.content);
        alert("deberia haber cambiado el panorama");
    }
}
MapaInternoComponent.ɵfac = function MapaInternoComponent_Factory(t) { return new (t || MapaInternoComponent)(); };
MapaInternoComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MapaInternoComponent, selectors: [["com-lib-mapa-interno"]], decls: 3, vars: 0, consts: [["id", "street-view"]], template: function MapaInternoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, "mapa-interno works!");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(2, "div", 0);
    } }, styles: ["", "html[_ngcontent-%COMP%], body[_ngcontent-%COMP%] {\n        height: 100%;\n        margin: 0;\n        padding: 0;\n    }\n\n    #street-view[_ngcontent-%COMP%] {\n        height: 100%;\n    }"] });
MapaInternoComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MapaInternoComponent, [{
        type: Component,
        args: [{
                selector: 'com-lib-mapa-interno',
                template: "<p>mapa-interno works!</p>\n<style>\n    html, body {\n        height: 100%;\n        margin: 0;\n        padding: 0;\n    }\n\n    #street-view {\n        height: 100%;\n    }\n</style>\n<!--AQUI ESTABA EL STREET VIEW\n\n-->\n<div id=\"street-view\"></div>\n<!--\n<button class=\"btn btn-lg btn-outline-primary\" \n    (click)=\"open(content)\"> \n    Popup using Angular and Bootstrap \n</button> \n<ng-template #content let-modal> \n    <div class=\"modal-header\"> \n        <h4 class=\"modal-title\" \n            id=\"modal-basic-title\"> \n            PANORAMA\n        </h4> \n        <button type=\"button\" class=\"close\"\n                aria-label=\"Close\" (click)= \n                \"modal.dismiss('Cross click')\">\n            <span aria-hidden=\"true\"> \n                \u00D7 \n            </span> \n        </button> \n    </div> \n    <div class=\"modal-body\"> \n        AQUI DEBO PONER STREET VIEW        \n        <div id=\"street-view\"></div>\n    </div> \n    <div class=\"modal-footer\"> \n        <button type=\"button\" \n            class=\"btn btn-outline-dark\" \n            (click)=\"modal.close('Save click')\"> \n            Save \n        </button> \n    </div> \n</ng-template> \n-->",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
/*

    var panorama;

    function initialize() {
        var latitud = getParameterByName('latitud');
        var longitud = getParameterByName('longitud');
        
        panorama = new google.maps.StreetViewPanorama(
            document.getElementById('street-view'),
            {
                position: {
                    lat: parseFloat(latitud),
                    lng: parseFloat(longitud)
                },
                pov: { heading: 165, pitch: 0 },
                zoom: 1
            });
    }
    
    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

*/

class IframeMapaComponent {
    constructor() { }
    ngOnInit() {
    }
}
IframeMapaComponent.ɵfac = function IframeMapaComponent_Factory(t) { return new (t || IframeMapaComponent)(); };
IframeMapaComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: IframeMapaComponent, selectors: [["com-lib-iframe-mapa"]], decls: 3, vars: 0, template: function IframeMapaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, "iframe-mapa works!");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(2, "com-lib-mapa-interno");
    } }, directives: [MapaInternoComponent], styles: [""] });
IframeMapaComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IframeMapaComponent, [{
        type: Component,
        args: [{
                selector: 'com-lib-iframe-mapa',
                template: "<p>iframe-mapa works!</p>\n<com-lib-mapa-interno></com-lib-mapa-interno>",
                styles: [""]
            }]
    }], function () { return []; }, null); })();

class CommonsLibModule {
}
CommonsLibModule.ɵfac = function CommonsLibModule_Factory(t) { return new (t || CommonsLibModule)(); };
CommonsLibModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CommonsLibModule });
CommonsLibModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            AgmOverlays,
            //  BrowserModule,
            CommonModule,
            CommonsLibRoutingModule,
            FormsModule,
            NgSelectModule,
            NgbModule,
            TranslateModule,
            AgmCoreModule,
            EventStreamLibModule,
            MultiSelectModule,
            TableModule,
            CalendarModule,
            SliderModule,
            DialogModule,
            ContextMenuModule,
            DropdownModule,
            ButtonModule,
            ToastModule,
            InputTextModule,
            ProgressBarModule,
            // BrowserAnimationsModule,
            NgxDaterangepickerMd
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CommonsLibModule, { declarations: function () { return [TrackLoadingComponent, MapRealtimeComponent, FileUploaderComponent, DialogComponent, MessageBarComponent, MessageErrorComponent, TrackGoogleMapComponent, BaseGoogleMapComponent, TableConfigurableComponent, MapaInternoComponent, IframeMapaComponent]; }, imports: function () { return [AgmOverlays,
        //  BrowserModule,
        CommonModule, CommonsLibRoutingModule, FormsModule,
        NgSelectModule,
        NgbModule,
        TranslateModule,
        AgmCoreModule,
        EventStreamLibModule,
        MultiSelectModule,
        TableModule,
        CalendarModule,
        SliderModule,
        DialogModule,
        ContextMenuModule,
        DropdownModule,
        ButtonModule,
        ToastModule,
        InputTextModule,
        ProgressBarModule,
        // BrowserAnimationsModule,
        NgxDaterangepickerMd]; }, exports: function () { return [TrackLoadingComponent, MapRealtimeComponent, FileUploaderComponent, DialogComponent, MessageBarComponent, MessageErrorComponent, TrackGoogleMapComponent, BaseGoogleMapComponent, TableConfigurableComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CommonsLibModule, [{
        type: NgModule,
        args: [{
                declarations: [TrackLoadingComponent, MapRealtimeComponent, FileUploaderComponent, DialogComponent, MessageBarComponent, MessageErrorComponent, TrackGoogleMapComponent, BaseGoogleMapComponent, TableConfigurableComponent, MapaInternoComponent, IframeMapaComponent],
                imports: [
                    AgmOverlays,
                    //  BrowserModule,
                    CommonModule,
                    CommonsLibRoutingModule,
                    FormsModule,
                    NgSelectModule,
                    NgbModule,
                    TranslateModule,
                    AgmCoreModule,
                    EventStreamLibModule,
                    MultiSelectModule,
                    TableModule,
                    CalendarModule,
                    SliderModule,
                    DialogModule,
                    ContextMenuModule,
                    DropdownModule,
                    ButtonModule,
                    ToastModule,
                    InputTextModule,
                    ProgressBarModule,
                    // BrowserAnimationsModule,
                    NgxDaterangepickerMd
                ],
                exports: [TrackLoadingComponent, MapRealtimeComponent, FileUploaderComponent, DialogComponent, MessageBarComponent, MessageErrorComponent, TrackGoogleMapComponent, BaseGoogleMapComponent, TableConfigurableComponent],
                entryComponents: [MessageErrorComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of ng-alto-commons-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BaseGoogleMapComponent, CommonsLibModule, DialogComponent, FileUploaderComponent, FileUploaderEvent, MapRealtimeComponent, MessageBarComponent, MessageBarService, MessageErrorComponent, TableConfigurableComponent, TrackGoogleMapComponent, TrackLoadingComponent, ServiceFile as ɵa, ZonesService as ɵb, TripsService as ɵc, ManejoZonas as ɵd, ManejoFiltradoSenalesGps as ɵe, ServicioZonasService as ɵf, MapaInternoComponent as ɵg, IframeMapaComponent as ɵh, CommonsLibRoutingModule as ɵi };

//# sourceMappingURL=ng-alto-commons-lib.js.map